var App = App || {};

const ONLY_JS_RENDERING = true;

App.components_queue = {
	is_enabled: false,
	queue: new Set(),
	add: function(el) {
		this.queue.add(el);
	},
	render: function() {
		this.queue.forEach((el) => {
			el._render();
		});
		this.queue.clear();
	},
};

/**
 * @type {ComponentsApi & Record<string, AppComponent>}
 */
App.components = {

	get_object_list: function(component, object_type) {
		return component[`list_by_${object_type}`] ?? component.list_by_object;
	},

	get_object_ref: function(el) {

		if (el.dataset.task) return { id: parseInt(el.dataset.task), type: 'task' };
		if (el.dataset.project) return { id: parseInt(el.dataset.project), type: 'project' };
		if (el.dataset.user) return { id: parseInt(el.dataset.user), type: 'user' };
		if (el.dataset.tagsGroup) return { id: parseInt(el.dataset.tagsGroup), type: 'tags_group' };

		return null;
	},

	register_in: function(component, draw) { // this = el
		if (!this.dataset.format) return;
		if (!this.tpl_format) {
			this.tpl_format = this.dataset.format;
			this.tpl_filter = 'filter' in this.dataset ? this.dataset.filter : 'none';
			this.tpl_field = 'field' in this.dataset ? this.dataset.field : 'none';
			const child = this.children[0];
			if (child && child.nodeName === 'SCRIPT' && child.type === 'application/json') {
				this.tpl_data = JSON.parse(child.textContent) || {};
			} else {
				this.tpl_data = JSON.parse(this.dataset.data) || {};
			}

			const obj_ref = App.components.get_object_ref(this);
			if (obj_ref) {
				const list = App.components.get_object_list(component, obj_ref.type);

				if (!list[obj_ref.id]) list[obj_ref.id] = [];
				list[obj_ref.id].push(this);
			}

			delete this.dataset.data;
			delete this.dataset.format;
		}
		component.list_all.push(this);
		if (draw) component.redraw(this);
	},

	unregister_in: function(component) { // this = el

		const obj_ref = App.components.get_object_ref(this);
		if (obj_ref) {
			const list = App.components.get_object_list(component, obj_ref.type);

			if (list[obj_ref.id]) list[obj_ref.id] = list[obj_ref.id].filter((el) => el !== this);
			if (list[obj_ref.id] && list[obj_ref.id].length === 0) list[obj_ref.id] = undefined;
		}

		component.list_all = component.list_all.filter((el) => el !== this);
	},

	compact: function(el) {
		let data = el.dataset;
		data.filter = el.tpl_filter;
		data.format = el.tpl_format;
		let data_str = '';
		for (let i in data) data_str += ' data-' + i + '="' + App.helper.html.encode(data[i]) + '"';
		return '<'+el.tagName + data_str + '><script type="application/json">' + JSON.stringify(el.tpl_data) + '</script></'+el.tagName+'>';
	},

	expand: function(tagName, data = {}, tpl_data = {}) {
		let attrs = '';

		// dataset
		for (let i in data) {
			if (data[i] == null) continue;
			attrs += ' data-' + i + '="' + App.helper.html.encode(data[i]) + '"';
		}

		return `<${tagName}${attrs}>
			<script type="application/json">${JSON.stringify(tpl_data)}</script>
		</${tagName}>`;
	},

	update: function (component, id, data) {

		component.list_by_object[id]?.forEach((el) => {

			// no.. redraw only if data changed
			// Object.assign(el.tpl_data, data);
			// component.redraw(el);

			let changed = false;

			for (let key in data) {
				if (el.tpl_data[key] !== data[key]) {
					el.tpl_data[key] = data[key];
					changed = true;
				}
			}

			if (changed) {
				component.redraw(el);
			}
		});

		App.components.emit_update(component, id, data);
	},

	emit_update: function (component, id, data) {
		App.bus.app.emit('component.'+component.tag_name, { id, data });
	},

	on_update: function (component, handler) {
		App.bus.app.on('component.'+component.tag_name, handler);
	},

	emit_redraw: function (el) {
		el.dispatchEvent(new CustomEvent('component:redraw'));
	},

	helper_need_update: function (html1, html2) {
		html1 = html1.replace(/(<ws-icon[^>]*>).*?<\/ws-icon>/gs, '$1');
		html2 = html2.replace(/(<ws-icon[^>]*>).*?<\/ws-icon>/gs, '$1');
		return html1 !== html2;
	},

};

$.fn.destroyComponents = function () {
	for (let i in App.components) {
		if ('destructor' in App.components[i]) {
			this
				.find(App.components[i].tag_name)
				.addBack(App.components[i].tag_name)
				.each(function() {
					if (this._in_cache) return; // #8323972/#com20810579
					App.components[i].destructor.call(this, App.components[i])
				});
		}
	}
	if (this.data('observer')) this.data('observer').unobserve(this.get(0));
	return this;
};

$.fn.removeWithComponents = function () {
	return this.destroyComponents().remove();
};

$.fn.cloneWithComponents = function () {
	for (let i in App.components) {
		this.find(App.components[i].tag_name).each(function() {
			$(this).attr('data-format', this.tpl_format);
			$(this).attr('data-data', JSON.stringify(this.tpl_data));
		});
	}
	let o = this.clone();
	for (let i in App.components) {
		this.find(App.components[i].tag_name).each(function() {
			$(this).removeAttr('data-format').removeAttr('data-data');
		});
	}
	return o;
};
$.fn.htmlWithComponents = function () {
	for (let i in App.components) {
		this.find(App.components[i].tag_name).each(function() {
			$(this).attr('data-format', this.tpl_format);
			$(this).attr('data-data', JSON.stringify(this.tpl_data));
		});
	}
	let o = this.clone();
	let html = o.outerHTML;
	for (let i in App.components) {
		this.find(App.components[i].tag_name).each(function() {
			$(this).removeAttr('data-format').removeAttr('data-data');
		});
	}
	o.remove();
	return html;
};

$.fn.findWithComponentsAndSetInCache = function () {
	for (let i in App.components) {
		this
			.find(App.components[i].tag_name)
			.addBack(App.components[i].tag_name)
			.each(function() {
				this._in_cache = true;
			});
	}
};

$.fn.findWithComponentsAndRemoveInCache = function () {
	for (let i in App.components) {
		this
			.find(App.components[i].tag_name)
			.addBack(App.components[i].tag_name)
			.each(function() {
				delete this._in_cache;
			});
	}
};

/**
 * @typedef {{onBoot?: () => void} & Record<string, any>} AppComponent
 * */
/**
 * @typedef {{
 * get_object_list: (function(*, *): *),
 * get_object_ref: ((function(*): ({id: number, type: string}|null))|*),
 * register_in: App.components.register_in,
 * unregister_in: App.components.unregister_in,
 * compact: (function(*): string),
 * expand: (function(*, {}=, {}=): string),
 * update: App.components.update,
 * emit_update: App.components.emit_update,
 * on_update: App.components.on_update,
 * emit_redraw: App.components.emit_redraw,
 * helper_need_update: (function(*, *): boolean)
 * }} ComponentsApi
 */
;class FileIcon extends RenderableComponent {
	static get observedAttributes() {
		return ['value'];
	}

	templateContext() {
		return {
			value: this.prop('value'),
			label: String(this.prop('value')).toUpperCase(),
		}
	}

	template() {
		// language=HTML
		return `
		<self >
			<div class="ext m" ws-class="['ext_'+value]">
				<u></u>
				<i ws-text="label"></i>
			</div> 
		</self>
		`
	}
}

App.components.file_icon = {
	onBoot() {
		customElements.define('file-icon', FileIcon);
	}
}
;class FormField extends RenderableComponent {

	static get observedAttributes() {
		return ['bindings', 'event', 'read', 'write'];
	}

	/**
	 * @returns {LifecycleLayer}
	 */
	static defineLifecycle() {
		/**
		 * @this {FormField}
		 */
		return function ({on, once}) {
			on('constructed', () => {
				this._eventUnbinders = [];
			});
			on('connected', () => {
				this._bindFormEvents();
				this.form;
			});
			once('mount:after', () => {
				this._bindFormEvents();
			});
			on('update:after', () => {
				this._bindFormEvents();
			});
			on('unmount', () => {
				this._unbindFormEvents();
			});

		};
	}


	_getBindings() {
		const bindingsAttr = this.attr('bindings');

		if (bindingsAttr) {
			return bindingsAttr
				.split(',')
				.map(s => s.trim())
				.filter(Boolean)
				.map(entry => {
					const parts = entry.split('|').map(s => s.trim());
					return {
						event: parts[0] || 'change',
						read: parts[1] || 'target.value',
						write: parts[2] || null,
					};
				});
		}

		return [{
			event: this.attr('event', 'change'),
			read: this.attr('read', 'target.value'),
			write: this.attr('write', null),
		}];
	}

	_bindFormEvents() {
		this._unbindFormEvents();

		for (const binding of this._getBindings()) {
			const {event, read, write} = binding;

			const debouncedHandler = App.helper.debounce((e) => {
				this._handleEvent(e, {read, write});
			}, 200);

			const {unbind} = this.addEventListenerWs(event, (e) => {
				if (e.target === this) return;
				debouncedHandler(e)
			});
			this._eventUnbinders.push(unbind);
		}
	}

	_unbindFormEvents() {
		for (const unbind of this._eventUnbinders) {
			try {
				unbind();
			} catch (error) {
				console.error('Error unbinding event listener:', error);
			}
		}
		this._eventUnbinders = [];
	}

	_handleEvent(e, {read, write}) {
		const value = App.helper.object.readByPath(e, read);

		if (write) {
			this.form.setValue(write, value);
		}

		this.emitEvent('change', {value, write});
	}

	get form() {
		return this._form || (this._form = this.useProvided('form'));
	}

	template() {
		// language=HTML
		return `
			<self class="form-field display_contents">
				<slot></slot>
			</self>
		`;
	}
}

App.components.form_field = {
	onBoot() {
		customElements.define('form-field', FormField);
	}
};
;/** <project-last-activity> component **/
App.components.last_activity = {

	tag_name: 'last-activity',
	list_by_project: {},
	list_by_task: {},
	list_by_user: {},
	list_all: [],

	template: function(params, format) {
		params.dateact = parseInt(params.dateact);

		if (params.dateact > 0) {
			params.diff = Math.max(90, App.helper.time.account() - params.dateact);

			if (params.diff < 3600) params.hot = 1;
			else if (params.diff < 5 * 86400) params.warm = 1;

			if (params.dateact > App.helper.customDate.get('today')) params.today = 1;
			else if (params.dateact > App.helper.customDate.get('yesterday')) params.yesterday = 1;
			else if (params.dateact > App.helper.customDate.get('today') - 6 * 86400) params.recently = 1;
			else if (params.dateact > App.helper.customDate.get('year_start') - 365 * 86400) params.sometimeago = 1;
		}

		let template = App.helper.template.get_cached('last_activity', format);
		template = template.trim().replace(/\s+/g, ' ');
		if (!template) return '';

		return App.helper.template.fill(template, params);
	},

	redraw: function(el, data) {
		if (data) el.tpl_data = data;
		let new_html = this.template(el.tpl_data, el.tpl_format);
		if (App.components.helper_need_update(new_html, el.innerHTML)) {
			el.innerHTML = new_html;
		}
	},

	redraw_all: function() {
		this.list_all.forEach((el) => this.redraw(el));
	},

	onBoot: function() {
		let component = this;
		customElements.define(this.tag_name, class extends HTMLElement {
			constructor() {
				super();
				App.components.register_in.call(this, component, ONLY_JS_RENDERING);
			}
		});
	},

	onLogin: function () {
		App.helper.cron.add('last_activity', () => this.redraw_all());

		let self = App.components.last_activity;

		App.bus.state.on('comment_add', function (payload) {
			let dateact = +payload.data.dt;

			if (payload.data.id_task) self.helper_update_by_object('task', payload.data.id_task, dateact);
			if (payload.data.id_project) self.helper_update_by_object('project', payload.data.id_project, dateact);
			if (payload.data.id_user) self.helper_update_by_object('user', payload.data.id_user, dateact);
		}).on('task_add', function (payload) {
			let dateact = +payload.data.dateadd;

			if (payload.data.id_parent) self.helper_update_by_object('task', payload.data.id_parent, dateact);
			if (payload.data.id_parent_top) self.helper_update_by_object('task', payload.data.id_parent_top, dateact);
			if (payload.data.id_project) self.helper_update_by_object('project', payload.data.id_project, dateact);
			if (payload.data.id_user_from) self.helper_update_by_object('user', payload.data.id_user_from, dateact);
		});
	},
	onLogout: function () {
		App.helper.cron.remove('last_activity');
	},

	destructor: function(component) { // `this` is element
		App.components.unregister_in.call(this, component);
	},

	helper_update_by_object: function (type, id, dateact) {
		if (type == null || id == null || id === 0 || dateact == null) return;

		let target = App.components.get_object_list(App.components.last_activity, type);

		target[id]?.forEach((el) => App.components.last_activity.redraw(el, { 'dateact': dateact }));
	},
}

;class Plate extends RenderableComponent {
	static get observedAttributes() {
		return ['interactable', 'selected', 'value']
	}

	templateContext() {
		return {
			interactable: this.propBool('interactable'),
			selected: this.propBool('selected')
		}
	}

	get value() {
		return this.prop('value')
	}

	template() {
		// language=HTML
		return `
			<self class="plate" ws-host-class="[interactable && 'plate--interactable', selected && 'plate--selected']">
				<slot></slot>
			</self>
		`
	}
}

class PlatesGroup extends RenderableComponent {
	static get observedAttributes() {
		return ['name', 'value'];
	}

	templateContext() {
		return {
			name: this.prop('name'),
			value: this.prop('value')
		}
	}

	select(e, el) {
		this.setProp('value', el.value);
		this.emitEvent('change', {value: el.value});
	}

	template() {
		//language=HTML
		return `
			<self ws-host-delegated-on-click="ws-plate|select">
				<slot interactable="true" ws-attr-selected="value == $target.value"></slot>
				<input ws-if="name" ws-attr-name="name" hidden>
			</self>
		`
	}

	get value() {
		return this.prop('value');
	}
}

App.components.plates = {
	onBoot() {
		customElements.define('ws-plate', Plate)
		customElements.define('ws-plates-group', PlatesGroup)
	}
}
;App.components.progress_bar = {
	onBoot: function () {
		customElements.define("progress-bar", class extends HTMLElement {
			constructor() {
				super();
			}

			render() {
				let data = {
					real: this.getAttribute('real') || 0,
					max: this.getAttribute('max') || 0,
					svgClass: this.getAttribute('svg-class') || undefined,
					over: this.getAttribute('over') || 0,
					overLink: this.getAttribute('over-link') || undefined,
					overTitle: this.getAttribute('over-title') || '',
				}

				let real = parseFloat(data.real);
				let max = parseFloat(data.max);
				let html = '';

				if (real <= max && max > 0) {
					const over_title_attr = data.overTitle ? 'data-title="'+data.overTitle+'"' : "";

					html += '<div class="progress' + (data.svgClass !== undefined ? ' progress_' + data.svgClass : '') + '">';
					if (data.over > 0 && data.overLink !== undefined) {
						html += '<a href="' + data.overLink + '" '+over_title_attr+' class="over" style="width: ' + (0.01 * Math.round(100 * 100 * data.over / max)) + '%"></a>';
					} else if (data.over > 0 && data.overLink === undefined) {
						html += '<div class="over" '+over_title_attr+' style="width: ' + (0.01 * Math.round(100 * 100 * data.over / max)) + '%"></div>';
					}
					if (1 || !isNaN(real)) {
						html += '<div style="width: ' + (0.01 * Math.round(100 * 100 * real / max)) + '%"></div>';
					}
					html += '</div>';
				} else if (real>0 && max===0) {
					html += '<div class="progress_na progress_time_na"><div></div></div>';
				} else if (real===0 && max===0) {
					html += '<div class="progress"><div style="width: 0;"></div></div>';
				} else {
					html += '<div class="progress progress_'+(data.svgClass!==undefined ? ' progress_'+data.svgClass+'_over' : '')+'">';
					html += '<div class="over" style="width: '+(!isNaN(real) ? 0.01*Math.round(100*100*(real-max)/real) : 0)+'%"></div>';
					html += '</div>';
				}
				this.innerHTML = html;
			}

			connectedCallback() {
				if (!this.rendered) {
					this.render();
					this.rendered = true;
				}
			}

			static get observedAttributes() {
				return ["real","max","svg-class","over","over-link"];
			}

			attributeChangedCallback() {
				if (this.hasChildNodes()) {
					this.removeChild(this.firstChild);
					this.render();
				}
			}
		});
	}
}

;App.components.progress_bar2 = {
	onBoot: function () {
		customElements.define("progress-bar2", class extends HTMLElement {
			constructor() {
				super();
			}

			render() {
				let data = {
					real: this.getAttribute('real') || 0,
					max: this.getAttribute('max') || 0,
					tmp: this.getAttribute('tmp') || 0,
					bars: this.getAttribute('bars') || 0,
					svgClass: this.getAttribute('svg-class') || undefined,
				}

				let real = parseFloat(data.real);
				let max = parseFloat(data.max);
				let tmp = parseFloat(data.tmp);
				real += tmp;
				let html = '';

				if (real <= max) {
				html += '<div class="progress2' + (data.svgClass !== undefined ? ' progress2_' + data.svgClass : '') + (tmp ? '' : ' progress2_nofill') + '">';
					html += '<div style="width:' + (0.01 * Math.round(100 * 100 * (real - tmp) / max)) + '%" class="p1"></div><div style="width:' + (0.01 * Math.round(100 * 100 * tmp / max)) + '%" class="p2"></div></div>';
					html += '</div>';
				} else if (real - tmp > max) {
					html += '<div class="progress2' + (data.svgClass !== undefined ? ' progress2_' + data.svgClass : '') + (tmp ? '' : ' progress2_nofill') + ' progress2_over">';
					html += '<div class="p1" style="width:' + (real ? 0.01 * Math.round(100 * 100 * (real - max - tmp) / real) : 0) + '%"></div><div class="p2" style="width:' + (real ? 0.01 * Math.round(100 * 100 * tmp / real) : 0) + '%"></div></div>';
					html += '</div>';
				} else {
					html += '<div class="progress2' + (data.svgClass !== undefined ? ' progress2_' + data.svgClass : '') + (tmp ? '' : ' progress2_nofill') + ' progress2_over2">';
					html += '<div class="p1" style="width:' + (real ? 0.01 * Math.round(100 * 100 * (real - max) / real) : 0) + '%"></div><div class="p2" style="width:' + (real ? 0.01 * Math.round(100 * 100 * (tmp - real + max) / real) : 0) + '%"></div></div>';
					html += '</div>';
				}
				let lines = Math.max(max, real);
				if (data.bars && lines && lines <= 24) for (let i = 0; i < lines - 1; i++) html += '<i style="width:' + (0.01 * Math.round(100 * 100 / lines)) + '%"></i>';
				this.innerHTML = html;
			}

			connectedCallback() {
				if (!this.rendered) {
					this.render();
					this.rendered = true;
				}
			}

			static get observedAttributes() {
				return ["real","max","svg-class","tmp"];
			}

			attributeChangedCallback() {
				if (this.hasChildNodes()) {
					while(this.firstChild) this.removeChild(this.firstChild);
					this.render();
				}
			}
		});
	}
}

;App.components.progress_pie = {
	onBoot: function () {
		customElements.define("progress-pie", class extends HTMLElement {
			constructor() {
				super();
			}

			connectedCallback() {
				if (!this.rendered) {
					this.render();
					this.rendered = true;
				}
			}

			render() {
				let data = {
					real: this.getAttribute('real') || 0,
					max: this.getAttribute('max') || 0,
					over: this.getAttribute('over') || 0,
					invert: this.getAttribute('invert') || undefined,
					svgClass: this.getAttribute('svg-class') || undefined,
					svgTitle: this.getAttribute('svg-title') || undefined,
					outerRadius: this.getAttribute('outer-radius') || 18,
					innerRadius: this.getAttribute('inner-radius') || 14,
				}
				let real = parseFloat(data.real);
				let max = parseFloat(data.max);
				let over = parseFloat(data.over);

				if (data.invert === 'yes') {
					real = max - real;
				}

				let svgSize = data.outerRadius*2;
				let center = svgSize/2;
				let strokeWidth = Math.max(2, data.outerRadius - data.innerRadius);
				let radius = data.outerRadius - strokeWidth/2;
				let circleLength = 2 * Math.PI * radius;

				let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
				svg.classList.add('pie_svg');
				if (data.svgTitle!==undefined) svg.setAttribute('data-title', data.svgTitle);
				svg.setAttribute('height', svgSize.toString());
				svg.setAttribute('width', svgSize.toString());
				svg.setAttribute('viewBox', '0 0 '+svgSize.toString()+' '+svgSize.toString());

				if (real <= max && !isNaN(max)) {
					if (data.svgClass!==undefined) svg.classList.add('pie_'+data.svgClass);
					svg.innerHTML = '' +
						'<circle class="fill" r="'+radius+'" cx="'+center+'" cy="'+center+'" fill="transparent" stroke-width="'+strokeWidth+'"></circle>\n' +
						'<circle class="draw" r="'+radius+'" cx="'+center+'" cy="'+center+'" fill="transparent" ' +
						'stroke-width="'+strokeWidth+'" ' +
						'stroke-dashoffset="'+(circleLength/4).toFixed(2)+'" ' +
						'stroke-dasharray="'+(circleLength*(real/max)).toFixed(2)+' '+(circleLength*(1-real/max)).toFixed(2)+'"' +
						'style="--dasharray-start: '+(circleLength*(0/max)).toFixed(2)+' '+(circleLength*(1-0/max)).toFixed(2)+'">' +
						'</circle>';
					if (over && !isNaN(over)) {
						svg.classList.add('pie_over');
						svg.innerHTML += '<circle class="draw_over" r="'+radius+'" cx="'+center+'" cy="'+center+'" fill="transparent" ' +
						'stroke-width="'+strokeWidth+'" ' +
						'stroke-dashoffset="'+(circleLength/4).toFixed(2)+'" ' +
						'stroke-dasharray="0 '+(circleLength*(1-over/max)).toFixed(2)+' '+(circleLength*(over/max)).toFixed(2)+' 0"' +
						'style="--dasharray-start: 0 '+(circleLength*(1-over/max)).toFixed(2)+' '+(circleLength*(over/max)).toFixed(2)+' 0">' +
						'</circle>';
					}
					this.appendChild(svg);
				} else if (!isNaN(max) && !isNaN(real)) {
					if (data.svgClass!==undefined) svg.classList.add('pie_'+data.svgClass+'_over');
					svg.classList.add('pie_over');
					svg.innerHTML = '' +
						'<circle class="fill" r="'+radius+'" cx="'+center+'" cy="'+center+'" fill="transparent" ' +
						'stroke-width="'+strokeWidth+'" ' +
						'stroke-dashoffset="'+(circleLength/4).toFixed(2)+'" ' +
						'stroke-dasharray="'+circleLength+' 0">' +
						'</circle>' +
						'<circle class="draw" r="'+radius+'" cx="'+center+'" cy="'+center+'" fill="transparent" ' +
						'stroke-width="'+strokeWidth+'" ' +
						'stroke-dashoffset="'+(circleLength/4).toFixed(2)+'" ' +
						'stroke-dasharray="'+circleLength+' 0"> ' +
						'</circle>' +
						'<circle class="draw_over" r="'+radius+'" cx="'+center+'" cy="'+center+'" fill="transparent" ' +
						'stroke-width="'+strokeWidth+'" ' +
						'stroke-dashoffset="'+(circleLength/4).toFixed(2)+'" ' +
						'stroke-dasharray="0 '+(circleLength*(max/real)).toFixed(2)+' '+(circleLength*(1-max/real)).toFixed(2)+' 0">' +
						'</circle>';
					this.appendChild(svg);
				} else if (0 && !isNaN(real)) {
					this.innerHTML = '<div class="pie_na pie_time_na"'+(data.svgTitle!==undefined ? ' data-title="'+data.svgTitle+'"' : '')+'><div></div></div>';
				}
			}

			static get observedAttributes() {
				return ["real","max","over","svg-class","title","outer-radius","inner-radius"];
			}

			attributeChangedCallback() {
				if (this.hasChildNodes()) {
					this.removeChild(this.firstChild);
					$(this).addClass('noani_child');
					this.render();
				}
			}
		});
	}
}

;/** <project-assignee> component **/
App.components.project_assignee = {

	tag_name: 'project-assignee',
	list_by_object: {},
	list_all: [],

	template: function(params, format) {
		let template = App.helper.template.get_cached('assignee', format);
		template = template.trim().replace(/\s+/g, ' ');
		if (!template) return '';

		return App.helper.template.fill(template, params);
	},

	redraw: function(el, data) {
		if (data) {
			el.tpl_data = data;
			el.setAttribute('data-ref-user', data.id);
		}
		let new_html = this.template(el.tpl_data, el.tpl_format);
		if (App.components.helper_need_update(new_html, el.innerHTML)) {
			el.innerHTML = new_html;
			let id_project = parseInt(el.dataset.project);

			if (data) switch (App.page.where()) {
				case 'projects':
					let classes = $('#obj-project'+id_project).attr('class').split(' ').filter(param => !/^u\d+/.test(param));
					classes.push('u' + data.id);
					$('#obj-project'+id_project).attr('class', classes);
					break;
			}
		}
	},

	onBoot: function() {
		let component = this;
		customElements.define(this.tag_name, class extends HTMLElement {
			constructor() {
				super();
				App.components.register_in.call(this, component, ONLY_JS_RENDERING);
			}
		});

		App.bus.state.on('user_update', function({id, data}) {
			App.components.user_name.redraw_by_ref(App.components.project_assignee, 'name', id, data);
		});
	},

	destructor: function(component) { // `this` is element
		App.components.unregister_in.call(this, component);
	},
}

;/** <project-author> component **/
App.components.project_author = {

	tag_name: 'project-author',
	list_by_object: {},
	list_all: [],

	template: function(params, format) {
		let template = App.helper.template.get_cached('author', format);
		template = template.trim().replace(/\s+/g, ' ');
		if (!template) return '';

		return App.helper.template.fill(template, params);
	},

	redraw: function(el, data) {
		if (data) {
			el.tpl_data = data;
			el.setAttribute('data-ref-user', data.id);
		}
		let new_html = this.template(el.tpl_data, el.tpl_format);
		if (App.components.helper_need_update(new_html, el.innerHTML)) {
			el.innerHTML = new_html;
			let id_project = parseInt(el.dataset.project);

			if (data) switch (App.page.where()) {
				case 'projects':
					let classes = $('#obj-project'+id_project).attr('class').split(' ').filter(param => !/^u\d+/.test(param));
					classes.push('u' + data.id);
					$('#obj-project'+id_project).attr('class', classes);
					break;
			}
		}
	},

	onBoot: function() {
		let component = this;
		customElements.define(this.tag_name, class extends HTMLElement {
			constructor() {
				super();
				App.components.register_in.call(this, component, ONLY_JS_RENDERING);
			}
		});

		App.bus.state.on('user_update', function({id, data}) {
			App.components.user_name.redraw_by_ref(App.components.project_author, 'name', id, data);
		});
	},

	destructor: function(component) { // `this` is element
		App.components.unregister_in.call(this, component);
	},
}

;/** <project-folder> component **/
App.components.project_folder = {

	tag_name: 'project-folder',
	list_by_object: {},
	list_all: [],

	template: function(params, format) {
		let template = 'folder';

		template = App.helper.template.get_cached(template, format);
		template = template.trim().replace(/\s+/g, ' ');
		if (!template) return '';

		return App.helper.template.fill(template, params);
	},

	redraw: function(el, data) {
		if (data) el.tpl_data = data;
		let new_html = this.template(el.tpl_data, el.tpl_format);
		if (App.components.helper_need_update(new_html, el.innerHTML)) {
			el.innerHTML = new_html;
		}
	},

	onBoot: function() {
		let component = this;
		customElements.define(this.tag_name, class extends HTMLElement {
			constructor() {
				super();
				App.components.register_in.call(this, component, ONLY_JS_RENDERING);
			}
		});
	},

	destructor: function(component) { // `this` is element
		App.components.unregister_in.call(this, component);
	},
}

;/** <project-stage> component **/
App.components.project_stage = {

	tag_name: 'project-stage',
	list_by_object: {},
	list_all: [],
	inst: 1,

	regex_remove_class: /(\s|\b)st\d+\b/g,

	id_map: {
		0: 4,
	},

	template: function(params, format) {
		let template = 'stage';
		let id_stage = params.id;
		let id_tag = App.components.project_stage.id_map[params.id] ?? params.id;

		if (id_stage && (!App.tags[id_tag] || !App.tags_group[App.tags[id_tag].id_group].stage)) return '';
		if (id_stage === 0 && params.status) id_tag = 5;

		const render_params = {
			id: id_stage,
			name: App.tags[id_tag].name,
			color: App.tags[id_tag].color,
			stage: App.tags_group[App.tags[id_tag].id_group].stage ? 1 : 0,
			hidden: App.tags_group[App.tags[id_tag].id_group].hidden ? 1 : 0,
			class: App.tags_group[App.tags[id_tag].id_group].stage ? ' tag-stage' : (App.tags_group[App.tags[id_tag].id_group].hidden ? ' tag-hidden' : ''),
			percent_style: App.tags[id_tag].percent_style,
			icon: App.tags_type_icon[App.components.project_tags.inst][App.tags[id_tag].id_type]
		};

		template = App.helper.template.get_cached(template, format);
		template = template.trim().replace(/\s+/g, ' ');
		if (!template) return '';

		return App.helper.template.fill(template, render_params);
	},

	redraw: function(el, data) {
		if (data) el.tpl_data = data;
		let new_html = this.template(el.tpl_data, el.tpl_format);
		if (App.components.helper_need_update(new_html, el.innerHTML)) {
			el.innerHTML = new_html;
		}
	},

	onBoot: function() {
		let component = this;
		customElements.define(this.tag_name, class extends HTMLElement {
			constructor() {
				super();
				App.components.register_in.call(this, component, ONLY_JS_RENDERING);
			}
		});
	},

	destructor: function(component) { // `this` is element
		App.components.unregister_in.call(this, component);
	},
}

;/** <project-tags> component **/
App.components.project_tags = {

	tag_name: 'project-tags',
	list_by_object: {},
	list_all: [],
	inst: 1,

	regex_remove_class: /(\s|\b)t\d+\b/g,

	template: function(params, format, filter) {

		let render_tags = [], render_params = {}, id_last_group = false, template = 'tags';

		render_params.tags = params.tags.filter(id_tag => id_tag in App.tags) // Visible for me
		render_params.tags = render_params.tags.sort(function(a, b) {
			return App.helper.sort.compare(App.tags_group[App.tags[a].id_group].order, App.tags_group[App.tags[b].id_group]) || App.helper.sort.compare(App.tags[a].order, App.tags[b].order)
		});
		render_params.tags.forEach(function(id_tag) {
			if (filter !== 'none' && App.tags[id_tag].id_group != filter) return;
			let render_tag = {
				name: App.tags[id_tag].name,
				color: App.tags[id_tag].color,
				stage: App.tags_group[App.tags[id_tag].id_group].stage ? 1 : 0,
				hidden: App.tags_group[App.tags[id_tag].id_group].hidden ? 1 : 0,
				class: App.tags_group[App.tags[id_tag].id_group].stage ? ' tag-stage' : (App.tags_group[App.tags[id_tag].id_group].hidden ? ' tag-hidden' : ''),
				space: id_last_group !== false && id_last_group !== App.tags[id_tag].id_group ? '<em></em>' : ''
			};
			if (App.tags_group[App.tags[id_tag].id_group].stage) {
				render_tag.percent_style = App.tags[id_tag].percent_style;
				render_tag.icon = App.tags_type_icon[App.components.project_tags.inst][App.tags[id_tag].id_type];
			}
			render_tags.push(render_tag);
			id_last_group = App.tags[id_tag].id_group;
		});
		render_params.tags = render_tags;

		template = App.helper.template.get_cached(template, format);
		template = template.trim().replace(/\s+/g, ' ');
		if (!template) return '';

		return App.helper.template.fill(template, render_params);
	},

	redraw: function(el, data) {
		if (data) el.tpl_data = data;
		let new_html = this.template(el.tpl_data, el.tpl_format, el.tpl_filter);
		if (App.components.helper_need_update(new_html, el.innerHTML)) {
			el.innerHTML = new_html;
		}
	},

	onBoot: function() {
		let component = this;
		customElements.define(this.tag_name, class extends HTMLElement {
			constructor() {
				super();
				App.components.register_in.call(this, component, ONLY_JS_RENDERING);
			}
		});
	},

	destructor: function(component) { // `this` is element
		App.components.unregister_in.call(this, component);
	},
}

;/** <project-term> component **/
App.components.project_terms = {

	tag_name: 'project-term',
	list_by_object: {},
	list_all: [],

	list_project_classes: {
		'burning': 23,
		'no_duedate': 24,
	},

	remove_project_classes: 'p23 p24',

	list_class_helper: function(i) {
		return ' p' + i;
	},

	template: function(params, format) {
		params.dateend = parseInt(params.dateend);
		params.datestart = parseInt(params.datestart);
		params.dateadd = parseInt(params.dateadd);
		params.time_diff = params.dateend + App.config.day_end - App.helper.time.account();
		params.time_diff_start = params.datestart - App.helper.time.account();
		params.time_diff_max = params.time_diff_start < 0 && params.datestart ? params.time_diff - params.time_diff_start : 6 * 86400;
		params.terms = params.terms_end = params.dateend ? App.format.terms_from_inputs_data({
			dateend: params.dateend ? App.helper.date.to_input(new Date((params.dateend + App.config.date_timestamp_offset)  * 1000)) : '',
			datestart: params.datestart ? App.helper.date.to_input(new Date((params.datestart+ App.config.date_timestamp_offset) * 1000)) : '',
			dateadd: params.dateadd ? App.helper.date.to_input(new Date(params.dateadd * 1000)) : '',
		}) : '';
		if (params.terms.indexOf(' &mdash;') !== -1) [params.terms_start, params.terms_end] = params.terms.split(' &mdash;');
		if (format === 'class') {
			let className = '';
			if (!params.dateend) className += App.components.project_terms.list_class_helper(App.components.project_terms.list_project_classes['no_duedate']);
			else if (params.time_diff < 0) className += App.components.project_terms.list_class_helper(App.components.project_terms.list_project_classes['burning']);
			return className;
		} else {
			if (params.datestart && params.datestart > App.helper.customDate.get('today')) params.wait = 1;
			else if (params.dateend && Math.abs(params.time_diff) >= 60) {
				if (params.time_diff < 0) params.hot = 1;
				else if (params.dateend === App.helper.customDate.get('today')) params.today = 1;
				else if (params.dateend === App.helper.customDate.get('tomorrow')) params.tomorrow = 1;
				else if (params.time_diff < 6 * 86400) params.warm = 1;
				else params.normal = 1;
			}
		}

		let template = App.helper.template.get_cached('terms', format);
		template = template.trim().replace(/\s+/g, ' ');
		if (!template) return '';

		return App.helper.template.fill(template, params);
	},

	redraw: function(el, data) {
		if (data) el.tpl_data = data;
		let new_html = this.template(el.tpl_data, el.tpl_format);
		if (App.components.helper_need_update(new_html, el.innerHTML)) {
			el.innerHTML = new_html;
			let id_project = parseInt(el.dataset.project);

			switch (App.page.where()) {
				case 'projects':
					$('#obj-project'+id_project).removeClass(this.remove_project_classes).addClass(this.template(el.tpl_data, 'class'));
					break;
			}
		}
	},

	redraw_all: function() {
		this.list_all.forEach((el) => this.redraw(el));
	},

	onLogin: function () {
		App.helper.cron.add('project_terms', () => this.redraw_all());
	},
	onLogout: function () {
		App.helper.cron.remove('project_terms');
	},

	onBoot: function() {
		let component = this;
		customElements.define(this.tag_name, class extends HTMLElement {
			constructor() {
				super();
				App.components.register_in.call(this, component, ONLY_JS_RENDERING);
			}
		});
	},

	destructor: function(component) { // `this` is element
		App.components.unregister_in.call(this, component);
	},
}

;/** <project-workflow> component **/
App.components.project_workflow = {
    tag_name: 'project-workflow',
    list_by_object: {},
    list_all: [],
    template: function (params, format) {

        let template = $(`#tmpl_${format}_workflow`).html();
        template = template.trim().replace(/\s+/g, ' ');
        if (!template) return '';
        return App.helper.template.fill(template, params);

    },

    onBoot: function () {
        let component = this;
        customElements.define(this.tag_name, class extends HTMLElement {
            constructor() {
                super();
                App.components.register_in.call(this, component, ONLY_JS_RENDERING);
            }
        });

    },

    redraw: function (el, data) {
        if (data) el.tpl_data = data;
        let new_html = this.template(el.tpl_data, el.tpl_format);
        if (App.components.helper_need_update(new_html, el.innerHTML)) {
            el.innerHTML = new_html;
        }
    },

    destructor: function (component) { // `this` is element
        App.components.unregister_in.call(this, component);
    },
}
;/** <tags-group-chips> component **/

App.components.tags_group_chips = {

	tag_name: 'tags-group-chips',
	list_by_object: {},
	list_all: [],
	inst: 0,


	// list_task_classes: {
	// 	'with_todos': 16,
	// },

	// regex_remove_class: /(\s|\b)p16\b/g,

	template: function(params, format) {

		let template = 'tags_group_chips';

		let render_params = params;

		template = App.helper.template.get_cached(template, format);
		template = template.trim().replace(/\s+/g, ' ');
		if (!template) return '';
		return App.helper.template.fill(template, render_params);
	},

	redraw: function(el, data) {
		if (data) el.tpl_data = data;
		let new_html = this.template(el.tpl_data, el.tpl_format);
		if (App.components.helper_need_update(new_html, el.innerHTML)) {
			el.innerHTML = new_html;
		}
	},

	onBoot: function() {
		let component = this;
		customElements.define(this.tag_name, class extends HTMLElement {
			constructor() {
				super();
				App.components.register_in.call(this, component);
			}
		});
	},

	destructor: function(component) { // `this` is element
		App.components.unregister_in.call(this, component);
	},
}

;/** <tags-group-icon> component **/

App.components.tags_group_icon = {

	tag_name: 'tags-group-icon',
	list_by_object: {},
	list_all: [],
	inst: 0,


	// list_task_classes: {
	// 	'with_todos': 16,
	// },

	// regex_remove_class: /(\s|\b)p16\b/g,

	template: function(params, format) {

		let template = 'tags_group_icon';

		let render_params = params;

		template = App.helper.template.get_cached(template, format);
		template = template.trim().replace(/\s+/g, ' ');
		if (!template) return '';
		return App.helper.template.fill(template, render_params);
	},

	redraw: function(el, data) {
		if (data) el.tpl_data = data;
		let new_html = this.template(el.tpl_data, el.tpl_format);
		if (App.components.helper_need_update(new_html, el.innerHTML)) {
			el.innerHTML = new_html;
		}
	},

	onBoot: function() {
		let component = this;
		customElements.define(this.tag_name, class extends HTMLElement {
			constructor() {
				super();
				App.components.register_in.call(this, component);
			}
		});
	},

	destructor: function(component) { // `this` is element
		App.components.unregister_in.call(this, component);
	},
}

;/** <tags-group-toggle> component **/

App.components.tags_group_toggle = {

	tag_name: 'tags-group-toggle',
	list_by_object: {},
	list_all: [],
	inst: 0,


	// list_task_classes: {
	// 	'with_todos': 16,
	// },

	// regex_remove_class: /(\s|\b)p16\b/g,

	template: function(params, format) {

		let template = 'tags_group_toggle';

		let render_params = params;

		template = App.helper.template.get_cached(template, format);
		template = template.trim().replace(/\s+/g, ' ');
		if (!template) return '';
		return App.helper.template.fill(template, render_params);
	},

	redraw: function(el, data) {
		if (data) el.tpl_data = data;
		let new_html = this.template(el.tpl_data, el.tpl_format);
		if (App.components.helper_need_update(new_html, el.innerHTML)) {
			el.innerHTML = new_html;
		}
	},

	onBoot: function() {
		let component = this;
		customElements.define(this.tag_name, class extends HTMLElement {
			constructor() {
				super();
				App.components.register_in.call(this, component);
			}
		});
	},

	destructor: function(component) { // `this` is element
		App.components.unregister_in.call(this, component);
	},
}

;/** <tags-group-usage> component **/

App.components.tags_group_usage = {

	tag_name: 'tags-group-usage',
	list_by_object: {},
	list_all: [],
	inst: 0,


	// list_task_classes: {
	// 	'with_todos': 16,
	// },

	// regex_remove_class: /(\s|\b)p16\b/g,

	template: function(params, format) {

		let template = 'tags_group_usage';

		let render_params = params;

		render_params['hint'] = App.components.tags_group_usage.format_hint(+params.usage);

		template = App.helper.template.get_cached(template, format);
		template = template.trim().replace(/\s+/g, ' ');
		if (!template) return '';
		return App.helper.template.fill(template, render_params);
	},

	redraw: function(el, data) {
		if (data) el.tpl_data = data;
		let new_html = this.template(el.tpl_data, el.tpl_format);
		if (App.components.helper_need_update(new_html, el.innerHTML)) {
			el.innerHTML = new_html;
		}
	},

	onBoot: function() {
		let component = this;
		customElements.define(this.tag_name, class extends HTMLElement {
			constructor() {
				super();
				App.components.register_in.call(this, component);
			}
		});
	},

	destructor: function(component) { // `this` is element
		App.components.unregister_in.call(this, component);
	},

	format_hint: function(cnt) {
		const locale = App.object_state.locale.tags_group;
		if (!locale) return cnt;
		if (!cnt) return locale.no_usage;
		return locale.usage_in_.replace('%s', App.format.quantity(cnt, locale._in_projects, true));
	},
}

;/** <task-assignee> component **/
App.components.task_assignee = {

	tag_name: 'task-assignee',
	list_by_object: {},
	list_all: [],

	template: function(params, format) {
		let template = App.helper.template.get_cached('assignee', format);
		template = template.trim().replace(/\s+/g, ' ');
		if (!template) return '';

		return App.helper.template.fill(template, params);
	},

	redraw: function(el, data) {
		if (data) {
			el.tpl_data = { ...el.tpl_data, ...data };
			el.setAttribute('data-ref-user', data.id);
		}
		let new_html = this.template(el.tpl_data, el.tpl_format);
		if (App.components.helper_need_update(new_html, el.innerHTML)) {
			el.innerHTML = new_html;
		}
	},

	onBoot: function() {
		let component = this;
		customElements.define(this.tag_name, class extends HTMLElement {
			constructor() {
				super();
				App.components.register_in.call(this, component, ONLY_JS_RENDERING);
			}
		});

		App.bus.state.on('user_update', function({id, data}) {
			App.components.user_name.redraw_by_ref(App.components.task_assignee, 'name', id, data);
		}).on('task_user_to', function ({id, data}) {
			let component_data = {};
			['id', 'avatar', 'name', 'icon'].forEach((i) => component_data[i] = data[i]);
			component_data['is_seen'] = data['is_seen'] || false;
			App.components.task_assignee.list_by_object[id]?.forEach((el) => App.components.task_assignee.redraw(el, component_data));
		});
	},

	destructor: function(component) { // `this` is element
		App.components.unregister_in.call(this, component);
	},
}

;/** <task-attach> component **/
App.components.task_attach = {

	tag_name: 'task-attach',
	list_by_object: {},
	list_all: [],

	list_task_classes: {
		'with_files': 17,
	},

	regex_remove_class: /(\s|\b)p17\b/g,

	template: function(params, format) {
		let template = App.helper.template.get_cached('attach', format);
		template = template.trim().replace(/\s+/g, ' ');
		if (!template) return '';

		return App.helper.template.fill(template, params);
	},

	redraw: function(el, data) {
		if (data) el.tpl_data = data;
		let new_html = this.template(el.tpl_data, el.tpl_format);
		if (App.components.helper_need_update(new_html, el.innerHTML)) {
			el.innerHTML = new_html;
		}
	},

	onBoot: function() {
		let component = this;
		customElements.define(this.tag_name, class extends HTMLElement {
			constructor() {
				super();
				App.components.register_in.call(this, component, ONLY_JS_RENDERING);
			}
		});

		App.bus.state.on('task_attach', function ({id,data}) {
			let component_data = {};
			['id'].forEach((i) => component_data[i] = data[i]);
			App.components.task_attach.list_by_object[id]?.forEach((el) => App.components.task_attach.redraw(el, component_data));
		});
	},

	destructor: function(component) { // `this` is element
		App.components.unregister_in.call(this, component);
	},
}

;/** <task-author> component **/
App.components.task_author = {

	tag_name: 'task-author',
	list_by_object: {},
	list_all: [],

	template: function(params, format) {
		let template = App.helper.template.get_cached('author', format);
		template = template.trim().replace(/\s+/g, ' ');
		if (!template) return '';

		return App.helper.template.fill(template, params);
	},

	redraw: function(el, data) {
		if (data) {
			el.tpl_data = data;
			el.setAttribute('data-ref-user', data.id);
		}
		let new_html = this.template(el.tpl_data, el.tpl_format);
		if (App.components.helper_need_update(new_html, el.innerHTML)) {
			el.innerHTML = new_html;
		}
	},

	onBoot: function() {
		let component = this;
		customElements.define(this.tag_name, class extends HTMLElement {
			constructor() {
				super();
				App.components.register_in.call(this, component, ONLY_JS_RENDERING);
			}
		});

		App.bus.state.on('user_update', function({id, data}) {
			App.components.user_name.redraw_by_ref(App.components.task_author, 'name', id, data);
		}).on('task_user_from', function ({id, data}) {
			let component_data = {};
			['id', 'avatar', 'name'].forEach((i) => component_data[i] = data[i]);
			App.components.task_author.list_by_object[id]?.forEach((el) => App.components.task_author.redraw(el, component_data));
		});
	},

	destructor: function(component) { // `this` is element
		App.components.unregister_in.call(this, component);
	},
}

;/** <task-contacts> component **/

App.components.task_contacts = {

	tag_name: 'task-contacts',
	list_by_object: {},
	list_all: [],
	inst: 0,


	list_task_classes: {
		'with_contacts': 50,
	},

	regex_remove_class: /(\s|\b)c\d\b/g,

	template: function(params, format) {

		let template = 'contacts';

		let ids = Object.keys(params);
		let render_params = {
			cnt: ids.length,
			cnt_str: App.format.quantity(ids.length, App.object_state.locale.quantity.contact, true),
			names: Object.values(params).join('\n'),
			ids: ids.join(','),
		};

		template = App.helper.template.get_cached(template, format);
		template = template.trim().replace(/\s+/g, ' ');
		if (!template) return '';
		return App.helper.template.fill(template, render_params);
	},

	redraw: function(el, data) {
		if (data) el.tpl_data = data;
		let new_html = this.template(el.tpl_data, el.tpl_format);
		if (App.components.helper_need_update(new_html, el.innerHTML)) {
			el.innerHTML = new_html;
		}
	},

	onBoot: function() {
		let component = this;
		customElements.define(this.tag_name, class extends HTMLElement {
			constructor() {
				super();
				App.components.register_in.call(this, component, ONLY_JS_RENDERING);
			}
		});

		// App.bus.state.on('task_contact', function ({id,data}) {
		//
		// });
	},

	destructor: function(component) { // `this` is element
		App.components.unregister_in.call(this, component);
	},
}

;class TaskDelay extends RenderableComponent {
	static get observedAttributes() {
		return ['dateend', 'timeend', 'dateclose']
	}

	templateContext() {

		const dateend = this.propInt('dateend');
		const timeend = this.propInt('timeend');
		const dateclose = this.propInt('dateclose');
		if (!dateend) {
			return {
				days: 0,
			}
		}
		const daysDiff = App.helper.date.dateDiffInDays(
			App.helper.date.from_timestamp(dateend + (timeend ? timeend * 900 : App.config.day_end)),
			App.helper.date.from_timestamp(dateclose || App.helper.time.server())
		);
		return {
			days: daysDiff > 0 ? daysDiff : 0,
		};
	}

	template() {
		//language=HTML
		return `
			<self class="task_delay" ws-host-class="[days > 0 && 'task_delay--filled']" ws-host-text="days">
			</self>
		`
	}

}

App.components.task_delay = {
	onBoot() {
		customElements.define('task-delay', TaskDelay);
		App.bus.state.on('task_terms', function ({id, data: {dateend, timeend}}) {
			document.querySelectorAll(`task-delay[task="${id}"]`).forEach(taskDelay => {
				taskDelay.setAttribute('dateend', dateend);
				taskDelay.setAttribute('timeend', timeend);
			})
		});
		App.bus.state.on('task_done', function ({id, data: {dateclose}}) {
			document.querySelectorAll(`task-delay[task="${id}"]`).forEach(taskDelay => {
				taskDelay.setAttribute('dateclose', dateclose);
			})
		});
		App.bus.state.on('task_undone', function (id) {
			document.querySelectorAll(`task-delay[task="${id}"]`).forEach(taskDelay => {
				taskDelay.setAttribute('dateclose', 0);
			})
		});
	}
}
;/** <task-done-date> component **/
App.components.task_done_date = {

	tag_name: 'task-done-date',
	list_by_object: {},
	list_all: [],

	template: function(params, format) {
		let type = '';
		if (!params.time_diff) {
			params.time_diff = params.dateend + (params.timeend ? params.timeend * 900 : App.config.day_end) - params.dateclose - App.config.date_timezone_offset;
		}
		let template = App.helper.template.get_cached('done_date', format + (type ? '_' + type : ''));
		template = template.trim().replace(/\s+/g, ' ');
		if (!template) return '';

		return App.helper.template.fill(template, params);
	},

	redraw: function(el, data) {
		if (data) el.tpl_data = data;
		let new_html = this.template(el.tpl_data, el.tpl_format);
		if (App.components.helper_need_update(new_html, el.innerHTML)) {
			el.innerHTML = new_html;
		}
	},

	redraw_all: function() {
		this.list_all.forEach((el) => this.redraw(el));
	},

	onLogin: function () {
		App.helper.cron.add('task_done_date', () => this.redraw_all());
	},
	onLogout: function () {
		App.helper.cron.remove('task_done_date');
	},

	onBoot: function() {
		let component = this;
		customElements.define(this.tag_name, class extends HTMLElement {
			constructor() {
				super();
				App.components.register_in.call(this, component, ONLY_JS_RENDERING);
			}
		});

		App.bus.state.on('task_terms', function({id, data}) {
			let component_data = {};
			['dateend', 'timeend'].forEach((i) => component_data[i] = data[i]);
			App.components.task_done_date.list_by_object[id]?.forEach((el) => App.components.task_done_date.redraw(el, component_data));
		}).on('task_done_date', function ({id, data}) {
			let component_data = {};
			['dateclose', 'dateend', 'closed_by', 'status', 'timeend', 'time_diff'].forEach((i) => component_data[i] = data[i]);
			App.components.task_done_date.list_by_object[id]?.forEach((el) => App.components.task_done_date.redraw(el, component_data));
		}).on('task_done', function ({id}) {
			App.components.task_done_date.list_by_object[id]?.forEach((el) => {
				el.tpl_data.status = 1;
				App.components.task_done_date.redraw(el);
			});
		}).on('task_undone', function ({id}) {
			App.components.task_done_date.list_by_object[id]?.forEach((el) => {
				el.tpl_data.status = 0;
				App.components.task_done_date.redraw(el);
			});
		});
	},

	destructor: function(component) { // `this` is element
		App.components.unregister_in.call(this, component);
	},
}

;/** <task-meet-term> component **/
App.components.task_meet_terms = {

	tag_name: 'task-meet-term',
	list_by_object: {},
	list_all: [],

	redraw: function(el, data) {
		if (data) el.tpl_data = data;
		el.tpl_data.date = 1 * el.tpl_data.date;
		el.tpl_data.timestart = 1 * el.tpl_data.timestart;
		el.tpl_data.timeend = 1 * el.tpl_data.timeend;
		let time_diff = el.tpl_data.date + 900 * el.tpl_data.timeend - App.helper.time.account();
		// if (time_diff < -3600) { // DOM disappear if meet finished 1 hour ago — disabled
		if (time_diff < 0) {
			this.destructor.call(el, this);
			$(el).parents('.meetListing__item').remove();
			return false;
		}

		let date = new Date(el.tpl_data.date * 1000);
		let new_html = App.format.date(date, DATE_SCHEDULE_COMPACT) + ' ' + App.format.term_time(el.tpl_data.timestart) + '&thinsp;&ndash;&thinsp;' + App.format.term_time(el.tpl_data.timeend);
		if (App.components.helper_need_update(new_html, el.innerHTML)) {
			el.innerHTML = new_html;
		}
	},

	redraw_all: function() {
		this.list_all.forEach((el) => this.redraw(el));
	},

	onLogin: function () {
		App.helper.cron.add('task_meet_terms', () => this.redraw_all());
	},
	onLogout: function () {
		App.helper.cron.remove('task_meet_terms');
	},

	onBoot: function() {
		let component = this;
		customElements.define(this.tag_name, class extends HTMLElement {
			constructor() {
				super();
				App.components.register_in.call(this, component);
			}
		});
	},

	destructor: function(component) { // `this` is element
		App.components.unregister_in.call(this, component);
	},
}

;/** <task-priority> component **/
App.components.task_priority = {

	tag_name: 'task-priority',
	list_by_object: {},
	list_all: [],

	regex_remove_class: /(\s|\b)p(5|6|10|110|10\d)\b/g,

	get_txt: function(num) {
		switch (num)
		{
			case 0:
				return App.object_state.locale.priority['pause'];
			case 1:
				return App.object_state.locale.priority['default'];
			case 2:
				return App.object_state.locale.priority['low_2'];
			case 3:
				return App.object_state.locale.priority['low_3'];
			case 4:
				return App.object_state.locale.priority['low_4'];
			case 5:
				return App.object_state.locale.priority['mid_5'];
			case 6:
				return App.object_state.locale.priority['mid_6'];
			case 7:
				return App.object_state.locale.priority['mid_7'];
			case 8:
				return App.object_state.locale.priority['high_8'];
			case 9:
				return App.object_state.locale.priority['high_9'];
			case 10:
				return App.object_state.locale.priority['high_10'];
		}
	},

	template: function(params, format) {
		let template = App.helper.template.get_cached('priority', format);
		template = template.trim().replace(/\s+/g, ' ');
		if (!template) return '';

		if (String(params.html) === '0') params.html = PRIOR0_HTML;
		params.text = App.components.task_priority.get_txt(params.id);

		return App.helper.template.fill(template, params);
	},

	redraw: function(el, data) {
		if (data) el.tpl_data = data;
		let new_html = this.template(el.tpl_data, el.tpl_format);
		if (App.components.helper_need_update(new_html, el.innerHTML)) {
			el.innerHTML = new_html;
		}
	},

	onBoot: function() {
		let component = this;
		customElements.define(this.tag_name, class extends HTMLElement {
			constructor() {
				super();
				App.components.register_in.call(this, component, ONLY_JS_RENDERING);
			}
		});

		App.bus.state.on('task', function (payload) {
			if (payload.data.priority) {
				let component_data = {}, data = payload.data.priority;
				['id', 'html'].forEach((i) => component_data[i] = data[i]);
				App.components.task_priority.list_by_object[payload.id]?.forEach((el) => App.components.task_priority.redraw(el, component_data));
			}
		});
	},

	destructor: function(component) { // `this` is element
		App.components.unregister_in.call(this, component);
	},
}

;/** <task-reactions> component **/

App.components.task_reactions = {

	tag_name: 'task-reactions',
	list_by_object: {},
	list_all: [],
	inst: 0,

	list_symbol: {
		1: 'color/reaction-like',
		2: 'color/reaction-love',
		3: 'color/reaction-dislike',
		4: 'color/reaction-hurry_up',
		5: 'color/reaction-checked_on',
		6: 'color/reaction-got_acquainted',
		7: 'color/reaction-funny',
		8: 'color/reaction-wonder',
		9: 'color/reaction-angry',
		10: 'color/reaction-party',
		15: 'color/reaction-face_palm',
		14: 'color/reaction-handshake',
		12: 'color/reaction-sadly',
		11: 'color/reaction-award',
		16: 'color/reaction-flames',
		13: 'color/reaction-begging_you',
	},

	regex_remove_class: /(\s|\b)st\d+\b/g,

	template: function(params, format) {

		let template = 'reactions';

		const arr_like = Object.entries(params.likes).sort((a, b) => b[1].length - a[1].length);

		let render_params = {
			has_data: arr_like.length > 0,
			likes: [],
			like_users: [],
		};

		arr_like.forEach(([id_like, ids_user]) => {
			const user_names = {};
			const user_avatars = {};

			ids_user.forEach((id_user) => {
				if (App.team[id_user]) {
					user_names[id_user] = App.team[id_user].name;
					user_avatars[id_user] = App.team[id_user].avatar;
					render_params.like_users.push({
						is_me: parseInt(id_user) === parseInt(App.me.id),
						id_like: id_like,
						symbol: App.components.task_reactions.list_symbol[id_like],
						name: user_names[id_user],
						avatar: user_avatars[id_user]
					});
				}
			});

			const avatars = Object.values(user_avatars).slice(0, 5).join('') + (Object.values(user_avatars).length > 5 ? '<span class="more">+' + (Object.values(user_avatars).length - 5) + '</span>' : '');

			render_params.likes.push({
				id: id_like,
				symbol: App.components.task_reactions.list_symbol[id_like],
				active: ids_user.includes(App.me.id),
				count: ids_user.length,
				hint: ids_user.length ? App.helper.html.encode(Object.values(user_names).join('\n')) : '',
				avatars
			});
		});

		const positions = {};
		App.reactions.forEach((id, index) => {
			positions[id] = index;
		});

		render_params.likes.sort((a, b) => {
			const countA = a.count;
			const countB = b.count;

			if (countA > 1 && countB > 1) {
				if (countA !== countB) {
					return countB - countA;
				}
			} else if (countA > 1) {
				return -1;
			} else if (countB > 1) {
				return 1;
			}

			const idA = parseInt(a.id);
			const idB = parseInt(b.id);
			return positions[idA] - positions[idB];
		});

		template = App.helper.template.get_cached(template, format);
		template = template.trim().replace(/\s+/g, ' ');
		if (!template) return '';
		return App.helper.template.fill(template, render_params);
	},

	redraw: function(el, data) {
		if (data) el.tpl_data = data;
		let new_html = this.template(el.tpl_data, el.tpl_format);
		if (App.components.helper_need_update(new_html, el.innerHTML)) {
			el.innerHTML = new_html;
		}
	},

	onBoot: function() {
		let component = this;
		customElements.define(this.tag_name, class extends HTMLElement {
			constructor() {
				super();
				App.components.register_in.call(this, component, ONLY_JS_RENDERING);
			}
		});

		App.bus.state.on('task_like', function ({id,data}) {
			App.components.task_reactions.list_by_object[id]?.forEach((el) => {
				if (el.tpl_data.id_comment) return;
				if (data.remove) {
					if (data.id in el.tpl_data.likes) {
						el.tpl_data.likes[data.id] = el.tpl_data.likes[data.id].filter((i) => parseInt(i) !== parseInt(data.id_user));
					}
					if (!el.tpl_data.likes[data.id].length) delete(el.tpl_data.likes[data.id]);
				} else {
					if (!(data.id in el.tpl_data.likes)) el.tpl_data.likes[data.id] = [];
					el.tpl_data.likes[data.id].push(data.id_user);
				}
				App.components.task_reactions.redraw(el);
			});
		});
	},

	destructor: function(component) { // `this` is element
		App.components.unregister_in.call(this, component);
	},
}

;/** <task-reminder-term> component **/
App.components.task_reminder_terms = {

	tag_name: 'task-reminder-term',
	list_by_object: {},
	list_all: [],

	redraw: function(el, data) {
		if (data) el.tpl_data = data;
		el.tpl_data.date = 1 * el.tpl_data.date;
		el.tpl_data.time = 1 * el.tpl_data.time;
		let time_diff = el.tpl_data.date + 900 * el.tpl_data.time - App.helper.time.account();
		if (time_diff < 0) {
			this.destructor.call(el, this);
			$(el).parents('.reminderListing__item').remove();
			return false;
		}

		let date = new Date(el.tpl_data.date * 1000);
		let new_html = App.format.date(date, DATE_SCHEDULE_COMPACT) + ' ' + App.format.term_time(el.tpl_data.time);
		if (App.components.helper_need_update(new_html, el.innerHTML)) {
			el.innerHTML = new_html;
		}
	},

	redraw_all: function() {
		this.list_all.forEach((el) => this.redraw(el));
	},

	onLogin: function () {
		App.helper.cron.add('task_reminder_terms', () => this.redraw_all());
	},
	onLogout: function () {
		App.helper.cron.remove('task_reminder_terms');
	},

	onBoot: function() {
		let component = this;
		customElements.define(this.tag_name, class extends HTMLElement {
			constructor() {
				super();
				App.components.register_in.call(this, component);
			}
		});
	},

	destructor: function(component) { // `this` is element
		App.components.unregister_in.call(this, component);
	},
}

;/** <task-stage> component **/
App.components.task_stage = {

	tag_name: 'task-stage',
	list_by_object: {},
	list_all: [],
	inst: 0,

	regex_remove_class: /(\s|\b)st\d+\b/g,

	id_map: {
		0: 2,
	},

	template: function(params, format) {
		let template = 'stage';
		let id_stage = params.id;
		let id_tag = App.components.task_stage.id_map[params.id] ?? params.id;

		if (id_stage && (!App.tags[id_tag] || !App.tags_group[App.tags[id_tag].id_group].stage)) return '';
		if (id_stage === 0 && params.status) id_tag = 3;

		const render_params = {
			id: id_stage,
			status: params.status,
			name: App.tags[id_tag].name,
			color: App.tags[id_tag].color,
			stage: App.tags_group[App.tags[id_tag].id_group].stage ? 1 : 0,
			hidden: App.tags_group[App.tags[id_tag].id_group].hidden ? 1 : 0,
			class: App.tags_group[App.tags[id_tag].id_group].stage ? ' tag-stage' : (App.tags_group[App.tags[id_tag].id_group].hidden ? ' tag-hidden' : ''),
			percent_style: App.tags[id_tag].percent_style,
			icon: App.tags_type_icon[App.components.task_tags.inst][App.tags[id_tag].id_type],
			has_workflow: params.has_workflow || 0,
			backlog_color: App.tags[2].color, // TODO 2 to const?
			backlog_icon: App.tags_type_icon[App.components.task_tags.inst][App.tags[2].id_type], // TODO 2 to const?
			backlog_name: App.tags[2].name, // TODO 2 to const?
		};

		template = App.helper.template.get_cached(template, format);
		template = template.trim().replace(/\s+/g, ' ');
		if (!template) return '';

		return App.helper.template.fill(template, render_params);
	},

	redraw: function(el, data) {
		if (data) el.tpl_data = data;
		let new_html = this.template(el.tpl_data, el.tpl_format);
		if (App.components.helper_need_update(new_html, el.innerHTML)) {
			el.innerHTML = new_html;
		}
	},

	onBoot: function() {
		let component = this;
		customElements.define(this.tag_name, class extends HTMLElement {
			constructor() {
				super();
				App.components.register_in.call(this, component, ONLY_JS_RENDERING);
			}
		});

		App.bus.state.on('task_done', function ({id}) {
			App.components.update(component, id, {
				status: 1
			});
		}).on('task_undone', function ({id}) {
			App.components.update(component, id, {
				status: 0
			});
		}).on('task_status', function ({id,data}) {
			App.components.update(component, id, {
				id: data.id == 1 ? 0 : data.id // Correct backlog process
			});
		});
	},

	destructor: function(component) { // `this` is element
		App.components.unregister_in.call(this, component);
	},
}

;/** <task-tags> component **/
App.components.task_tags = {

	tag_name: 'task-tags',
	list_by_object: {},
	list_all: [],
	inst: 0,

	regex_remove_class: /(\s|\b)t\d+\b/g,

	template: function(params, format, filter) {

		let render_tags = [], render_params = {}, id_last_group = false, template = 'tags';

		render_params.tags = params.tags.filter(id_tag => id_tag in App.tags) // Visible for me
		render_params.tags = render_params.tags.sort(function(a, b) {
			return App.helper.sort.compare(App.tags_group[App.tags[a].id_group].order, App.tags_group[App.tags[b].id_group].order) || App.helper.sort.compare(App.tags[a].order, App.tags[b].order)
		});
		render_params.tags.forEach(function(id_tag) {
			if (filter !== 'none' && App.tags[id_tag].id_group != filter) return;
			let render_tag = {
				name: App.tags[id_tag].name,
				color: App.tags[id_tag].color,
				stage: App.tags_group[App.tags[id_tag].id_group].stage ? 1 : 0,
				hidden: App.tags_group[App.tags[id_tag].id_group].hidden ? 1 : 0,
				class: App.tags_group[App.tags[id_tag].id_group].stage ? ' tag-stage' : (App.tags_group[App.tags[id_tag].id_group].hidden ? ' tag-hidden' : ''),
				space: id_last_group !== false && id_last_group !== App.tags[id_tag].id_group ? '<em></em>' : ''
			};
			if (App.tags_group[App.tags[id_tag].id_group].stage) {
				render_tag.percent_style = App.tags[id_tag].percent_style;
				render_tag.icon = App.tags_type_icon[App.components.task_tags.inst][App.tags[id_tag].id_type];
			}
			render_tags.push(render_tag);
			id_last_group = App.tags[id_tag].id_group;
		});
		render_params.tags = render_tags;

		if (format === 'subtask' && App.device.is_sm_width()) {
			render_params.tags = render_params.tags.slice(0, 5);
		}

		template = App.helper.template.get_cached(template, format);
		template = template.trim().replace(/\s+/g, ' ');
		if (!template) return '';

		return App.helper.template.fill(template, render_params);
	},

	redraw: function(el, data) {
		if (data) el.tpl_data = data;
		let new_html = this.template(el.tpl_data, el.tpl_format, el.tpl_filter);
		if (App.components.helper_need_update(new_html, el.innerHTML)) {
			el.innerHTML = new_html;
		}
	},

	onBoot: function() {
		let component = this;
		customElements.define(this.tag_name, class extends HTMLElement {
			constructor() {
				super();
				App.components.register_in.call(this, component, ONLY_JS_RENDERING);
			}
		});

		App.bus.state.on('task_tag', function ({id,data}) {
			App.components.task_tags.list_by_object[id]?.forEach((el) => {
				el.tpl_data.tags = data.tags;
				App.components.task_tags.redraw(el);
			});
		});
	},

	destructor: function(component) { // `this` is element
		App.components.unregister_in.call(this, component);
	},
}

;/** <task-term> component **/
App.components.task_terms = {

	tag_name: 'task-term',
	list_by_object: {},
	list_all: [],

	list_task_classes: {
		'burning': 2,
		'deadline': 1,
		'today': 7,
		'tomorrow': 8,
		'next_week': 9,
		'next_month': 30,
		'started': 3,
		'awaiting': 4,
		'no_duedate': 18,
		'regular': 31,
		// ------------------------
		'completed': 13,
		'completed_today': 40,
		'completed_yesterday': 41,
		'this_week': 42,
		'this_month': 43,
		'with_delay': 14,
		'on_time': 52
	},

	regex_remove_class: /(\s|\b)p(1|2|3|4|7|8|9|18|30|31|13|40|41|42|43|14|52)\b/g,
	regex_remove_class_undone: /(\s|\b)p(1|2|3|4|7|8|9|18|30|31)\b/g,

	list_class_helper: function(i) {
		return ' p' + i;
	},
	is_hot: function ({dateend, timeend, status, dateclose}) {
		return dateend && !dateclose && App.components.task_terms.calculate_time_diff({dateend, timeend, status}) < 0;
	},
	calculate_time_diff: function({dateend, timeend, status}) {
		return status ? 0 : dateend + (timeend ? timeend * 900 : App.config.day_end) - App.helper.time.account()
	},
	template: function(params, format, id) {
		params = {...params};
		params.id = id;
		const time_diff = App.components.task_terms.calculate_time_diff({dateend: params.dateend, timeend: params.timeend, status: params.status});
		const is_hot = App.components.task_terms.is_hot({dateend: params.dateend, timeend: params.timeend, status: params.status})
		params.time_diff = time_diff;
		params.time_diff_start = params.status ? 0 : params.datestart + (params.timestart ? params.timestart * 900 : App.config.day_start) - App.helper.time.account();
		params.time_diff_max = params.time_diff_start < 0 && params.datestart ? params.time_diff - params.time_diff_start : 6 * 86400;
		params.terms = params.terms_end = params.dateend ? App.format.terms_from_inputs_data({
			dateend: params.dateend ? App.helper.date.to_input(new Date((params.dateend + App.config.date_timestamp_offset)  * 1000)) : '',
			datestart: params.datestart ? App.helper.date.to_input(new Date((params.datestart + App.config.date_timestamp_offset) * 1000)) : '',
			timeend: params.timeend ? App.format.term_time(params.timeend) : '',
			timestart: params.timestart ? App.format.term_time(params.timestart) : '',
		}) : '';
		if (params.terms.indexOf(' &mdash;') !== -1) [params.terms_start, params.terms_end] = params.terms.split(' &mdash;');
		if (format === 'class') {
			let className = '';
			if (!params.dateend) className += App.components.task_terms.list_class_helper(App.components.task_terms.list_task_classes['no_duedate']);
			else {
				if (is_hot) className += App.components.task_terms.list_class_helper(App.components.task_terms.list_task_classes['burning']);
				else if (params.time_diff < 6 * 86400) className += App.components.task_terms.list_class_helper(App.components.task_terms.list_task_classes['deadline']);
				if (params.dateend === App.helper.customDate.get('today')) className += App.components.task_terms.list_class_helper(App.components.task_terms.list_task_classes['today']);
				if (params.dateend === App.helper.customDate.get('tomorrow')) className += App.components.task_terms.list_class_helper(App.components.task_terms.list_task_classes['tomorrow']);
				if (params.dateend >= App.helper.customDate.get('week') && params.dateend < App.helper.customDate.get('week_next')) className += App.components.task_terms.list_class_helper(App.components.task_terms.list_task_classes['next_week']);
				if (params.dateend >= App.helper.customDate.get('month') && params.dateend < App.helper.customDate.get('month_next')) className += App.components.task_terms.list_class_helper(App.components.task_terms.list_task_classes['next_month']);
			}
			if (params.is_related || (params.datestart && params.datestart > App.helper.time.today_account())) className += App.components.task_terms.list_class_helper(App.components.task_terms.list_task_classes['awaiting']);
			else className += App.components.task_terms.list_class_helper(App.components.task_terms.list_task_classes['started']);
			if (params.is_repeat) className += App.components.task_terms.list_class_helper(App.components.task_terms.list_task_classes['regular']);
			return className;
		} else {
			if (params.is_related) {}
			else if (params.datestart && params.timestart && params.time_diff_start > 0) params.wait = 1;
			else if (params.datestart && !params.timestart && params.datestart > App.helper.customDate.get('today')) params.wait = 1;
			else if (params.dateend && Math.abs(params.time_diff) >= 60) {
				if (is_hot) params.hot = 1;
				else if (params.dateend === App.helper.customDate.get('today')) params.today = 1;
				else if (params.dateend === App.helper.customDate.get('tomorrow')) params.tomorrow = 1;
				else if (params.time_diff < 6 * 86400) params.warm = 1;
				else params.normal = 1;
			}

			if (params.hot) {
				let hint_terms = params.terms_start ? App.object_state.locale.terms.range + ': ' + params.terms_start + ' &mdash;' + params.terms_end : App.object_state.locale.terms.due + ': ' + params.terms_end;
				params.hint = '%R' + App.format.time_diff(Math.abs(params.time_diff), false) + ' ' + App.object_state.locale.terms.overdue + 'R%%NL%' + '%G' + hint_terms + 'G%';
			} else if (params.today) {
				params.hint = '%Y' + App.object_state.locale.terms.due + ': ' + App.object_state.locale.today + 'Y%';
			} else if (params.tomorrow) {
				params.hint = '%V' + App.object_state.locale.terms.due + ': ' + App.object_state.locale.tomorrow + 'V%';
			} else if (params.warm) {
				let hint_terms = params.terms_start ? App.object_state.locale.terms.range + ': ' + params.terms_start + ' &mdash;' + params.terms_end : App.object_state.locale.terms.due + ': ' + params.terms_end;
				params.hint = '%V' + App.format.time_diff(Math.abs(params.time_diff), true) + ' ' + 'V%%NL%' + '%G' + hint_terms + 'G%';
			} else {
				params.hint = '';
			}
		}

		let template = App.helper.template.get_cached('terms', format);
		template = template.trim().replace(/\s+/g, ' ');
		if (!template) return '';

		return App.helper.template.fill(template, params);
	},

	redraw: function(el, data) {
		if (data) el.tpl_data = data;
		let new_html = this.template(el.tpl_data, el.tpl_format, $(el).attr('data-task'));
		if (App.components.helper_need_update(new_html, el.innerHTML)) {
			el.innerHTML = new_html;
		}
	},

	get_task_terms_class: function(task_data) {
		return task_data.class.replace(App.components.task_terms.regex_remove_class_undone, '') + App.components.task_terms.template(App.helper.object.clone(task_data), 'class');
	},

	redraw_all: function() {
		this.list_all.forEach((el) => this.redraw(el));

		if (App.page?.data?.task && App.page?.integrity_check) {
			const task = App.page.data.task;
			for (let id in task) if (App.page.integrity_check(id)) {
				App.page.data.update('task', id, {
					class: App.components.task_terms.get_task_terms_class(task[id])
				});
			}
		}
	},

	onBoot: function() {
		let component = this;
		customElements.define(this.tag_name, class extends HTMLElement {
			constructor() {
				super();
				App.components.register_in.call(this, component, ONLY_JS_RENDERING);
			}
		});

		App.bus.state.on('task_terms', function ({id,data}) {
			let component_data = {};
			['dateadd', 'datestart', 'dateend', 'timeend', 'timestart', 'time_diff', 'is_related', 'related_from', 'is_repeat', 'repeat_ico'].forEach((i) => component_data[i] = data[i]);
			App.components.task_terms.list_by_object[id]?.forEach((el) => App.components.task_terms.redraw(el, component_data));
		}).on('task_done', function ({id}) {
			App.components.task_terms.list_by_object[id]?.forEach((el) => {
				el.tpl_data.status = 1;
				App.components.task_terms.redraw(el);
			});
		}).on('task_undone', function ({id}) {
			App.components.task_terms.list_by_object[id]?.forEach((el) => {
				el.tpl_data.status = 0;
				App.components.task_terms.redraw(el);
			});
		});
	},

	onLogin: function () {
		App.helper.cron.add('task_terms', () => this.redraw_all());
	},
	onLogout: function() {
		App.helper.cron.remove('task_terms');
	},

	destructor: function(component) { // `this` is element
		App.components.unregister_in.call(this, component);
	},
}

;/** <task-timers> component **/
App.components.task_timers = {

	tag_name: 'task-timers',
	list_by_object: {},
	list_all: [],

	list_task_classes: {
		'active_timers': 12,
	},

	template: function(params, format) {
		let type = '', ids;

		ids = params.ids.split(',').filter((id) => !!id && id);
		params.users = ids.map((id) => App.helper.team(id, 'name')).join('\n');
		params.count = ids.length;
		params.show = ids.length > 0 && !(ids.length === 1 && ids[0] == App.me.id);

		let template = App.helper.template.get_cached('timers', format + (type ? '_' + type : ''));
		if (!template) return '';

		return App.helper.template.fill(template, params);
	},

	redraw: function(el, data) {
		if (data) el.tpl_data = data;
		let new_html = this.template(el.tpl_data, el.tpl_format);
		$(el).toggleClass('is_active', el.tpl_data.ids.split(',').filter((id) => !!id).length > 0);
		if (App.components.helper_need_update(new_html, el.innerHTML)) {
			el.innerHTML = new_html;
			App.components.emit_redraw(el);
		}
	},

	onBoot: function() {
		let component = this;
		customElements.define(this.tag_name, class extends HTMLElement {
			constructor() {
				super();
				App.components.register_in.call(this, component, ONLY_JS_RENDERING);
			}
		});

		// App.bus.state.on('task_timers', function ({id,data}) {
		// 	let ids;
		// 	App.components.task_timers.list_by_object[id]?.forEach((el) => {
		// 		ids = el.tpl_data.ids.split(',').filter((id) => !!id).map(Number);
		// 		if (data.add) ids.push(+data.add.id_user_from);
		// 		if (data.delete) ids = ids.filter((id) => id !== +data.delete.id_user_from);
		// 		el.tpl_data.ids = ids.join(',');
		//
		// 		App.components.task_timers.redraw(el);
		// 	});
		// });
	},

	destructor: function(component) { // `this` is element
		App.components.unregister_in.call(this, component);
	},
}

;/** <task-todos> component **/

App.components.task_todos = {

	tag_name: 'task-todos',
	list_by_object: {},
	list_all: [],
	inst: 0,


	list_task_classes: {
		'with_todos': 16,
	},

	regex_remove_class: /(\s|\b)p16\b/g,

	template: function(params, format) {

		let template = 'todos';

		let render_params = params;

		template = App.helper.template.get_cached(template, format);
		template = template.trim().replace(/\s+/g, ' ');
		if (!template) return '';
		return App.helper.template.fill(template, render_params);
	},

	redraw: function(el, data) {
		if (data) el.tpl_data = data;
		let new_html = this.template(el.tpl_data, el.tpl_format);
		if (App.components.helper_need_update(new_html, el.innerHTML)) {
			el.innerHTML = new_html;
		}
	},

	onBoot: function() {
		let component = this;
		customElements.define(this.tag_name, class extends HTMLElement {
			constructor() {
				super();
				App.components.register_in.call(this, component, ONLY_JS_RENDERING);
			}
		});

		// App.bus.state.on('task_todo', function ({id,data}) {
		//
		// });
	},

	destructor: function(component) { // `this` is element
		App.components.unregister_in.call(this, component);
	},
}

;/** <task-unseen> component **/
App.components.task_unseen = {

	tag_name: 'task-unseen',
	list_by_object: {},
	list_all: [],

	list_task_classes: {
		'new_comments': 11,
	},

	regex_remove_class: /(\s|\b)p11\b/g,

	template: function(params, format) {
		let type = '';

		if (params.id_user_mention > 0 && (!params.user_mention || params.user_mention.id != params.id_user_mention)) {
			const user_mention = App.helper.team(params.id_user_mention);
			params.user_mention = { avatar: user_mention.avatar, name: user_mention.name };
		}

		params.class = (params.count ? 'unseen' : 'seen') + (params.has_mention ? ' has_mention' : '');
		params.vis = !!params.count;
		if (!params.dt_max) params.class += ' seenh seen_empty';
		else {
			let dt = new Date((params.dt_max + App.config.date_timezone_offset) * 1000);
			if (dt.getTime() >= App.helper.date.today().getTime()) {
				params.class = 'seen_today ' + params.class;
				params.vis = true;
			} else if (dt.getTime() >= App.helper.date.today().getTime() - 86400 * 1000) {
				params.class = 'seen_yesterday ' + params.class;
				params.vis = true;
			} else if (!params.count) params.class += ' seenh';
		}

		let template = App.helper.template.get_cached('unseen', format + (type ? '_' + type : ''));
		if (!template) return '';

		return App.helper.template.fill(template, params).trim();
	},

	redraw: function(el, data) {
		if (data) el.tpl_data = data;
		let new_html = this.template(el.tpl_data, el.tpl_format);
		if (App.components.helper_need_update(new_html, el.innerHTML)) {
			el.innerHTML = new_html;
		}
	},

	redraw_all: function() {
		this.list_all.forEach((el) => this.redraw(el));
	},

	onLogin: function () {
		App.helper.cron.add('task_unseen', () => this.redraw_all());
	},
	onLogout: function () {
		App.helper.cron.remove('task_unseen');
	},

	onBoot: function() {
		let component = this;
		customElements.define(this.tag_name, class extends HTMLElement {
			constructor() {
				super();
				App.components.register_in.call(this, component, ONLY_JS_RENDERING);
			}
		});

		App.bus.state.on('task_clear', function ({id,data}) {
			if (data.type === 'comment') {
				App.components.update(component, id, {
					count: 0
				});
			}
		}).on('task_read', function ({id,data}) {
			App.components.update(component, id, {
				id_seen: data.id_seen,
				count: data.cnt_new,
				has_mention: data.has_mention,
				id_user_mention: data.id_user_mention,
			});
		});
	},

	destructor: function(component) { // `this` is element
		App.components.unregister_in.call(this, component);
	},
}

;/** <task-wait> component **/
App.components.task_wait = {
	tag_name: 'task-wait',
	objects: [],

	redraw: function() {
		if (App.components.task_wait.objects.length === 0) {
			App.helper.cron.remove('task_wait_redraw');
			return;
		}

		const thisTime = App.helper.time.now();
		App.components.task_wait.objects.forEach(function (el) {
			let o = $(el);
			if (!o.attr('data-wait-start')) o.attr('data-wait-start', thisTime);
			if (thisTime - o.attr('data-wait-start') >= o.attr('data-wait')) {
				while ($('#' + o.attr('id') + 'menu').length) $('#' + o.attr('id') + 'menu').remove();
				if (o.parent().hasClass('notify_block')) o.next().show();
				o.parent().parent().parent().filter('.in').find('.icons-waitPub').hide().next().show().prev().remove();
				o.each(App.components.task_wait.destructor).remove();
				if (o.attr('data-teleport-time')) $(o.attr('data-teleport-time')).html('00:00').hide();
			} else {
				let dif = o.attr('data-wait') - thisTime + 1 * o.attr('data-wait-start');
				let is_seconds = dif <= 300 || o.hasClass('wait_seconds');
				if (is_seconds) {
					let tm_str = App.format.time_to_MMSS(dif);
					o.removeClass('wait_long').html(tm_str).attr('data-title', o.attr('data-text') + ' %G' + tm_str + 'G%');
					if (App.hint.is_shown() && App.hint.el == el) {
						$('#hint .in').html(o.attr('data-title')
							.replace(/%G(.*?)G%/gm, '<span>$1</span>')
							.replace(/%R(.*?)R%/gm, '<span class="red">$1</span>')
							.replace(/%B(.*?)B%/gm, '<b>$1</b>')
							.replace(/%Y(.*?)Y%/gm, '<span class="yellow">$1</span>')
							.replace(/\\n/g, "\n")
							.replace('%UP%', '<span class="ico ico_levelupw"></span>')
						)
					}
				} else {
					o.addClass('wait_long');
				}

				if (o.attr('data-teleport-time')) $(o.attr('data-teleport-time')).html(App.format.time_to_MMSS(dif));
			}
		});
	},

	constructor: function (el) {
		App.components.task_wait.objects.push(el);
		App.helper.cron.add_if_not_exists('task_wait_redraw', App.components.task_wait.redraw, 1);
	},

	destructor: function () { // `this` is element
		App.components.task_wait.objects = App.components.task_wait.objects.filter((el) => el !== this);
	},

	onBoot: function() {
		customElements.define(this.tag_name, class extends HTMLElement {
			constructor() {
				super();
				App.components.task_wait.constructor(this);
			}
		});
	},

	onLogout: function() {
		App.helper.cron.remove('task_wait_redraw');
	}
}

;/** <team-timer> component **/
App.components.team_timer = {

	tag_name: 'team-timer',
	list_all: [],

	template: function(params, format) {

		let template = App.helper.template.get_cached('team_timer', format);
		if (!template) return '';

		// поки дата провайдер це інший компонент
		let data = App.team_timers.data;
		let cnt = Object.keys(App.team_timers.data).length;
		let over = '';
		let dt = new Date().getTime();

		for (let id_user in data) {
			if (data[id_user].time + Math.floor((dt - data[id_user].dt) / 1000) > TIMER_ALERT) {
				over = 'alert';
			} else if (data[id_user].time + Math.floor((dt - data[id_user].dt) / 1000) > TIMER_WARNING) {
				over ||= 'warning';
			}
		}

		params = {
			cnt, over,
			is_work_time: App.work_time.state,
			is_menu_shown: App.mymenu.is_shown('costs'),
		};


		if (App.helper.template.debug) console.log('template', template);
		return App.helper.template.fill(template, params);
	},

	redraw: function(el, data) {
		if (data) el.tpl_data = data;
		let new_html = this.template(el.tpl_data, el.tpl_format);
		if (App.helper.template.debug) console.log('new_html', new_html);
		if (App.components.helper_need_update(new_html, el.innerHTML)) {
			el.innerHTML = new_html;
		}
	},

	redraw_all: function() {
		this.list_all.forEach((el) => this.redraw(el));
	},

	onBoot: function() {
		let component = this;
		customElements.define(this.tag_name, class extends HTMLElement {
			constructor() {
				super();
				App.components.register_in.call(this, component, ONLY_JS_RENDERING);
			}
		});

		App.bus.app.on('work_time', () => {
			this.redraw_all();
		});
	},

	destructor: function(component) { // `this` is element
		App.components.unregister_in.call(this, component);
	},
}

;/** <user-last-seen> component **/
App.components.user_last_seen = {

	tag_name: 'user-last-seen',
	list_by_object: {},
	list_all: [],

	template: function(params, format) {
		params.dateact = parseInt(params.dateact);

		if (params.dateact > 0) {
			params.diff = App.helper.time.account() - params.dateact;

			if (params.diff >= 86400 * 30) params.very_long_ago = 1;
			else if (params.diff >= 86400 * 7) params.long_ago = 1;
			else params.recent = 1;
		}

		let template = App.helper.template.get_cached('last_seen', format);
		template = template.trim().replace(/\s+/g, ' ');
		if (!template) return '';

		return App.helper.template.fill(template, params);
	},

	redraw: function(el, data) {
		if (data) el.tpl_data = { can_view: el.tpl_data.can_view, ... data };
		let new_html = this.template(el.tpl_data, el.tpl_format);
		if (App.components.helper_need_update(new_html, el.innerHTML)) {
			el.innerHTML = new_html;
		}
	},

	redraw_all: function() {
		this.list_all.forEach((el) => this.redraw(el));
	},

	onLogin: function () {
		App.helper.cron.add('user_last_seen', () => this.redraw_all());
	},
	onLogout: function () {
		App.helper.cron.remove('user_last_seen');
	},

	onBoot: function() {
		let component = this;
		customElements.define(this.tag_name, class extends HTMLElement {
			constructor() {
				super();
				App.components.register_in.call(this, component, ONLY_JS_RENDERING);
			}
		});
	},

	destructor: function(component) { // `this` is element
		App.components.unregister_in.call(this, component);
	},

	helper_update_by_object: function (id, dateact) {
		if (id == null || id === 0 || dateact == null) return;

		App.components.user_last_seen.list_by_object[id]?.forEach((el) => App.components.user_last_seen.redraw(el, { 'dateact': dateact }));
	},
}

;/** <user-name> component **/

App.components.user_name = {

	tag_name: 'user-name',
	list_by_object: {},
	list_all: [],

	template: function (params, format) {
		return App.format.user_name(params, format);
	},

	redraw: function (el, data) {
		if (data) el.tpl_data = data;
		let new_html = this.template(el.tpl_data, el.tpl_format);
		if (App.components.helper_need_update(new_html, el.innerHTML)) {
			el.innerHTML = new_html;
		}
	},

	onBoot: function() {
		let component = this;
		customElements.define(this.tag_name, class extends HTMLElement {
			constructor() {
				super();
				App.components.register_in.call(this, component);
			}
		});

		App.bus.state.on('user_update', function({id, data}) {
			let component_data = {};
			['fname', 'lname', 'login'].forEach((i) => { if (i in data) component_data[i] = data[i]; });
			App.components.user_name.list_by_object[id]?.forEach((el) => App.components.user_name.redraw(el, component_data));
		});
	},

	destructor: function (component) { // `this` is element
		App.components.unregister_in.call(this, component);
	},

	redraw_by_ref: function(target, field, id, data) {
		const new_name = App.format.user_name(data);
		target.list_all.forEach(el => {
			if (+el.getAttribute('data-ref-user') !== id) return;
			el.tpl_data[field] = new_name;
			target.redraw(el);
		});
	},
}

;/** <user-topic-status> component **/
App.components.user_topic_status = {
    tag_name: 'user-topic-status',
    list_by_object: {},
    list_all: [],

    // Build template for given params
    template: function (params, format) {
        // find template in DOM
        let template = App.helper.template.get_cached('topic_status', format);
        template = (template || '').trim().replace(/\s+/g, ' ');
        if (!template) return '';

        return App.helper.template.fill(template, params);
    },

    // Redraw element with new data
    redraw: function (el, data) {
        if (data) el.tpl_data = {...(el.tpl_data || {}), ...data};
        let new_html = this.template(el.tpl_data, el.tpl_format);
        if (App.components.helper_need_update(new_html, el.innerHTML)) {
            el.innerHTML = new_html;
        }
    },

    // Redraw all elements of this component
    redraw_all: function () {
        this.list_all.forEach((el) => this.redraw(el));
    },

    // Component registration
    onBoot: function () {
        let component = this;
        customElements.define(this.tag_name, class extends HTMLElement {
            constructor() {
                super();
                App.components.register_in.call(this, component, ONLY_JS_RENDERING);
            }
        });
    },

    // Cleanup
    destructor: function (component) {
        App.components.unregister_in.call(this, component);
    },

    // Update specific user id with new topic_status
    helper_update_by_object: function (id, data) {

        if (!id) return;
        this.list_by_object[id]?.forEach((el) =>
            this.redraw(el, data)
        );
    },
};

;class WsForm extends RenderableComponent {
	/**
	 * @private {FormInstance}
	 */
	_form
	/**
	 * @returns {LifecycleLayer}
	 */
	static defineLifecycle() {
		/**
		 * @this {WsForm}
		 */
		return function ({once}) {
			once('mount:before', () => {
				this._form = App.helper.useForm({
					onSubmit: (values) => {
						const prevented = this.emitEvent('submit', {values});

						!prevented && $.ajax({
							type: this.prop('method', 'POST'),
							url: this.prop('endpoint'),
							data: values,
							dataType: this.prop('dataType'),
							success: (response) => {
								this.emitEvent('form:success', {response: response});
							},
							error: (response) => {
								this.emitEvent('form:error', {response: response});
							}
						})
					},
					initialValues: this.propJson('initial', {})
				});
				this._form.subscribe(() => this.invalidateLifecycle('form:change'));
			})
		}
	}
	provides() {
		return {
			form: () => this._form,
		}
	}

	templateContext() {
		return {
			form: this._form,
			values: Object.create(this._form.values),
		};
	}

	onSubmit () {
		this._form.submit();
	}


	template() {
		return `
		<self ws-host-delegated-on-change="onChange" class="display_contents">
		<slot></slot>
		<slot name="submit" ws-on-click="onSubmit"></slot>
		</self>
		`
	}


}

App.components.ws_form =  {
	onBoot() {
		customElements.define('ws-form', WsForm);
	}
}

;/*
Базове використання:
<ws-app-logo></ws-app-logo>
<ws-app-logo theme="light"></ws-app-logo>
<ws-app-logo theme="dark"></ws-app-logo>
<ws-app-logo device="desktop"></ws-app-logo>
<ws-app-logo device="mobile"></ws-app-logo>
<ws-app-logo fallback="false"></ws-app-logo>
<ws-app-logo theme="dark" device="desktop"></ws-app-logo>
*/
App.components.ws_app_logo = {

	tag_name: 'ws-app-logo',

	onBoot: function() {
		customElements.define('ws-app-logo', class extends HTMLElement {

			static get observedAttributes() {
				return [
					'theme',
					'device',
					'fallback',

					'width',
					'height'
				];
			}

			constructor() {
				super();
				this.connected = false;
				this.rendered = false;
			}

			attributeChangedCallback(name, oldValue, newValue) {
				if (oldValue !== newValue && this.connected) {
					this.render();
				}
			}

			connectedCallback() {
				if (!this.rendered) {
					this.render();
					this.rendered = true;
					this.connected = true;
				}
			}

			disconnectedCallback() {
				this.connected = false;
			}

			getAttr(name, def = null) {
				return this.hasAttribute(name) ? this.getAttribute(name) : def;
			}

			isPhotoLogo(html) {
				const match = typeof html === 'string' && html.match(/<img[^>]+src\s*=\s*["']([^"']+)["']/i);
				if (!match) return false;

				const src = match[1].toLowerCase();
				return /\.jpg(\?|$)/i.test(src);
			}

			render() {
				const theme = this.getAttr('theme') || (App.core.theme.dark ? 'dark' : 'light');
				const device = this.getAttr('device') || (App.device.is_mobile() ? 'mobile' : 'desktop');
				const allow_fallback = this.getAttr('fallback', 'true') !== 'false';

				let html = null;

				if (App.logos[theme]) {
					html = App.logos[theme];
				}
				else if (
					theme === 'light'
					&& device === 'mobile'
					&& App.logos['dark']
					&& this.isPhotoLogo(App.logos['dark'])
				) {
					html = App.logos['dark'];
				}
				else if (allow_fallback) {
					const device_default_key = device !== 'desktop' ? device + '_default' : 'default';
					html = App.logos[device_default_key];
				}

				if (!html) {
					this.classList.add('empty');
					this.innerHTML = '';
				} else {
					this.classList.remove('empty');
					this.innerHTML = html;

					const inner = this.firstElementChild;
					if (inner) {
						for (const attr of this.attributes) {
							if (attr.name === 'width' || attr.name === 'height') {

								let attr_name = attr.name;
								let attr_value = attr.value;

								// якщо треба мати певний додатковий клас всередині вже при ініціалізації
								// поки не знадобилось
								// if (attr.name === 'proxy-class' && inner.hasAttribute('class')) {
								// 	attr_name = 'class';
								// 	if (inner._class === undefined) {
								// 		inner._class = inner.getAttribute('class');
								// 	}
								// 	attr_value = (inner._class+' '+attr.value).trim();
								// }

								inner.setAttribute(attr_name, attr_value);
							}
						}
					}
				}
			}
		});
	}
}

;App.components.ws_btn = {
	onBoot: function() {
		customElements.define("ws-btn", class extends HTMLElement {
			constructor() {
				super();
			}

			/**
			 * Returns the disabled state of the element.
			 * console.log('ws-btn-disabled', $('ws-btn').prop('disabled'));
			 *
			 * @return {boolean} True if the element is disabled, false otherwise.
			 */
			get disabled() {
				return this.hasAttribute('disabled');
			}

			/**
			 * Sets the disabled state of the element.
			 * $('ws-btn').toggleDisabled(false);
			 *
			 * @param {boolean} value - The new disabled state of the element.
			 */
			set disabled(value) {
				if (value) {
					this.setAttribute('disabled', '');
				} else {
					this.removeAttribute('disabled');
				}
			}

			render() {
				let clsArr = [];
				let btnDouble = false;
				let bg = this.getAttribute('bg') || '';
				let id = this.getAttribute('button-id') || '';
				let rel = this.getAttribute('rel') || '';
				let cls = this.getAttribute('name') || '';
				let text = this.getAttribute('text') || '';
				let onclick = this.getAttribute('button-onclick') || '';
				let disabled = this.getAttribute('disabled');
				let leftIcon = this.getAttribute('left-icon') || '';
				let rightIcon = this.getAttribute('right-icon') || '';
				let leftIconBox = this.getAttribute('left-icon-box') || '';
				let rightIconBox = this.getAttribute('right-icon-box') || '';
				let modalUrl = this.getAttribute('data-modal-url') || '';
				let modalTitle = this.getAttribute('data-modal-title') || '';
				let modalWidth = this.getAttribute('data-modal-width') || '';
				let modalBackup = this.getAttribute('data-modal-backup') || '';
				let modalLevel = this.getAttribute('data-modal-level') || '';
				let modalGroup = this.getAttribute('data-modal-group') || '';
				let dataBtn = this.getAttribute('data-btn') || '';
				let dataTitle = this.getAttribute('data-title') || '';
				let dataTitleConfig = this.getAttribute('data-title-config') || '';
				let autoBlur = this.getAttribute('auto-blur') === '';

				let tmp = cls.split(' ');
				if (!cls) return false;

				this.innerHTML = '';
				tmp.forEach(function(val) {
					if (val !== 'btn-double') {
						clsArr.push(val);
					} else {
						btnDouble = val;
					}
				});
				cls = clsArr.join(' ');
				if (bg) cls += ' ' + 'btn-bg';

				if (cls && cls.match(/btn-sum/)) {
					leftIcon = 'sum';
				} else if (cls && cls.match(/btn-timer/)) {
					leftIcon = 'stopwatch_parts:stopwatch_parts-rotation';
				} else if (cls && cls.match(/btn-time/)) {
					leftIcon = 'timer-play';
					rightIcon = 'chevron-right';
					//rightIconSprite = 'arrows';
				}
				if (cls && cls.match(/btn-money/)) {
					leftIcon = 'hour_hand';
					rightIcon = 'chevron-right';
					//rightIconSprite = 'arrows';
				}
				if (cls && (text || leftIcon || rightIcon)) {
					if (!btnDouble) {
						let buttonElem = document.createElement('button');
						buttonElem.setAttribute('type', 'button');
						buttonElem.setAttribute('class', cls);
						if (id) buttonElem.setAttribute('id', id);
						if (rel) buttonElem.setAttribute('rel', rel);
						if (modalUrl) buttonElem.setAttribute('data-modal-url', modalUrl);
						if (modalTitle) buttonElem.setAttribute('data-modal-title', modalTitle);
						if (modalWidth) buttonElem.setAttribute('data-modal-width', modalWidth);
						if (modalBackup) buttonElem.setAttribute('data-modal-backup', modalBackup);
						if (modalLevel) buttonElem.setAttribute('data-modal-level', modalLevel);
						if (modalGroup) buttonElem.setAttribute('data-modal-group', modalGroup);
						if (dataBtn) buttonElem.setAttribute('data-btn', dataBtn);
						if (dataTitle) buttonElem.setAttribute('data-title', dataTitle);
						if (dataTitleConfig) buttonElem.setAttribute('data-title-config', dataTitleConfig);
						for (let attr of this.attributes) {
							if (attr.name.startsWith('data-title-text-')) {
								buttonElem.setAttribute(attr.name, attr.value);
							}
						}
						if (disabled === null && onclick) buttonElem.setAttribute('onclick', onclick);
						if (disabled !== null) buttonElem.disabled = true;

						if (leftIcon) {
							if (leftIconBox === 'small') {
								leftIconBox = ' btn-box-small';
							} else if (leftIconBox === 'big') {
								leftIconBox = ' btn-box-big';
							} else {
								leftIconBox = '';
							}
							buttonElem.innerHTML += '<ws-icon class="btn-left-icon'+ leftIconBox +'" name="'+leftIcon+'"></ws-icon>';
						}
						if (text) {
							let textElem = document.createElement('span');
							textElem.innerText = (text == null ? '' : text).toString().trim().replace(/\s+/g, ' ');
							buttonElem.appendChild(textElem);
						}
						if (rightIcon) {
							if (rightIconBox === 'small') {
								rightIconBox = ' btn-box-small';
							} else if (rightIconBox === 'big') {
								rightIconBox = ' btn-box-big';
							} else {
								rightIconBox = '';
							}
							buttonElem.innerHTML += '<ws-icon class="btn-right-icon'+ rightIconBox +'" name="'+rightIcon+'"></ws-icon>';
						}
						this.appendChild(buttonElem);
					} else if ((text || leftIcon) && rightIcon) {
						let div = document.createElement('div');
						let button1 = document.createElement('button');
						let button2 = document.createElement('button');
						let onclick1 = this.getAttribute('left-button-onclick') || '';
						let onclick2 = this.getAttribute('right-button-onclick') || '';
						if (onclick1) button1.setAttribute('onclick', onclick1);
						if (onclick2) button2.setAttribute('onclick', onclick2);
						if (disabled !== null) {
							button1.disabled = true;
							button2.disabled = true;
						}
						if (rightIconBox === 'small') {
							rightIconBox = ' btn-box-small';
						} else if (rightIconBox === 'big') {
							rightIconBox = ' btn-box-big';
						} else {
							rightIconBox = '';
						}

						div.setAttribute('class', btnDouble);
						button1.setAttribute('class', cls);
						button2.setAttribute('class', cls);
						button1.setAttribute('type', 'button');
						button2.setAttribute('type', 'button');
						button2.innerHTML += '<ws-icon class="btn-right-icon'+ rightIconBox +'" name="'+rightIcon+'"></ws-icon>';
						if (leftIcon) {
							if (leftIconBox === 'small') {
								leftIconBox = ' btn-box-small';
							} else if (leftIconBox === 'big') {
								leftIconBox = ' btn-box-big';
							} else {
								leftIconBox = '';
							}
							button1.innerHTML += '<ws-icon class="btn-left-icon'+ leftIconBox +'" name="'+leftIcon+'"></ws-icon>';
						}
						if (text) {
							let textElem = document.createElement('span');
							textElem.innerHTML = text;
							button1.appendChild(textElem);
						}
						div.appendChild(button1);
						div.appendChild(button2);
						this.appendChild(div);
					}
				}
			}
			static get observedAttributes() {
				return ["name", "text", "left-icon", "right-icon", "disabled", "left-icon-box", "right-icon-box", "data-title"];
			}
			connectedCallback() {
				if (!this.rendered) {
					this.render();
					this.rendered = true;
					this.connected = true;
				}
			}
			attributeChangedCallback() {
				if (this.connected) {
					this.render();
				}
			}
		});
	}
}

$(document).on('click', 'ws-btn[data-copy-val]', function (e) {
	let item = $(this);
	let val = item.attr('data-copy-val');

	if (!val || !val.trim()) return;

	App.core.clipboard(val);
	item.copySuccessIcon();
});
$(document).on('mouseup', function (e) {
	$(e.target).closest('ws-btn[auto-blur]').find('button').blur()
})

/**
 * Отримати розмір КОНКРЕТНОЇ кнопки:
 *     $('ws-btn').first().ws_btn('get_size');
 * Встановити розмір колекції кнопок:
 *     const collection = self.obj_window.find('.container').find('ws-btn, .btn');
 *     // просто:
 *     collection.ws_btn('set_size', 48);
 *     // з колбеком:
 *     collection.ws_btn('set_size', function (index, size, element) { console.log('current size: ', size); return 48; });
 * @param {'get_size'|'set_size'} method
 * @param {*} options
 * @returns
 * @todo треба перевірити роботу з ws-btn без name, коли пара .btn вкладено всередину вручну
 */
$.fn.ws_btn = function(method, options) {

	const _resolve_elements = function () {
		let ws_btn = null;
		let btns = null;
		if ($(this).is('ws-btn')) {
			ws_btn = $(this);
			btns = $(this).find('.btn');
		} else if ($(this).hasClass('btn')) {
			if ($(this).closest('ws-btn').length) {
				ws_btn = $(this).closest('ws-btn');
				btns = ws_btn.find('.btn');
			} else {
				btns = $(this);
			}
		}

		if (ws_btn && !ws_btn.attr('name')) {
			ws_btn = null;
		}

		return { ws_btn, btns };
	};

	const get_size = function () {

		if ($(this).length !== 1) {
			throw new Error('Expected exactly 1 element');
		}

		const { ws_btn, btns } = _resolve_elements.call(this);

		if (ws_btn) {
			const name_attr = ws_btn.attr('name') || '';
			const match = name_attr.match(/\bbtn-(\d+)\b/);
			return match ? parseInt(match[1]) : null;
		}

		if (btns) {
			const class_attr = btns.attr('class') || '';
			const match = class_attr.match(/\bbtn-(\d+)\b/);
			return match ? parseInt(match[1]) : null;
		}

		return null;
	};

	const set_size = function () {

		if (!options && options !== null) {
			throw new Error('Wrong configuration');
		}

		let new_size = null;
		let new_size_callback = null;
		if (typeof options === 'function') {
			new_size_callback = options;
		} else if (options && +options > 0) {
			new_size = +options;

			const allowed_sizes = [ 16, 20, 24, 28, 32, 36, 40, 48, 56 ];
			if (!allowed_sizes.includes(new_size)) {
				console.warn('Unknown size: ' + new_size, this);
			}
		} else if (options === null) {
			// remove btn-xx
		} else {
			throw new Error('Wrong configuration');
		}

		return this.each(function(index) {

			const { ws_btn, btns } = _resolve_elements.call(this);
			if (!ws_btn && !btns) throw new Error('Wrong selector?');

			const current_size = get_size.call(this);

			if (new_size_callback) {
				new_size = new_size_callback.call(this, index, current_size, ws_btn ?? btns);
			}

			// значить не змінювати
			if (new_size === false) return;

			if (ws_btn) {
				let name_attr = ws_btn.attr('name') || '';

				// прибираємо всі btn-XX
				name_attr = name_attr.replace(/\bbtn-(\d+)\b/g, '');

				// додаємо новий
				if (new_size) {
					name_attr = (name_attr + ' btn-' + new_size).trim().replace(/\s+/g, ' ');
				}

				ws_btn.attr('name', name_attr);

				return;
			}

			if (btns) {
				btns.each(function (this_index, this_btn) {

					this_btn = $(this_btn);

					let class_attr = this_btn.attr('class') || '';

					// прибираємо всі btn-XX
					class_attr = class_attr.replace(/\bbtn-(\d+)\b/g, '');

					// додаємо новий
					if (new_size) {
						class_attr = (class_attr + ' btn-' + new_size).trim().replace(/\s+/g, ' ');
					}

					this_btn.attr('class', class_attr);
				});

				return;
			}
		});
	};

	if (typeof method === 'string') {
		if (method === 'set_size') {
			return set_size.call(this);
		} else if (method === 'get_size') {
			return get_size.call(this);
		}
	}

	throw new Error('Unknown method: ('+(typeof method)+') '+method);
};
;App.components.ws_chart = {
	onBoot: function() {
		customElements.define("ws-chart", class extends HTMLElement {
			constructor() {
				super();
			}

			get its_padding() {
				let values = (this.getAttribute('padding') || '0').split(' ');

				if (values.length === 1) {
					let val = parseInt(values[0]);
					return { top: val, right: val, left: val, bottom: val }
				}

				if (values.length === 2) {
					let x = parseInt(values[0]);
					let y = parseInt(values[1]);
					return {top: y, right: x, left: x, bottom: y }
				}

				if (values.length === 4) {
					return {
						top: parseInt(values[0]), right: parseInt(values[1]),
						bottom: parseInt(values[2]), left: parseInt(values[3])
					}
				}

				return { top: 0, right: 0, left: 0, bottom: 0 }
			}

			render() {
				let canvas = document.createElement("canvas");
				this.chart_data = {
					ctx: canvas.getContext('2d'),
					maxValue: this.getAttribute('max') || 10,
					height: this.getAttribute('height') || 28,
					dataset: {
						data: this.getAttribute('data')?.split(',') || [0],
					}
				};
				let padding = this.its_padding;
				let maxDataValue = Math.max.apply(null, this.chart_data.dataset.data);

				this.chart_data.maxValueOffset = this.chart_data.maxValue * 1;
				this.chart_data.gradient = this.chart_data.ctx.createLinearGradient(
					0, this.chart_data.height * (this.chart_data.maxValueOffset - maxDataValue) / this.chart_data.maxValueOffset,
					0, this.chart_data.height
				);
				this.chart_data.gradient.addColorStop(0, App.colors.css_var('--CHART_TASKS_PLAN_BORDER'));
				this.chart_data.gradient.addColorStop(1, App.colors.css_var('--trans'));

				let borderColor = maxDataValue ? App.colors.css_var('--base-hlt-active') : App.colors.css_var('--base-line-secondary');
				let backgroundColor = App.colors.css_var('--base-hlt-hover'); //this.chart_data.gradient;
				this.chart_data.data = {
					labels: this.chart_data.dataset.data,
					datasets: [{
						clip: 10,
						data: this.chart_data.dataset.data,
						labelText: '',
						fill: true,
						backgroundColor: backgroundColor,
						borderColor: borderColor,
						borderWidth: 2,
						borderCapStyle: 'round',
						borderJoinStyle: 'round',
						pointRadius: 0,
						pointBackgroundColor: borderColor,
						pointHoverRadius: 4,
						pointHoverBorderWidth: 2,
						pointHoverBackgroundColor: App.colors.css_var('--base-cont-top'),
						snapGaps: true
					}]
				}
				this.chart_data.options = {
					scales: {
						x: {
							display: false,
							grid: {
								display: false,
								drawBorder: false
							},
							ticks: {
								display: false
							},
							offset: false
						},
						y: {
							display: false,
							grid: {
								display: false,
								drawBorder: false
							},
							ticks: {
								display: false
							},
							beginAtZero: true,
							min: 0,
							max: this.chart_data.maxValueOffset
						}
					},
					layout: {
						padding: padding
					},
					responsive: true,
					maintainAspectRatio: false,
					plugins: {
						legend: false,
						tooltip: {
							enabled: false,
							position: 'average',
							yAlign: 'bottom'
						}
					},
					interaction: {
						mode: 'index',
						intersect: false
					}
				}
				this.chart_data.chart = new Chart(this.chart_data.ctx, {
					type: 'line',
					data: this.chart_data.data,
					options: this.chart_data.options,
					plugins: [{
						afterDraw: (chart, args) => {
							// let ctx = chart.ctx;
							// let data = chart.getDatasetMeta(0).data;
							// let xTo = data[data.length - 1].x;
							// let yToday = data[data.length - 1].y;
							// ctx.save();
							//
							// data.forEach(function(point, i) {
							// 	let value = point.parsed.y;
							// 	let final = i === data.length - 1;
							// 	ctx.fillStyle = borderColor;
							// 	if (value || final) {
							// 		let draw = true;
							// 		if (chart.tooltip && chart.tooltip._active && chart.tooltip._active.length) {
							// 			let activePoint = chart.tooltip._active[0];
							// 			if (activePoint.element.x === point.x && activePoint.element.y === point.y) draw = false;
							// 		}
							//
							// 		if (draw) {
							// 			ctx.beginPath();
							// 			ctx.arc(point.x, point.y, final && value ? 4 : 2, 0, 2 * Math.PI);
							// 			ctx.fill();
							// 			if (final && value) {
							// 				ctx.beginPath();
							// 				ctx.fillStyle = App.colors.css_var('--base-cont-top');
							// 				ctx.arc(point.x, point.y, 2, 0, 2 * Math.PI);
							// 				ctx.fill();
							// 			}
							// 		}
							// 	}
							// });
							/*
							if (chart.tooltip && chart.tooltip._active && chart.tooltip._active.length) {
								let activePoint = chart.tooltip._active[0];
								ctx.beginPath();
								ctx.fillStyle = App.colors.css_var('--base-cont-top');
								ctx.arc(activePoint.element.x, activePoint.element.y, 3, 0, 2 * Math.PI);
								ctx.fill();


								ctx.beginPath();
								ctx.setLineDash([6, 5]);
								ctx.moveTo(activePoint.element.x, chart.chartArea.top);
								ctx.lineTo(activePoint.element.x, activePoint.element.y - 5);
								if (chart.chartArea.bottom !== chart.tooltip.caretY) {
									ctx.moveTo(activePoint.element.x, chart.chartArea.bottom);
									ctx.lineTo(activePoint.element.x, activePoint.element.y + 5);
								}
								ctx.lineWidth = 1;
								ctx.strokeStyle = 'grey';
								ctx.stroke();
								ctx.restore();
							}
							 */
						}
					}]
				});
				this.innerHTML = '';
				this.appendChild(canvas);
			}

			connectedCallback() {
				if (!this.rendered) {
					this.render();
					this.rendered = true;
				}
			}

			static get observedAttributes() {
				return ["data"];
			}

			attributeChangedCallback() {
				if (this.hasChildNodes()) {
					this.removeChild(this.firstChild);
					this.render();
				}
			}
		});
	}
}

;class WSCheckbox extends HasRefsMixin(HTMLElement) {

	render() {
		this.innerHTML = `
			<label class="inputCheckbox ${this.checked ? 'act' : ''}  ${this.labelClass}">
				<input
				data-ref="input"
				class="${this.inputClass}"
				type="checkbox"
				name="${this.name}"
				${this.checked ? 'checked' : ''}
				/>
				<span class="${this.iconClass}"><ws-icon name="${this.type}"></ws-icon></span>
			</label>
		`;

		this.ref('input').addEventListener('change', e => {
			if (this.ref('input').checked) {
				this.check();
			} else {
				this.uncheck();
			}
			this.dispatchEvent(new Event('change'));
		});
	}


	get type() {
		return this.hasAttribute('type') ? this.getAttribute('type') : 'checkbox';
	}

	get checked() {
		return this.hasAttribute('checked') && this.getAttribute('checked') !== 'false';
	}

	get inputClass() {
		return this.hasAttribute('input-class') ? this.getAttribute('input-class') : '';
	}

	get labelClass() {
		return this.hasAttribute('label-class') ? this.getAttribute('label-class') : '';
	}

	get iconClass() {
		return this.hasAttribute('icon-class') ? this.getAttribute('icon-class') : '';
	}

	get name() {
		return this.hasAttribute('name') ? this.getAttribute('name') : '';
	}

	check(silent = false) {
		this.setAttribute('checked', 'true');
		!silent && this.dispatchEvent(new CustomEvent('checked', { bubbles: true, composed: true, cancelable: false }));
	}

	uncheck(silent = false) {
		this.removeAttribute('checked');
		!silent && this.dispatchEvent(new CustomEvent('unchecked', { bubbles: true, composed: true, cancelable: false }));
	}

	toggle(silent = false) {
		if (this.checked) {
			this.uncheck(silent);
		} else {
			this.check(silent);
		}
	}

	connectedCallback() {
		this.render();
	}

	attributeChangedCallback() {
		this.render();
	}

	static get observedAttributes() {
		return [
			'type',
			'checked',
			'input-class',
			'label-class',
			'icon-class',
			'name'
		];
	}

}

App.components.ws_checkbox = {
	onBoot: function () {
		customElements.define("ws-checkbox", WSCheckbox);
	}
};
;App.components.ws_chip = {
	onBoot: function() {
		customElements.define("ws-chip", class extends HTMLElement {
			constructor() {
				super();
			}
			render() {
				let cls = this.getAttribute('name') || '';
				let text = this.getAttribute('text') || '';
				let leftIcon = this.getAttribute('left-icon') || '';
				let leftIconColor = this.getAttribute('left-icon-color') || '';
				let leftIconBox = this.getAttribute('left-icon-box') || '';
				let leftIconBoxColor = this.getAttribute('left-icon-box-color') || '';
				let rightIcon = this.getAttribute('right-icon') || '';
				let chevronIcon = this.getAttribute('chevron-icon') || '';
				let crossIcon = this.getAttribute('cross-icon') || '';
				let bg = this.getAttribute('bg-color') || '';

				if (!(cls && (text || leftIcon))) return false;

				this.innerHTML = '';

				if (bg) cls += ' ' + 'chip-bg-' + bg;

				let div = document.createElement('div');
				div.setAttribute('class', cls);

				if (leftIcon) {
					let leftIconCls = 'chip-left-icon';
					if (leftIconColor) leftIconCls += ' chip-left-icon-color-'+leftIconColor;
					if (leftIconBox === 'big') leftIconCls += ' chip-box-big';
					if (leftIconBoxColor) leftIconCls += ' chip-box-color-'+leftIconBoxColor;
					div.innerHTML += '<ws-icon name="' + leftIcon + '" class="' + leftIconCls + '"></ws-icon>';
				}

				if (text) {
					let textElem = document.createElement('span');
					textElem.innerHTML = text;
					div.appendChild(textElem);
				}

				if (rightIcon) {
					let hoverIcon = rightIcon.match(/:/);
					let rightIconCls = 'chip-right-icon';

					if (hoverIcon) rightIconCls += ' ' + 'withHover';
					if (rightIcon.match(/close/) || rightIcon.match(/cancel/)) rightIconCls += ' ' + 'delete';

					div.innerHTML += '<ws-icon name="' + rightIcon + '" class="' + rightIconCls + '"></ws-icon>';
				}

				if (chevronIcon) {
					div.innerHTML += '<ws-icon name="arrows/chevron_sm-down" class="chevron-attr"></ws-icon>';
				}

				if (crossIcon) {
					div.innerHTML += '<ws-icon name="close_sm" class="delete cross-attr"></ws-icon>';
				}

				this.appendChild(div);
			}

			static get observedAttributes() {
				return ["name", "text", "left-icon", "left-icon-color", "left-icon-box", "left-icon-box-color", "right-icon", "chevron-icon", "cross-icon", "bg-color"];
			}
			connectedCallback() {
				if (!this.rendered) {
					this.render();
					this.rendered = true;
					this.connected = true;
				}
			}
			attributeChangedCallback() {
				if (this.connected) {
					this.render();
				}
			}
		});
	}
}

;App.components.ws_code_input = {
	onBoot: function() {
		customElements.define("ws-code-input", class extends HTMLElement {

			get value() {
				return this.input.value;
			}

			constructor() {
				super();
				this.connected = false;
				this.rendered = false;
				this.input = null;
				this.inputs = []
			}

			connectedCallback() {
				if (!this.rendered) {
					this.render();
					this.rendered = true;
					this.connected = true;
				}
			}

			disconnectedCallback() {
				this.connected = false;
			}

			getAttr(name, def = null) {
				return this.hasAttribute(name) ? this.getAttribute(name) : def;
			}

			render() {

				const classes = {
					box: 'ws-code-input',
					input: 'ws-code-input__input',
				};

				const name = this.getAttr('name');
				const length = parseInt(this.getAttr('length'));
				const input_class = (classes.input+' '+this.getAttr('input-class', '')).trim();

				if (!name) throw new Error('`name` attribute is required');
				if (!length || isNaN(length)) throw new Error('`length` attribute must be a number');

				let html = `<div class="${classes.box}">`;
				// по W3C інпут має мати id або name
				// вибрав id, щоб не відправляти "сміття" на сервер
				// але id має бути унікальним, щоб запобігти дублювання
				const suffix = App.helper.random.string(5);
				for (let i = 0; i < length; i++) {
					html += `<input id="d${i}__${suffix}" type="text" inputmode="numeric" maxlength="${length + 1}" class="${input_class}" data-index="${i}" autocomplete="off" />`;
				}
				html += `</div>`;
				html += `<input type="hidden" name="${name}" />`;

				this.innerHTML = html;

				const inputs = this.inputs = Array.from(this.querySelectorAll('.'+classes.input));
				const hidden = this.querySelector(`input[type="hidden"][name="${name}"]`);

				this.input = hidden;

				const updateValue = (source) => {

					source ||= 'input';

					const code = inputs.map(el => el.value).join('');
					hidden.value = code;

					this.dispatchEvent(new CustomEvent('ws-code-input', {
						detail: {
							status: code.length === length,
							source,
							value: code,
						},
						bubbles: true,
						composed: true
					}));
				};

				inputs.forEach((input, i) => {

					const processPaste = (raw_val, filtered_val) => {
						if (raw_val.length !== filtered_val.length || filtered_val.length !== length) {
							this.clearValue();
							updateValue();
							inputs[0].focus();
							return;
						};

						for (let j = 0; j < inputs.length; j++) {
							inputs[j].value = filtered_val[j] ?? '';
						}
						if (filtered_val.length > 0 && filtered_val.length < inputs.length) {
							inputs[filtered_val.length].focus();
						}
						if (filtered_val.length >= inputs.length) {
							inputs[inputs.length-1].focus();
						}
						updateValue('paste');
					};

					input.addEventListener('input', (e) => {
						const raw_val = input.value;
						const filtered_val = raw_val.replace(/\D/g, '').slice(0, length);

						if (raw_val.length === 1) {
							input.value = filtered_val;
							if (filtered_val && i < inputs.length - 1) {
								inputs[i + 1].focus();
							}
							updateValue();
							return;
						}

						processPaste(raw_val, filtered_val);
					});

					input.addEventListener('keydown', (e) => {

						const goto_prev = () => {
							if (i <= 0) return;
							const prev_input = inputs[i - 1];
							prev_input.focus();
							prev_input.setSelectionRange(prev_input.value.length, prev_input.value.length);
							return prev_input;
						};
						const goto_next = () => {
							if (i >= inputs.length - 1) return;
							const next_input = inputs[i + 1];
							next_input.focus();
							next_input.setSelectionRange(next_input.value.length, next_input.value.length);
							return next_input;
						};

						if (e.key === 'Delete') {
							e.preventDefault();

							if (input.value === '') {
								const next_input = goto_next();
								if (!next_input) return;
								const old_value = next_input.value
								next_input.value = '';
								if (old_value !== next_input.value) updateValue();
								return;
							}

							const old_value = input.value;
							input.value = '';
							if (old_value !== input.value) updateValue();
							if (old_value === '') goto_next();
						} else if (e.key === 'Backspace') {
							e.preventDefault();

							if (input.value === '') {
								const prev_input = goto_prev();
								if (!prev_input) return;
								const old_value = prev_input.value;
								prev_input.value = '';
								if (old_value !== prev_input.value) updateValue();
								return;
							}

							const old_value = input.value;
							input.value = '';
							if (old_value !== input.value) updateValue();
							if (old_value === '') goto_prev();
						} else if (e.key === 'ArrowLeft') {
							e.preventDefault();
							goto_prev();
						}
						else if (e.key === 'ArrowRight') {
							e.preventDefault();
							goto_next();
						} else if (/^\d$/.test(e.key)) {
							input.setSelectionRange(0, input.value.length);
						} else {
							input.setSelectionRange(0, input.value.length);
						}
					}, true);

					input.addEventListener('paste', (e) => {
						e.preventDefault();
						const raw_val = (e.clipboardData.getData('text') || '');
						const filtered_val = raw_val.replace(/\D/g, '').slice(0, length);

						processPaste(raw_val, filtered_val);
					});

					// on focus force cursor to the end
					input.addEventListener('focus', (e) => {
						setTimeout(() => {
							if (!this.value) {
								inputs[0].focus();
								return;
							}
							input.setSelectionRange(input.value.length, input.value.length);
						});
					});
				});
			}

			focusIntelligent() { // TODO mb same but return input to use $.fn.focusDesktop etc
				if (!this.connected) return;

				let last_value_idx = 0;

				this.inputs.forEach((input, idx) => {
					if (input.value !== '') last_value_idx = idx + 1;
				});

				last_value_idx = Math.min(last_value_idx, this.inputs.length - 1);

				this.inputs.at(last_value_idx).focus();

				return this;
			}

			clearValue() {
				this.input.value = '';
				this.inputs.forEach(input => input.value = '');

				return this;
			}
		});
	}
}

$.valHooks['ws-code-input'] = {
	get: function(el) {
		return el.input.value;
	},
	// наче не треба
	// set: function(el, value) {
	// 	el.input.value = value;
	// }
};
;App.components.ws_date = {

	tag_name: 'ws-date',
	list_all: [],

	template: function (params, format) {
		params = {...params};
		let server_date = parseInt(params.time);

		if (server_date > App.helper.customDate.get('today')) params.today = 1;
		else if (server_date > App.helper.customDate.get('yesterday')) params.yesterday = 1;
		else if (server_date > App.helper.customDate.get('today') - 6 * 86400) params.recently = 1;

		let template = App.helper.template.get_cached('ws_date', format);
		template = template.trim().replace(/\s+/g, ' ');
		if (!template) return '';

		return App.helper.template.fill(template, params);
	},

	redraw: function(el, data) {
		if (data) el.tpl_data = data;
		let new_html = this.template(el.tpl_data, el.tpl_format);
		if (App.components.helper_need_update(new_html, el.innerHTML)) {
			el.innerHTML = new_html;
		}
	},

	redraw_all: function() {
		this.list_all.forEach((el) => this.redraw(el));
	},

	onBoot: function() {
		let component = this;
		customElements.define(this.tag_name, class extends HTMLElement {
			constructor() {
				super();
				App.components.register_in.call(this, component, ONLY_JS_RENDERING);
			}
		});
	},

	onLogin: function () {
		App.helper.cron.add('ws_date', () => this.redraw_all());
	},
	onLogout: function () {
		App.helper.cron.remove('ws_date');
	},

	destructor: function(component) { // `this` is element
		App.components.unregister_in.call(this, component);
	},
}

;App.components.ws_date_input = {
	onBoot: function() {
		customElements.define("ws-date-input", class extends HTMLElement {
			constructor() {
				super();
				this.rendered = false;
				this.tabIndex = 0;
				this.hasBeenFocused = false;
				this.lastFocused = null;
				this.currentDay = null;
				this.currentMonth = null;
				this.currentYear = null;
				this.nowYear = new Date().getFullYear();
				this.minYear = this.nowYear - 10;
				this.maxYear = this.nowYear + 10;
				this.minDate = null;
				this.observer = null;
				this.linkedInput = null;
				this.nodate = null;
			}

			leadingZero(val) {
				return String(val).padStart(2, '0');
			}

			getDaysInMonth(month, year) {
				return new Date(year, month, 0).getDate();
			}

			getMonthNameByNumber(monthNumber) {
				const date = new Date(2023, monthNumber - 1);
				let monthName = App.object_state.locale.month['short'][date.getMonth()];
				return monthName.charAt(0).toUpperCase() + monthName.slice(1)
			}

			focusOnFirstInput() {
				const firstInput = this.querySelector('.date-segment');
				if (firstInput) {
					firstInput.focus();
					firstInput.select();
					this.lastFocused = firstInput;
				}
			}

			setNoDate(state) {
				this.nodate = state;
				this.classList.toggle('nodate', state);
				if (state===false) this.updateInputsFromGlobal();
			}

			updateInputsFromGlobal(isNumMonth = false) {
				let dayInput = this.querySelector('.date-segment.day');
				let monthInput = this.querySelector('.date-segment.month');
				let yearInput = this.querySelector('.date-segment.year');

				dayInput.value = !isNumMonth && this.nodate ? 'DD' : this.leadingZero(this.currentDay);
				monthInput.value = isNumMonth ? this.leadingZero(this.currentMonth) : (this.nodate ? 'MM' : this.getMonthNameByNumber(this.currentMonth));
				yearInput.value = this.currentYear;
			}

			navigateInput(currentInput, direction) {
				const inputs = Array.from(this.querySelectorAll('.date-segment'));
				const currentIndex = inputs.indexOf(currentInput);
				this.checkDatesInput(currentInput);
				if (direction === 'next') {
					if (currentIndex < inputs.length - 1) {
						inputs[currentIndex + 1].focus();
						setTimeout(() => {
							inputs[currentIndex + 1].select();
						}, 0);

					} else {
						inputs[0].focus();
						setTimeout(() => {
							inputs[0].select();
						}, 0);

					}
				} else if (direction === 'prev') {
					if (currentIndex > 0) {
						inputs[currentIndex - 1].focus();
						setTimeout(() => {
							inputs[currentIndex - 1].select();
						}, 0);

					} else {
						inputs[inputs.length - 1].focus();
						setTimeout(() => {
							inputs[inputs.length - 1].select();
						}, 0);

					}
				}
			}

			changeDateByInput(input, action) {
				const dayInput = this.querySelector('.day');
				const monthInput = this.querySelector('.month');
				const yearInput = this.querySelector('.year');

				let day = parseInt(dayInput.value, 10) || 1;
				let month = parseInt(monthInput.value, 10) - 1 || 0;
				let year = parseInt(yearInput.value, 10) || new Date().getFullYear();

				if (input.classList.contains('day')) {
					action === 'increment' ? day++ : day--;
				} else if (input.classList.contains('month')) {
					action === 'increment' ? month++ : month--;
				} else if (input.classList.contains('year')) {
					if (action === 'increment' && year < this.maxYear) {
						year++;
					} else if (action === 'decrement' && year > this.minYear) {
						year--;
					}
				}

				if (year>this.maxYear) year--;
				if (year<this.minYear) year++;

				let newDate = new Date(year, month, day);
				if (this.minDate && newDate < this.minDate) newDate = this.minDate;

				dayInput.value = this.currentDay = String(newDate.getDate()).padStart(2, '0');
				monthInput.value = this.currentMonth = String(newDate.getMonth() + 1).padStart(2, '0');
				yearInput.value = this.currentYear = String(newDate.getFullYear());

				input.select();
			}

			dispatchChangeEvent(focus = true) {
				const event = new Event('change', {
					'bubbles': true,
					'cancelable': true
				});
				this.observer.disconnect();
				this.updateLinkedInput();
				setTimeout(()=> {
					if ( this.getAttribute('data-value') !== this.linkedInput.value ) this.setAttribute('data-value', this.linkedInput.value);
				}, 5); // if other scripts changes value (like closest_workday)
				this.dispatchEvent(event);
				if (focus) this.lastFocused.focus();
			}

			checkDatesInput(input) {
				const nonNumeric = /\D/;

				if (input.classList.contains('day') || input.classList.contains('month')) {
					if (nonNumeric.test(input.value)) {
						input.value = input.value.replace(nonNumeric, '');
					}
				}
				let val = parseInt(input.value, 10);
				if (input.classList.contains('year')) {
					if (!input.value.trim()) {
						input.value = this.currentYear;
					} else if (val < this.minYear) {
						if (val > 999) {
							input.value = val;
						} else if (val > 99) {
							input.value = "2" + val;
						} else if (val > 9) {
							input.value = "20" + val;
						} else {
							input.value = "200" + val;
						}
					} else if (val < 1) {
						input.value = this.minYear;
					} else {
						input.value = val;
					}
					let newVar = parseInt(input.value, 10);
					if (newVar > this.maxYear) {
						newVar = this.maxYear;
					} else if (newVar < this.minYear) {
						newVar = this.minYear;
					}
					if ( isNaN(newVar) || newVar === undefined ) newVar = this.currentYear;
					input.value = this.currentYear = newVar;
				} else if (input.classList.contains('day')) {
					if (!input.value.trim()) {
						input.value = this.currentDay;
					} else if (val > this.getDaysInMonth(this.currentMonth, this.currentYear)) {
						input.value = this.getDaysInMonth(this.currentMonth, this.currentYear);
					}
					if ( isNaN(input.value) || input.value === undefined ) input.value = this.currentDay;
					this.currentDay = parseInt(input.value, 10);
				} else if (input.classList.contains('month')) {
					if (!input.value.trim()) {
						input.value = this.currentMonth;
					} else if (val > 12) {
						input.value = 12;
					} else if (val < 1) {
						input.value = this.currentMonth;
					}
					if ( isNaN(input.value) || input.value === undefined ) input.value = this.currentMonth;
					this.currentMonth = parseInt(input.value, 10);
				}
			}

			updateLinkedInput() {
				let newVal = this.currentDay + '.' + this.currentMonth + '.' + this.currentYear;
				let newDate = App.helper.date.from_input(newVal);
				if (this.minDate && newDate.getTime() < this.minDate.getTime()) {
					this.currentDay = this.minDate.getDate();
					this.currentMonth = this.minDate.getMonth();
					this.currentYear = this.minDate.getFullYear();
					this.updateInputsFromGlobal();
					newVal = App.helper.date.to_input(this.minDate);
				}
				if (this.linkedInput.value !== newVal) {
					$(this.linkedInput).val(newVal);
				}
			}

			render() {
				if (this.rendered) return;
				if (this.observer) this.observer.disconnect();

				let self_element = this;
				let dateValue = new Date();
				const parentForm = this.closest('.menu') || this.closest('form') || document;
				this.linkedInput = parentForm.querySelector(`input[name="${this.getAttribute('name')}"]`);

				if (this.linkedInput && this.linkedInput.value) {
					dateValue = App.helper.date.from_input(this.linkedInput.value);
					if (!this.getAttribute('data-value') || this.getAttribute('data-value')==='') this.setAttribute('data-value', this.linkedInput.value);
					if (this.hasAttribute('data-min')) this.minDate = App.helper.date.from_input(this.getAttribute('data-min'));
				}
				if (this.linkedInput) {
					let inp = this.linkedInput;
					this.observer = new MutationObserver( function(mutations, observer) {
						self_element.setAttribute('data-value', inp.value);
						self_element.setNoDate(!inp.value.length>0);
						if (self_element.classList.contains('formSimple-error') && inp.value !== '') self_element.classList.remove('formSimple-error');
					});
					this.observer.observe(this.linkedInput, { attributes: true, attributeFilter: ['value'], childList: false, characterData: false });
				} else {
					return;
				}

				let ifDateRealExists = this.linkedInput.dataset.real
					? parseInt(this.linkedInput.dataset.real, 10) > 0 && this.linkedInput.value !== ''
					: this.linkedInput.value !== '';

				let day = this.currentDay = dateValue.getDate().toString().padStart(2, '0');
				let monthName = App.object_state.locale.month['short'][dateValue.getMonth()];
				let monthNumber = this.currentMonth = String(dateValue.getMonth() + 1).padStart(2, '0');
				let year = this.currentYear = dateValue.getFullYear();

				if (!ifDateRealExists) {
					day = "DD";
					monthName = "MM";
					this.setNoDate(true);
				}

				this.innerHTML = `
                    <input type="text" maxlength="2" class="date-segment day" value="${day}" />
                    <div class="separator">.</div>
                    <input type="text" maxlength="2" class="date-segment month" value="${monthName}" />
                    <div class="separator">.</div>
                    <input type="text" maxlength="4" class="date-segment year" value="${year}" />
                `;

				this.querySelectorAll('.date-segment').forEach(input => {
					input.addEventListener('focus', () => {
						this.classList.add('focused');
						this.lastFocused = input;
						this.updateInputsFromGlobal(true);
						input.select();
					});

					input.addEventListener('blur', () => {
						setTimeout(() => {
							if (!this.querySelector('.date-segment:focus')) {
								this.classList.remove('focused');
								this.hasBeenFocused = false;
								this.checkDatesInput(input);
								this.dispatchChangeEvent(false);
								this.updateInputsFromGlobal();
							}
						}, 10);
					});

					input.addEventListener('keydown', e => {
						switch (e.keyCode) {
							case App.keycode.ArrowRight:
								this.navigateInput(input, 'next');
								break;
							case App.keycode.ArrowLeft:
								this.navigateInput(input, 'prev');
								break;
							case App.keycode.Tab:
								if (e.shiftKey) {
									this.navigateInput(input, 'prev');
								} else {
									this.navigateInput(input, 'next');
								}
								e.preventDefault();
								break;
							case App.keycode.ArrowUp:
								this.changeDateByInput(input, 'increment');
								e.preventDefault();
								e.stopPropagation();
								break;
							case App.keycode.ArrowDown:
								this.changeDateByInput(input, 'decrement');
								e.preventDefault();
								e.stopPropagation();
								break;
							case App.keycode.Enter:
								this.checkDatesInput(input);
								this.dispatchChangeEvent(false);
								e.preventDefault();
								break;
						}
					});

					input.addEventListener('keyup', e => {
						//this.checkDatesInput(input);
						//App.core.call_queue.add('date.change', this.dispatchChangeEvent, this, null, 0.5);
					});

					input.addEventListener('keypress', e => {
						if (e.which < 48 || e.which > 57) e.preventDefault();
					});

					input.addEventListener('change', e => {
						e.stopPropagation();
					});
				});

				this.addEventListener('click', () => {
					if (!this.querySelector('.date-segment:focus')) {
						//this.focusOnFirstInput();
						$(this).select();
					}
				});

				this.rendered = true;
			}

			static get observedAttributes() {
				return ["data-value"];
			}

			connectedCallback() {
				if (!this.rendered) {
					this.render();
				}
			}

			attributeChangedCallback() {
				this.rendered = false;
				this.render();
			}
		});
	}
}

;App.components.ws_editable = {
	validators: {
		required: function (value) { return value != null && value.trim() !== ''; },
		numeric: function (value) { return !isNaN(Number(value)); },
		integer: function (value) { return !isNaN(Number(value)) && Number.isInteger(Number(value)); },
		string_min: function (value, param) { return value.length >= Number(param); },
		string_max: function (value, param) { return value.length <= Number(param); },
		number_min: function (value, param) { return !Number.isFinite(Number(value)) || Number(value) >= Number(param); },
		number_max: function (value, param) { return !Number.isFinite(Number(value)) || Number(value) <= Number(param); },
		email: function (value) { return App.helper.validate.email.test(value); },
		phone: function (value) { return App.helper.validate.phone.test(value); },
		regex: function (value, param) { return new RegExp(`/${param}/`).test(value); },
		url: function (value) { return App.helper.validate.url.test(value); },
	},
	pre_validate_transformers: {
		precision: function (value, param) {
			return Number.isFinite(+value)
				? String(+(+value).toFixed(Number(param)))
				: value;
		},
	},
	onBoot: function() {

		const attr_bool = (val) => ['true', 'yes', '1'].includes(val);
		const create_dummy_element = () => document.createComment('');
		const VALIDATOR_MIN = 'min';
		const VALIDATOR_MAX = 'max';
		const VALIDATOR_REQUIRED = 'required';
		const ALWAYS_CHECK_VALIDATORS = [VALIDATOR_REQUIRED, VALIDATOR_MIN, VALIDATOR_MAX];
		const STRING_MAX_LENGTH = 999;

		const get_error_message = (key) => (App.object_state.locale.validation_messages ?? {})[key];
		const expect_number = (rules) => (rules || '').split('|').some(d => d.startsWith('numeric') || d.startsWith('integer'))

		const create_validators = function (input_type, rules) {
			const value_type = input_type === 'number' || expect_number(rules) ? 'number' : 'string';

			return (rules || '').split('|').map(k => k.trim()).filter(k => k.length > 0).reduce(function (acc, item) {
				const def = item.split(':');
				const name = def.shift();
				const param = def.length > 0 ? def.join(':') : null;

				let validator_id = name;

				if ([VALIDATOR_MIN, VALIDATOR_MAX].includes(validator_id)) {
					validator_id = value_type + '_' + validator_id;
				}

				const handler = App.components.ws_editable.validators[validator_id];
				if (handler == null) return acc;

				return {
					...acc, [name]: {
						name: name,
						param: param,
						last_context: null,
						is_valid: function (value) {
							this.last_context = { value: value, param: param, valid: true };

							if ((value == null || value.trim() === '') && name !== VALIDATOR_REQUIRED) return true;

							this.last_context.valid = handler(value, param);

							return this.last_context.valid
						},
						message: function () {
							const msg = get_error_message(validator_id) || get_error_message(value_type + '_invalid') || 'Invalid value';

							if (['string_min', 'string_max'].includes(validator_id)) {
								return msg.replace('%s', App.format.quantity(Number(this.param), get_error_message('chars_plural') || 'symbol|symbols|symbols', true));
							}

							return msg.replace('%s', this.param);
						}
					}
				}
			}, {})
		}

		const apply_pre_validate_transformers = function(value, rules) {
			return (rules || '')
				.split('|')
					.map(v => v.trim())
					.filter(v => v.length > 0)
				.reduce((value, item) => {
					const def = item.split(':');
					const name = def.shift();
					const param = def.length > 0 ? def.join(':') : null;

					const handler = App.components.ws_editable.pre_validate_transformers[name];

					return handler == null
						? value
						: handler(value, param);
				}, value);
		}

		customElements.define("ws-editable", class extends HTMLElement {
			constructor() {
				super();

				this.rendered = false;
				this.editing = false;
				this.prev_state = {};
				this.invalid = false;
				this.prev_value = '';
				this.input_value = '';
				this.validators = null;
				this.input_type = 'string';
			}

			static get observedAttributes() {
				return [
					"value", "class", "loading", "readonly", "clipboard",
					"pencil", "pencil-name", "pencil-text", "pencil-left-icon", "pencil-right-icon",
					"autosave", "placeholder", "emptyholder", "error", "validator",
					"action", "action-name", "action-text", "action-left-icon", "action-right-icon",
					"updated-ts", 'input-classes', 'input-id'
				];
			}

			get its_type() { return this.getAttribute('type') || 'text'; }
			get its_value() { return (this.getAttribute('value') || '').trim(); }
			get its_class() { return this.getAttribute('class') || ''; }
			get its_placeholder() { return this.getAttribute('placeholder') || ''; }
			get its_emptyholder() { return this.getAttribute('emptyholder') || ''; }
			get its_readonly() { return attr_bool(this.getAttribute('readonly')); }
			get its_autosave() { return attr_bool(this.getAttribute('autosave') || '1'); }
			get its_loading() { return attr_bool(this.getAttribute('loading')); }
			get its_show_clipboard() { return attr_bool(this.getAttribute('clipboard') || '1'); }
			get its_validator() { return this.getAttribute('validator'); }
			get its_error() { return this.getAttribute('error'); }
			get its_updated_ts() { return this.getAttribute('updated-ts'); }
			get its_textarea_line_height() {
				const val = parseInt(this.getAttribute('textarea-line-height') || '14')
				return isNaN(val) ? 14 : val;
			}
			get its_textarea_padding_height() {
				const val = parseInt(this.getAttribute('textarea-padding-height') || '0')
				return isNaN(val) ? 0 : val;
			}

			get its_show_pencil() { return attr_bool(this.getAttribute('pencil') || '1'); }
			get its_pencil_name() {return this.getAttribute('pencil-name') || 'btn btn-24 btn-g btn-fill'}
			get its_pencil_text() {return this.getAttribute('pencil-text') || ''}
			get its_pencil_left_icon() {return this.getAttribute('pencil-left-icon') || ''}
			get its_pencil_right_icon() {return this.getAttribute('pencil-right-icon') || 'edit'}

			get its_show_action() { return attr_bool(this.getAttribute('action') || '1'); }
			get its_action_name() { return this.getAttribute('action-name') || ''; }
			get its_action_text() { return this.getAttribute('action-text') || ''; }
			get its_action_tooltip() { return this.getAttribute('action-tooltip') || ''; }
			get its_action_left_icon() { return this.getAttribute('action-left-icon') || ''; }
			get its_action_right_icon() { return this.getAttribute('action-right-icon') || ''; }

			get its_allowed_empty() { return this.getAttribute('validator') == null || !this.getAttribute('validator').includes(VALIDATOR_REQUIRED); }
			get its_select_enabled() { return attr_bool(this.getAttribute('select-enabled')); }
			get its_keep_view() { return attr_bool(this.getAttribute('keep-view')); }
			get its_selectable() { return attr_bool(this.getAttribute('selectable')); }
			get its_longtouch_trigger() { return attr_bool(this.getAttribute('longtouch-trigger')); }
			get its_unit() { return this.getAttribute('unit') || ''; }
			get its_align() { return this.getAttribute('align') || 'left'; }
			get its_input_classes() { return (this.getAttribute('input-classes') || '').split(' ').filter((val) => val.length > 0); }
			get its_input_id() { return this.getAttribute('input-id') || null; }
			get show_unit_on_focus() { return attr_bool(this.getAttribute('show-unit-on-focus') || 'true'); }

			is_empty_value() { return this.input_value.trim() === '' && !this.its_allowed_empty; }
			remember_input_value() {
				this.prev_value = this.input_value;
				this.input_value = this.editing ? this.input_ref.value.trim() : this.its_value;
			}
			setup_validation() {
				this.validators = create_validators(this.its_type, this.its_validator)
				this.input_type = this.its_type === 'number' || this.validators['numeric'] != null || this.validators['integer'] != null ? 'number' : 'string';
			}

			make_wrapper_class() {
				let value = 'editable-value ' + this.its_class

				if (this.is_empty_value()) value+= ' empty';
				if (this.its_readonly) value+= ' readonly';
				if (this.editing) value+= ' editing';
				if (this.invalid) value+= ' errored';

				return value;
			}

			render() {
				if (this.rendered) return;

				this.rendered = true;

				this.inner_view = this.innerHTML;
				this.innerHTML = '';

				this.remember_state();
				this.remember_input_value();
				this.setup_validation();

				this.wrapper = document.createElement('div')
				this.wrapper.classList.value = this.make_wrapper_class();
				this.content = this.editing ? this.render_input() : this.render_view();

				this.wrapper.appendChild(this.content)

				this.appendChild(this.wrapper);
			}

			update() {
				if (!this.rendered) return;

				this.wrapper.classList.value = this.make_wrapper_class();

				if (this.is_changed_state('its_validator', 'its_type')) {
					this.setup_validation();
				}

				if (this.is_changed_state('editing')) {
					let content;
					if (!this.editing) {
						content = this.render_view();
					} else if (this.its_keep_view) {
						content = document.createElement('div');
						content.append(this.render_view(), this.render_input());
					} else {
						content = this.render_input();
					}
					this.replace_el('content', content);
				} else if(this.editing) {
					this.input_ref.placeholder = this.its_placeholder;
					this.input_ref.type = this.its_type;
					if (this.is_changed_state('its_value')) {
						this.input_ref.value = this.its_value;
						this.remember_input_value();
					}
				} else {
					this.content.classList.toggle('loading', this.its_loading)

					if (this.is_changed_state('its_value')) {
						this.text.classList.toggle('empty', this.is_empty_value())
						const formatExpression = this.text.getAttribute('data-format');
						let textValue = this.is_empty_value() ? this.its_emptyholder : this.its_value;
						if (formatExpression) {
							textValue = App.helper.eval_safe_context(formatExpression, { value: this.its_value, el: this });
						}
					if (this.text.getAttribute('data-format-html') === '1') {
						this.text.innerHTML = textValue ?? '';
					} else {
						this.text.innerText = textValue;
					}
						this.text.appendChild(this.render_unit())
					}
					if (this.is_changed_state('its_show_pencil', 'its_readonly', 'its_pencil_name', 'its_pencil_text', 'its_pencil_left_icon', 'its_pencil_right_icon', 'its_loading')) {
						this.replace_el('btn_pencil', this.its_show_pencil && !this.its_loading && !this.its_readonly && this.render_btn_pencil())
					}
					if (this.is_changed_state('its_show_clipboard', 'its_loading')) {
						this.replace_el('btn_clipboard', this.its_show_clipboard && !this.its_loading && !this.is_empty_value() && this.render_btn_clipboard())
					}
					if (this.is_changed_state('its_show_action', 'its_action_name', 'its_action_text', 'its_action_left_icon', 'its_action_right_icon', 'its_loading')) {
						this.replace_el('btn_action', this.its_show_action && this.its_action_name !== '' && !this.invalid && !this.its_loading && this.render_btn_action())
					}
				}

				if (this.is_changed_state('editing') && this.editing) {
					this.input_ref.focus();
				}

				if (this.is_changed_state('its_updated_ts')) {
					$(this.wrapper).animate_css('blink');
				}

				if (this.invalid) this.validate();

				const options = this.querySelector('.options');
				if (options && options.childElementCount === 0) options.classList.add('options-empty');
				else if (options && options.childElementCount > 0) options.classList.remove('options-empty');

				this.remember_state();
			}

			is_changed_state(key, ...rest_keys) { return [key, ...rest_keys].some((k) => this.prev_state[k] !== this[k]); }
			remember_state() {
				this.prev_state.its_loading = this.its_loading
				this.prev_state.its_readonly = this.its_readonly
				this.prev_state.editing = this.editing
				this.prev_state.its_value = this.its_value
				this.prev_state.its_class = this.its_class
				this.prev_state.its_updated_ts = this.its_updated_ts
				this.prev_state.its_show_clipboard = this.its_show_clipboard
				this.prev_state.its_show_pencil = this.its_show_pencil
				this.prev_state.its_pencil_name = this.its_pencil_name
				this.prev_state.its_pencil_text = this.its_pencil_text
				this.prev_state.its_pencil_left_icon = this.its_pencil_left_icon
				this.prev_state.its_pencil_right_icon = this.its_pencil_right_icon
				this.prev_state.its_validator = this.its_validator
				this.prev_state.its_show_action = this.its_show_action
				this.prev_state.its_action_name = this.its_action_name
				this.prev_state.its_action_text = this.its_action_text
				this.prev_state.its_action_left_icon = this.its_action_left_icon
				this.prev_state.its_action_right_icon = this.its_action_right_icon
				this.prev_state.its_action_right_icon = this.its_action_right_icon
				this.prev_state.its_empty_fallback = this.its_empty_fallback
			}

			replace_el(name, new_el) {
				const el = new_el || create_dummy_element();
				this[name].replaceWith(el)
				this[name] = el;
			}

			enter_edit_mode() {
				if (!this.editing) this.content_height = this.content.offsetHeight;

				let last_input_value = this.input_value;
				this.remember_input_value();
				if (this.invalid) this.input_value = last_input_value;

				this.toggle_editing(!this.its_readonly && !this.its_loading);
				return this;
			}

			toggle_editing(state) {
				if (this.editing === state) return;

				this.editing = state === true;

				if (this.editing && this.inner_view.trim() !== '' && this.view_slot) {
					this.inner_view = this.view_slot.innerHTML;
				}

				this.update();
			}

			do_apply() {

				if (this.input_value.trim() === '' && VALIDATOR_REQUIRED in this.validators) {
					this.do_cancel();
					return;
				}

				if (!this.invalid) {
					this.input_value = apply_pre_validate_transformers(
						this.input_value,
						this.its_validator
					);
				}

				this.validate();
				this.toggle_editing(false);
				this.emit_apply();
			}

			do_cancel() {
				this.input_value = this.its_value;
				this.prev_value = '';
				this.invalid = false;
				this.toggle_editing(false);
				this.emit_cancel();
			}

			validate(is_typing) {
				const error_name = this.its_error != null ? 'its_error' : Object.keys(this.validators).find(name => {
					return this.validators[name] != null && (!is_typing || ALWAYS_CHECK_VALIDATORS.includes(name)) ? !this.validators[name].is_valid(this.input_value) : false;
				})
				const error_validator = error_name != null ? this.validators[error_name] : null;

				if (is_typing && !this.invalid && this.input_type === 'string' && error_name === VALIDATOR_MIN && this.input_value.length > this.prev_value.length) return;
				if (is_typing && !this.invalid && this.input_type === 'string' && error_name === VALIDATOR_MAX && this.input_value.length < this.prev_value.length) return;

				this.invalid = error_name != null;
				this.wrapper.classList.value = this.make_wrapper_class();

				if (!this.invalid) return this.replace_el('error_icon', create_dummy_element());

				if (error_name === 'its_error') {
					this.replace_el('error_icon', this.render_error_icon(this.its_error))
				} else if (error_validator == null) {
					this.replace_el('error_icon', this.render_error_icon('Unknown Error'))
				} else if (error_validator.name === VALIDATOR_MIN && this.input_type === 'string') {
					this.replace_el('error_icon', this.render_length_counter('+' + (Number(error_validator.param) - this.input_value.length), error_validator.message()))
				} else if (error_validator.name === VALIDATOR_MAX && this.input_type === 'string') {
					this.replace_el('error_icon', this.render_length_counter('-' + (this.input_value.length - Number(error_validator.param)), error_validator.message()))
				} else {
					this.replace_el('error_icon', this.render_error_icon(error_validator.message()))
				}
			}

			render_error_icon(title) {
				const err_icon = document.createElement('ws-icon', { is:'ws-icon' })
				err_icon.classList.add('errico')

				err_icon.setAttribute('name', 'exclam_triangle-solid')
				if (title != null) err_icon.setAttribute('data-title', title);

				return err_icon;
			}

			render_length_counter(text, title) {
				const cnt = document.createElement('span')
				cnt.classList.add('counter')
				cnt.innerText = text;

				if (title != null) cnt.setAttribute('data-title', title);

				return cnt;
			}

			render_input() {
				const wrapper = document.createElement('div')
				const is_textarea = this.its_type === 'textarea'
				const initial_content_height = this.content_height;

				const input = document.createElement(is_textarea ? 'textarea' : 'input')
				input.id = this.its_input_id || '';
				this.its_input_classes.forEach(cls => input.classList.add(cls));

				input.value = this.input_value;
				if (!is_textarea) input.type = this.its_type;
				input.placeholder = this.its_placeholder;

				if (is_textarea) {
					input.style.height = initial_content_height + 'px';
				}

				const update_textarea_height = () => {
					input.style.height = Math.min(
						this.its_textarea_line_height*3 + this.its_textarea_padding_height,
						Math.max(initial_content_height, input.scrollHeight)
					) + 'px';
				};

				input.addEventListener('focus', (event) => {
					wrapper.classList.add('focus');
					if (this.its_select_enabled) {
						event.target.select();
					}
				});
				input.addEventListener('blur', () => {
					wrapper.classList.remove('focus');

					if (!this.editing) return;

					if (this.invalid && !this.its_autosave) return this.do_cancel();

					if (this.input_value !== this.its_value && this.its_autosave) {
						this.do_apply();
					} else {
						this.do_cancel();
					}
				})
				input.addEventListener('input', (e) => {
					if (is_textarea) update_textarea_height();
					if (this.input_type === 'string' && e.target.value.length > STRING_MAX_LENGTH) {
						input.value = e.target.value.substring(0, STRING_MAX_LENGTH);
					}
					if (this.its_keep_view) {
						const viewSpan = this.querySelector('.view > span');
						if (viewSpan) viewSpan.innerText = input.value;
					}
					this.remember_input_value();
					this.validate(true);
					this.emit_input()
				})
				input.addEventListener('keydown', (e) => {
					const keyCode = e.keyCode ? e.keyCode : e.charCode;
					if (keyCode === App.keycode.Enter || keyCode === App.keycode.Escape) {
						e.preventDefault();
						e.stopPropagation();
						if (keyCode === App.keycode.Escape) this.do_cancel();
						return false;
					}
				});
				input.addEventListener('keyup', (e) => {
					const keyCode = e.keyCode ? e.keyCode : e.charCode;

					if (keyCode === App.keycode.Enter) {
						if (this.input_value !== this.its_value) {
							this.do_apply();
						} else {
							this.do_cancel();
						}
					}
				})

				this.input_ref = input;
				this.error_icon = create_dummy_element()

				wrapper.classList.add('input')
				if (this.its_align === 'right') {
					wrapper.appendChild(this.error_icon)
				}
				wrapper.appendChild(input)
				if (this.show_unit_on_focus) {
					wrapper.appendChild(this.render_unit())
				}
				if (this.its_align === 'left') {
					wrapper.appendChild(this.error_icon)
				}
				this.emit('input-ready', { el: this, input: this.input_ref });

				return wrapper;
			}

			render_view() {
				const view = document.createElement('div')
				view.classList.add('view')
				view.classList.toggle('loading', this.its_loading)
				view.setAttribute('data-title', '')

				const with_pencil = this.its_show_pencil && !this.its_loading && !this.its_readonly && !this.is_empty_value() && !this.invalid;

				this.btn_clipboard = this.its_show_clipboard && !this.its_loading && !this.is_empty_value() && !this.invalid ? this.render_btn_clipboard() : create_dummy_element()
				this.btn_pencil = with_pencil ? this.render_btn_pencil() : create_dummy_element()
				this.btn_action = this.its_show_action && this.its_action_name !== '' && !this.invalid && !this.its_loading ? this.render_btn_action() : create_dummy_element()
				this.error_icon = create_dummy_element()

				const right_side = document.createElement('div')
				right_side.classList.add('options')

				right_side.appendChild(this.error_icon)
				right_side.appendChild(this.btn_clipboard)
				right_side.appendChild(this.btn_pencil)
				right_side.appendChild(this.btn_action)
				if (right_side.childElementCount === 0) right_side.classList.add('options-empty');
				if (this.its_align === 'right') {
					view.appendChild(right_side)
				}
				if (this.inner_view.trim() !== '') {
					this.view_slot = document.createElement('div')
					this.view_slot.classList.add('slot')
					this.view_slot.innerHTML = this.inner_view;



					this.text = this.view_slot.querySelector('[data-role=value]') || document.createElement('span')
					const formatExpression = this.text.getAttribute('data-format');
					let textValue = this.its_value;
					if (formatExpression) {
						textValue = App.helper.eval_safe_context(formatExpression, { value: this.its_value, el: this });
					}
					if (this.text.getAttribute('data-format-html') === '1') {
						this.text.innerHTML = textValue ?? '';
					} else {
						this.text.innerText = textValue;
					}
					this.text.classList.toggle('filled', this.input_value.trim() !== '');
					this.text.classList.add('value-field');
					this.text.appendChild(this.render_unit())
					view.appendChild(this.view_slot)
				} else {
					this.view_slot = null;
					this.text = this.render_text()
					view.appendChild(this.text)
				}

				if (this.its_align === 'left') {
					view.appendChild(right_side)
				}
				if (!with_pencil) {
					const edit_target = this.view_slot?.querySelector('[data-edit-target]') || view;
					edit_target.addEventListener('click', (e) => {
						if (App.click_listener.is_click(e)) this.enter_edit_mode();
					})
				}


				return view;
			}

			render_text() {
				const value = document.createElement('span')
				value.classList.add('value-field')
				value.classList.toggle('empty', this.is_empty_value())
				value.innerText = this.is_empty_value() ? this.its_emptyholder : this.its_value;
				value.classList.toggle('filled', this.input_value.trim() !== '');
				if (this.its_longtouch_trigger) {
					$(this).on_longtouch(() => this.enter_edit_mode());
				}

				if (this.its_selectable && !this.invalid) {
					value.setAttribute('data-allow-select', '');
				} else {
					value.addEventListener('click', () => this.enter_edit_mode());
				}
				value.appendChild(this.render_unit())
				return value;
			}

			render_btn_clipboard() {
				const btn_clipboard = document.createElement('ws-btn', { is: 'ws-btn' })
				btn_clipboard.setAttribute('name', 'btn btn-24 btn-g btn-fill')
				btn_clipboard.setAttribute('right-icon', 'content_copy:check')
				btn_clipboard.addEventListener('click', () => this.emit_clipboard())

				return btn_clipboard;
			}

			render_btn_pencil() {
				const btn_pencil = document.createElement('ws-btn', { is: 'ws-btn' });
				btn_pencil.setAttribute('name', this.its_pencil_name);
				btn_pencil.setAttribute('text', this.its_pencil_text);
				btn_pencil.setAttribute('left-icon', this.its_pencil_left_icon);
				btn_pencil.setAttribute('right-icon', this.its_pencil_right_icon);
				btn_pencil.addEventListener('click', () => this.enter_edit_mode());

				return btn_pencil;
			}

			render_btn_action() {
				const btn_action = document.createElement('ws-btn', { is: 'ws-btn' });
				btn_action.setAttribute('name', this.its_action_name);
				btn_action.setAttribute('text', this.its_action_text);
				btn_action.setAttribute('data-title', this.its_action_tooltip);
				btn_action.setAttribute('left-icon', this.its_action_left_icon);
				btn_action.setAttribute('right-icon', this.its_action_right_icon);
				btn_action.addEventListener('click', (e) => {
					e.stopPropagation();
					this.emit_action()
				});

				return btn_action;
			}

			render_unit () {
				let unit = this.its_unit.trim();
				if (unit !== '') {
					if (unit.startsWith('expr:')) {
						unit = App.helper.eval_safe_context(unit.substring(5), { value: this.its_value});
					}
					const unitView = document.createElement('span');
					unitView.classList.add('unit');
					unitView.innerText = unit;
					return unitView;
				}
				return create_dummy_element();
			}

			connectedCallback() {
				this.render();
			}

			attributeChangedCallback() {
				this.update();
			}

			emit_apply() {
				this.emit('apply', { el: this, value: this.input_value, old_value: this.its_value, has_error: this.invalid });
			}

			emit_cancel() {
				this.emit('cancel', { el: this, value: this.input_value });
			}

			emit_input() {
				this.emit('input', { el: this, value: this.input_value, old_value: this.its_value, has_error: this.invalid });
			}

			emit_clipboard() {
				this.emit('clipboard', { el: this, value: this.its_value });
			}

			emit_action() {
				this.emit('action', { el: this, value: this.its_value, has_error: this.invalid });
			}

			emit (type, detail) {
				return this.dispatchEvent(new CustomEvent(type, { bubbles: true, cancelable: true, detail: detail }));
			}
		});
	}
}

;App.components.ws_emoji = {
	onBoot: function() {
		customElements.define("ws-emoji", class extends HTMLElement {

			render() {
				if (this.innerHTML) return;
				const shadow = this.shadowRoot ?? this.attachShadow({mode: 'open'});
				let id = this.getAttribute('id') || '';
				let rel = this.getAttribute('rel') || '';
				let imgElem = document.createElement('img');
				let styleElem = document.createElement('style');
				if (this.shadowRoot) {
					while (shadow.firstChild) shadow.firstChild.remove();
				}

				if (!id) {
					let useElem, svgElem = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
					useElem = document.createElementNS('http://www.w3.org/2000/svg', 'use')
					useElem.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', (App.svg_embed ? '' : App.public_root + 'assets/img/icons/sprite.svg') + '#' + App.controls.emoji.defaultIco[rel]);
					svgElem.setAttribute('part', 'icon');
					styleElem.textContent = 'svg {width: 100%;height: 100%}';
					svgElem.appendChild(useElem);
					shadow.appendChild(svgElem);
				} else {
					id = id.split(':');
					if (this.getAttribute('native')) imgElem.alt = this.getAttribute('native');
					imgElem.src = App.controls.emoji.source + id[1] + '.png';
					if (id[1] !== 'undefined') {
						imgElem.addEventListener('error', function() {
							this.src = App.controls.emoji.localSource + id[1] + '.png';
						}, {once : true});
					}

					styleElem.textContent = 'img {width: 100%;height: 100%;display: inline-block;}';
					shadow.appendChild(imgElem);
				}
				shadow.appendChild(styleElem);
			}
			static get observedAttributes() {
				return ["id"];
			}
			connectedCallback() {
				if (!this.rendered) {
					// спроба заставити редактор на андроїді видаляти емоджі хоча б НАТИВНО
					let parent = this.parentNode;
					while (parent) {
						if (parent.isContentEditable) {
							this.setAttribute('contenteditable', 'false');
							break;
						}
						parent = parent.parentNode;
					}
					this.render();
					this.rendered = true;
				}
			}
			attributeChangedCallback() {
				this.render();
			}
		});
	}
}

;App.components.ws_icon = {
	tag_name: 'ws-icon',
	// не поняв нашо, воно не додається в масив через відстуність this.dataset.format
	// list_all: [],
	onBoot: function() {
		let component = this;
		customElements.define("ws-icon", class extends HTMLElement {
			constructor() {
				super();
				this.rendered = false;
				this.connected = false;

				// не поняв нашо, воно не додається в масив через відстуність this.dataset.format
				// App.components.register_in.call(this, component);
			}

			_render() {

				if (!this.rendered && this.innerHTML) return;
				else this.innerHTML = '';
				let useElem, svgElem = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
				let icons = this.getAttribute('name');

				// presets
				if (icons === 'checkbox') icons = 'input-box-blank:input-box-select:input-box-solid-check';
				if (icons === 'checkboxWithError') icons = 'input-box-blank:input-box-select:input-box-solid-check:input-box-solid-cancel';
				if (icons === 'checkboxAdvanced') icons = 'input-box-blank:input-box-select:input-box-solid-check:input-box-minus:input-box-solid-minus';
				if (icons === 'radio') icons = 'input-circle-blank:input-circle-select:input-circle-solid-select';
				if (icons === 'radioCheck') icons = 'input-circle-blank:input-circle-select:input-circle-solid-check';
				if (icons === 'AdvancedFilterRadioCheck') icons = 'input-circle-blank:input-circle-check:input-circle-solid-check';
				if (icons === 'hint') icons = 'info_circle-line:info_circle-fill';
				if (icons === 'hint-exclam') icons = 'exclam_triangle-solid';
				if (icons === 'my_group') icons = 'office:shop';
				if (icons === 'meet') icons = 'alarm_clock';
				if (icons === 'arrows/chevron-forward') icons = 'arrows/chevron-right'; // backward compatibility?
				if (icons === 'tickBox-full') icons = 'editor/tickbox-glare:editor/tickbox-outline:editor/tickbox-tick-glare:editor/tickbox-tick-outline:editor/tickbox-tick-outfill:editor/tickbox-outfill:editor/tickbox-tick-fill:editor/tickbox-fill:editor/tickbox-solid:editor/tickbox-tick-solid:editor/tickbox-tick';

				let common_sprite = this.dataset.sprite || 'sprite';

				icons?.split(':').forEach(function (icon) {
					let sprite = common_sprite;
					if (icon.indexOf('/') !== -1) {
						[sprite, icon] = icon.split('/', 2);
					}
					useElem = document.createElementNS('http://www.w3.org/2000/svg', 'use')
					let path = App.public_root + 'assets/img/icons/' + sprite +'.svg' + (window.APP_SVG_HASH ? '?h='+window.APP_SVG_HASH : '');
					if (sprite === 'props') icon = 'ico-props-' + icon;
					if (sprite === 'props' && App.hybrid_app) {
						useElem.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#' + icon);
					} else if (sprite === 'color' || sprite === 'social' || sprite === 'tools') {
						svgElem.setAttribute('data-theme-dep', '')
						if (['apple', 'keycrm', 'pipedrive'].includes(icon)) icon += '_' + ($('body').attr('data-color') ? 'for_night' : 'for_day');
						useElem.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#ico-' + sprite + '-' + icon);
					} else {
						useElem.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', (App.svg_embed ? '' : path) + '#' + icon);
					}
					svgElem.appendChild(useElem);
				}, this);

				//const shadowRoot = this.attachShadow({mode: "open"}).appendChild(svgElem.cloneNode(true));
				this.appendChild(svgElem);
				this.rendered = true;
			}

			render() {

				if (App.components_queue.is_enabled) {
					App.components_queue.add(this);
					return;
				}

				this._render();
			}

			static get observedAttributes() {
				return ["name"];
			}
			connectedCallback() {
				if (!this.connected) {
					this.render();
					this.connected = true;
				}
			}
			attributeChangedCallback(name, oldValue, newValue) {
				if (this.connected && oldValue !== newValue) {
					this.render();
				}
			}
		});
	},

	destructor: function(component) { // `this` is element
		// не поняв нашо, воно не додається в масив через відстуність this.dataset.format
		// App.components.unregister_in.call(this, component);
		this.innerHTML = '';
		this.rendered = false;
		this.connected = false;
	}
}

;App.components.ws_logo = {
	tag_name: 'ws-logo',
	list_all: [],
	onBoot: function() {
		let component = this;
		customElements.define("ws-logo", class extends HTMLElement {
			constructor() {
				super();
				App.components.register_in.call(this, component);
				if (this.innerHTML) return;
				let icon = this.getAttribute('name');
				this.dataset.sprite ||= 'migration';
				const sprite = '/assets/img/icons/' + this.dataset.sprite + '.svg';

				this.loadSvg(sprite).then(loadedSvg => {

					const fullIconId = 'ico-' + this.dataset.sprite + '-' + icon + '_' + ($('body').attr('data-color') ? 'for_night' : 'for_day');
					const nestedSvg = loadedSvg.querySelector(`#${fullIconId}`);
					if (nestedSvg) {
						const width = nestedSvg.getAttribute('width');
						const height = nestedSvg.getAttribute('height');

						nestedSvg.style.width = this.style.width = width + 'px';
						nestedSvg.style.height = this.style.height = height + 'px';

						const shadow = this.attachShadow({ mode: 'closed' });
						shadow.appendChild(nestedSvg);
					} else {
						console.error(`Element with id ${fullIconId} not found in SVG`);
					}
				}).catch(error => {
					console.error('Error loading SVG:', error);
				});
			}

			loadSvg(url) {
				return fetch(url).then(response => response.text()).then(text => {
					const parser = new DOMParser();
					const svgDoc = parser.parseFromString(text, 'image/svg+xml');
					return svgDoc.documentElement;
				});
			}
		});
	},

	destructor: function(component) { // `this` is element
		App.components.unregister_in.call(this, component);
	},
}

;/*
Базове використання:

<ws-marquee>
	Lorem ipsum dolore sit amet
</ws-marquee>

<ws-marquee
	behavior="bounce"
	trigger="hover"
>
	Lorem ipsum dolore sit amet
</ws-marquee>

<ws-marquee
	behavior="loop"
	trigger="auto"
	pause-on-hover
>
	Lorem ipsum dolore sit amet
</ws-marquee>

Параметри:

behavior:
	loop
	bounce

trigger:
	hover
	click
	auto

direction:
	ltr
	rtl

CSS vars:
TODO replace some or all css vars with html attributes

--marquee-speed: 70; // bounce default: 25
--marquee-iteration-count: infinite;
--marquee-delay: 0s;
--marquee-gap-size: 4ch;
--marquee-edge-padding: 24;
*/

App.components.ws_marquee = {
	onBoot: function () {

		const BEHAVIORS = {
			loop: 'loop',
			bounce: 'bounce',
		};

		const TRIGGERS = {
			hover: 'hover',
			click: 'click',
			auto: 'auto',
		};

		const DIRECTIONS = {
			ltr: 'ltr',
			rtl: 'rtl',
		};

		customElements.define('ws-marquee', class extends HTMLElement {

			static get observedAttributes() {
				return [
					'behavior',
					'trigger',
					'mobile-trigger',
					'direction',
					'mobile',
				];
			}

			constructor() {
				super();

				this.connected = false;
				this.rendered = false;

				this._speed = 70;
				this._active = false;
				this._resize_raf = null;

				this.start = this.start.bind(this);
				this.pause = this.pause.bind(this);
				this.resume = this.resume.bind(this);
				this.stop = this.stop.bind(this);

				this.onMouseEnter = this.onMouseEnter.bind(this);
				this.onMouseLeave = this.onMouseLeave.bind(this);
				this.onClick = this.onClick.bind(this);

				this._observer = new MutationObserver(() => {

					if (!this.connected) return;

					this.update();
				});
			}

			attributeChangedCallback(name, oldValue, newValue) {

				if (oldValue === newValue) return;
				if (!this.connected) return;

				this.update();
			}

			/**
			 * @return {boolean}
			 */
			get mobile() {

				let value = this.getAttribute('mobile');

				if (value === null) {
					value = App.device.is_mobile();
				} else {
					value = value === 'true';
				}

				return value;
			}

			/**
			 * @return {string}
			 */
			get behavior() {

				const value = this.getAttribute('behavior');

				if (
					value === BEHAVIORS.loop ||
					value === BEHAVIORS.bounce
				) {
					return value;
				}

				return BEHAVIORS.loop;
			}

			/**
			 * @return {string}
			 */
			get trigger() {

				const mobile_value = this.getAttribute('mobile-trigger');

				if (this.mobile && mobile_value) {
					return mobile_value;
				}

				const value = this.getAttribute('trigger');

				if (
					value === TRIGGERS.hover ||
					value === TRIGGERS.click ||
					value === TRIGGERS.auto
				) {
					return value;
				}

				return this.mobile
					? TRIGGERS.auto
					: TRIGGERS.hover;
			}

			/**
			 * @return {string}
			 */
			get direction() {

				const value = this.getAttribute('direction');

				if (
					value === DIRECTIONS.ltr ||
					value === DIRECTIONS.rtl
				) {
					return value;
				}

				return DIRECTIONS.rtl;
			}

			/**
			 * @return {boolean}
			 */
			get pause_on_hover() {
				return this.hasAttribute('pause-on-hover');
			}

			connectedCallback() {

				if (this.rendered) return;

				this.connected = true;

				this.render();
				this.update();

				this.observeContent();
				this.observeResize();

				this.rendered = true;
			}

			disconnectedCallback() {

				this.connected = false;

				this.removeTriggers();

				this._observer.disconnect();

				if (this._resize_observer) {
					this._resize_observer.disconnect();
				}

				if (this._resize_raf) {
					cancelAnimationFrame(this._resize_raf);
				}
			}

			render() {

				if (this.shadowRoot) return;

				this.attachShadow({ mode: 'open' });

				this.shadowRoot.innerHTML = `
					<style>
						:host {
							display: block;
							overflow: hidden;
						}

						.marquee {
							display: flex;
							width: max-content;
							white-space: nowrap;
							will-change: transform;
						}

						.marquee-loop {
							margin-left: calc(var(--marquee-gap-size, 4ch) * -1);
						}

						.marquee-running.marquee-loop {
							animation-name: marquee-loop;
							animation-timing-function: linear;
							animation-iteration-count: var(--marquee-iteration-count, infinite);
							animation-delay: var(--marquee-delay, 0s);
						}

						.marquee-running.marquee-bounce {
							animation-name: marquee-bounce;
							animation-duration: var(--marquee-duration);
							animation-timing-function: linear;
							animation-iteration-count: var(
								--marquee-iteration-count,
								infinite
							);
							animation-delay: var(--marquee-delay, 0s);
						}

						.marquee__bullet::after {
							content: '•';
							display: block;
							width: var(--marquee-gap-size, 4ch);
							text-align: center;
						}

						@keyframes marquee-loop {

							to {
								transform: translateX(-50%);
							}
						}

						/*@keyframes marquee-bounce {

							0% {
								transform: translateX(0);
							}

							50% {
								transform: translateX(var(--marquee-bounce-offset));
							}

							100% {
								transform: translateX(0);
							}
						}*/

						@media (prefers-reduced-motion: reduce) {

							.marquee {
								animation: none !important;
								transform: none !important;
							}
						}
					</style>

					<div class="container">
						<div
							part="marquee"
							class="marquee"
						></div>
					</div>
				`;

				this._container_el = this.shadowRoot.querySelector('.container');
				this._marquee_el = this.shadowRoot.querySelector('.marquee');
			}

			update() {

				if (!this.connected) return;

				this.stop();

				this.removeTriggers();

				this.build();

				requestAnimationFrame(() => {

					requestAnimationFrame(() => {

						if (!this.connected) return;

						this.refresh();

					});
				});
			}

			build() {

				const marquee_el = this._marquee_el;

				marquee_el.innerHTML = '';
				marquee_el.className = 'marquee';

				const text = this.textContent.trim();

				this._main_text_el = document.createElement('div');
				this._main_text_el.part = 'text';
				this._main_text_el.className = 'marquee__text';
				this._main_text_el.textContent = text;

				marquee_el.appendChild(this._main_text_el);
			}

			refresh() {

				const marquee_el = this._marquee_el;

				const host_width = this.clientWidth;
				const content_width = this._main_text_el.scrollWidth;

				const has_overflow = content_width > host_width;

				this.stop();

				// cleanup clones
				marquee_el
					.querySelectorAll('.marquee__bullet, .marquee__text[aria-hidden="true"]')
					.forEach(el => el.remove());

				if (!has_overflow) {
					return;
				}

				this._speed = (
					+getComputedStyle(this)
						.getPropertyValue('--marquee-speed')
						.trim()
				) || (
					this.behavior === BEHAVIORS.bounce
						? 25
						: 70
				);

				switch (this.behavior) {

					case BEHAVIORS.loop:
						this.setupLoop();
						break;

					case BEHAVIORS.bounce:
						this.setupBounce();
						break;
				}

				this.setupTriggers();
			}

			setupLoop() {

				const marquee_el = this._marquee_el;

				const bullet_el = document.createElement('div');
				bullet_el.part = 'bullet';
				bullet_el.className = 'marquee__bullet';
				bullet_el.ariaHidden = true;

				const clone_el = document.createElement('div');
				clone_el.part = 'text';
				clone_el.className = 'marquee__text';
				clone_el.textContent = this._main_text_el.textContent;
				clone_el.ariaHidden = true;

				marquee_el.prepend(bullet_el.cloneNode());
				marquee_el.append(bullet_el.cloneNode());
				marquee_el.append(clone_el);

				const distance = marquee_el.scrollWidth / 2;

				const duration = (
					distance / this._speed
				).toFixed(3);

				const direction_multiplier = (
					this.direction === DIRECTIONS.rtl
						? -1
						: 1
				);

				marquee_el.style.setProperty(
					'--marquee-loop-offset',
					`${distance * direction_multiplier}px`
				);

				marquee_el.style.animationDuration = `${duration}s`;

				marquee_el.classList.add('marquee-loop');
			}

			rollbackLoop() {

				const marquee_el = this._marquee_el;

				if (!marquee_el) return;

				// READ CURRENT POSITION FIRST
				const transform = getComputedStyle(marquee_el)
					.getPropertyValue('transform');

				const matrix = new DOMMatrixReadOnly(transform);

				const currentX = matrix.m41;

				// THEN stop animation
				marquee_el.classList.remove('marquee-running');

				// freeze current transform
				marquee_el.style.transform = `translateX(${currentX}px)`;
				marquee_el.style.transition = 'none';

				// force reflow
				void marquee_el.offsetWidth;

				const duration = (
					Math.abs(currentX) / this._speed / 10
				).toFixed(3);

				marquee_el.style.transition = `
					transform ${duration}s ease-out
				`;

				marquee_el.style.transform = 'translateX(0)';

				if (marquee_el._onTransitionEnd) {
					marquee_el.removeEventListener(
						'transitionend',
						marquee_el._onTransitionEnd
					);
				}

				marquee_el._onTransitionEnd = () => {

					marquee_el.style.transition = '';
					marquee_el.style.transform = '';

					this._active = false;
				};

				marquee_el.addEventListener(
					'transitionend',
					marquee_el._onTransitionEnd,
					{ once: true }
				);
			}

			setupBounce() {

				const marquee_el = this._marquee_el;

				const overflow = (
					this._main_text_el.scrollWidth
					- this.clientWidth
				);

				if (overflow <= 0) {
					return;
				}

				const computedStyle = getComputedStyle(this);

				const edge_padding = parseFloat(
					computedStyle.getPropertyValue('--marquee-edge-padding')
				) || 24;

				const offset = overflow + edge_padding;

				const hold_time = parseFloat(
					computedStyle.getPropertyValue('--marquee-hold-time')
				) || 2;

				console.trace({ hold_time });

				const duration = Math.max(
					offset / this._speed * 2,
					3
				).toFixed(3) + hold_time * 2;

				const direction_multiplier = (
					this.direction === DIRECTIONS.rtl
						? -1
						: 1
				);

				marquee_el.style.setProperty(
					'--marquee-bounce-offset',
					`${offset * direction_multiplier}px`
				);

				marquee_el.style.setProperty(
					'--marquee-duration',
					`${duration}s`
				);

				const hold_ratio = hold_time / (duration * 2 + hold_time * 2);

				const keyframes = `
					@keyframes marquee-bounce {

						0% {
							transform: translateX(0);
						}

						${hold_ratio * 2 * 100}% {
							transform: translateX(0);
						}

						${(0.5 - hold_ratio) * 100 + hold_ratio * 100}% {
							transform: translateX(var(--marquee-bounce-offset));
						}

						${(0.5 + hold_ratio) * 100 + hold_ratio * 100}% {
							transform: translateX(var(--marquee-bounce-offset));
						}

						100% {
							transform: translateX(0);
						}
					}
				`;

				const style = document.createElement('style');
				style.textContent = keyframes;
				marquee_el.append(style);

				marquee_el.classList.add('marquee-bounce');
			}

			setupTriggers() {

				switch (this.trigger) {

					case TRIGGERS.hover:
						this.addEventListener('mouseenter', this.onMouseEnter);
						this.addEventListener('mouseleave', this.onMouseLeave);
						break;

					case TRIGGERS.click:
						this.addEventListener('click', this.onClick);
						break;

					case TRIGGERS.auto:
						this.start();
						break;
				}
			}

			removeTriggers() {

				this.removeEventListener('mouseenter', this.onMouseEnter);
				this.removeEventListener('mouseleave', this.onMouseLeave);
				this.removeEventListener('click', this.onClick);
			}

			observeContent() {

				this._observer.observe(this, {
					childList: true,
					characterData: true,
					subtree: true,
				});
			}

			observeResize() {

				this._resize_observer = new ResizeObserver(() => {

					if (this._resize_raf) {
						cancelAnimationFrame(this._resize_raf);
					}

					this._resize_raf = requestAnimationFrame(() => {

						if (!this.connected) return;

						this.update();
					});
				});

				this._resize_observer.observe(this);
			}

			onMouseEnter() {

				if (
					this.trigger === TRIGGERS.hover ||
					this.pause_on_hover
				) {
					this.start();
				}
			}

			onMouseLeave() {

				if (this.trigger !== TRIGGERS.hover) {
					return;
				}

				switch (this.behavior) {

					case BEHAVIORS.loop:
						this.rollbackLoop();
						break;

					case BEHAVIORS.bounce:
						this.rollbackLoop();
						// this.pause();
						break;
				}
			}

			onClick() {

				if (this._active) {
					this.pause();
				} else {
					this.start();
				}
			}

			start() {

				const marquee_el = this._marquee_el;

				if (!marquee_el) return;

				// cleanup rollback styles
				marquee_el.style.transition = '';
				marquee_el.style.transform = '';

				// full animation reset
				const animation_classes = [
					'marquee-running',
					'marquee-loop',
					'marquee-bounce',
					'marquee-paused',
				];

				marquee_el.classList.remove(...animation_classes);

				// force reflow
				void marquee_el.offsetWidth;

				this._active = true;

				switch (this.behavior) {

					case BEHAVIORS.loop:
						marquee_el.classList.add(
							'marquee-loop',
							'marquee-running',
						);
						break;

					case BEHAVIORS.bounce:
						marquee_el.classList.add(
							'marquee-bounce',
							'marquee-running',
						);
						break;
				}
			}

			resume() {

				const marquee_el = this._marquee_el;

				if (!marquee_el) return;

				this._active = true;

				marquee_el.classList.remove('marquee-paused');
				marquee_el.classList.add('marquee-running');
			}

			pause() {

				const marquee_el = this._marquee_el;

				if (!marquee_el) return;

				this._active = false;

				marquee_el.classList.remove('marquee-running');
				marquee_el.classList.add('marquee-paused');
			}

			stop() {

				const marquee_el = this._marquee_el;

				if (!marquee_el) return;

				this._active = false;

				marquee_el.classList.remove(
					'marquee-running',
					'marquee-paused',
					'marquee-loop',
					'marquee-bounce',
				);

				marquee_el.style.animationDuration = '';
				marquee_el.style.transform = '';
			}
		});
	}
};
;class WsMenu extends RenderableComponent {

	copyBox = false

	static get observedAttributes() {
		return ['menu-box-selector', 'width'];
	}
	/** @returns {LifecycleLayer} */
	static defineLifecycle() {
		return function ({on}) {
			on('mount:after', () => {
				this._menuBox = this.menuBoxSelector ? document.querySelector(this.menuBoxSelector) : this.ref('menu');
				if (this.copyBox) {
					this._menuBox = this._menuBox.cloneNode(true);
				}
			});
		}
	}
	get menuBoxSelector() {
		return this.attr('menu-box-selector');
	}

	templateContext() {
		return {
			clickEventName: this.attr('event', 'click'),
			width: this.attr('width'),
		};
	}

	template() {
		return `
			<self class="display_contents">
				<slot ws-on-{clickEventName}="showMenu" name="anchor" data-ref="anchor"></slot>
				<slot data-ref="menu" name="menu" ws-style="--menu-default-width: width"></slot>
			</self>
		`;
	}

	showMenu(e, el) {
		if (el.hasAttribute('disabled')) return;
		App.menu.show({
			anchor: this.ref('anchor'),
			box: this._menuBox,
			type: this.prop('type', 'mymenu'),
			force_dropdown: this._forceDropdown || this.propBool('force-dropdown', false),
			backup: this.propBool('backup', false),
			onshow: (menu) => this.onShow(menu),
			onhide: (menu) => this.onHide(menu),
			onLoad: (menu) => this.onLoad(menu),

		});
	}


	onShow(menuBox) {}

	onHide(menuBox) {}

	onLoad(menuBox) {}

}

App.components.ws_menu = {
	onBoot: function () {
		customElements.define("ws-menu", WsMenu);
	}
};
;App.components.ws_slider = {
	onBoot: function() {
		customElements.define("ws-slider", class extends HTMLElement {

			resizeObserver

			constructor() {
				super();

				this.value = this.getAttribute('value');
				this.name = this.getAttribute('name');
				this.invalid = false;
				this.options = Array.from(this.querySelectorAll('option'));
				this.labels = [];
				const self = this;

				this.options.forEach((option, index) => {
					option.style.display = 'none';
					let value = option.hasAttribute('value') ? option.getAttribute('value') : option.innerText;
					let block = document.createElement('a');

					if (!this.value && index===0) this.value = value;

					block.innerHTML = option.innerHTML;
					if (option.disabled) block.setAttribute('disabled', '');
					if (option.getAttribute('onclick')) block.setAttribute('onclick', option.getAttribute('onclick'));
					if (option.getAttribute('data-title')) block.setAttribute('data-title', option.getAttribute('data-title'));
					option.classList.forEach(className => {
						block.classList.add(className);
					});
					if (block.childElementCount === 0 ) this.classList.add('string');
					block.setAttribute('data-value', value);
					block.onclick = function() {
						if (this.classList.contains('act') || this.hasAttribute('disabled')) {
							return;
						}
						self.its_value = this.getAttribute('data-value');
						this.parentNode.setAttribute('value', this.getAttribute('data-value'));
						if (this.getAttribute('onclick')) eval(this.getAttribute('onclick'));
					};
					if (value === this.value && !option.disabled) block.classList.add('act','wsinit');
					$(block).each(function() {
						$(this).contents().eq(2).wrap('<span/>');
					});
					this.appendChild(block);
					this.removeChild(option);
				});

				let input = document.createElement('input');
				input.setAttribute('type', 'hidden');
				input.setAttribute('name', this.name);
				input.setAttribute('value', this.value);
				if (this.getAttribute('id')) {
					input.setAttribute('id', this.id);
					this.removeAttribute('id');
				}
				this.appendChild(input);
			}

			static get observedAttributes() {
				return ["value"];
			}

			set its_value(value) {
				this.setAttribute('value', value);
				this.emitEvent('change', {value});
			}

			get its_value() { return (this.getAttribute('value') || '').trim(); }

			attributeChangedCallback() {
				$(this).find('a').removeClass('act').removeClass('wsinit');
				$(this).find('a[data-value="'+this.its_value+'"]').addClass('act');
				$(this).find('input').attr('value', this.its_value);
				if($(this).closest('form')) $(this).closest('form').trigger('change');
				this.updateAniBg();
			}

			updateAniBg = function() {
				const slider = $(this);
				const active_tab = slider.find('a.act');
				const ani_bg = slider.find('i.bg');

				if (active_tab.length === 0 || active_tab.outerWidth() === 0) {
					ani_bg.hide();
					return;
				}

				ani_bg.show();
				ani_bg.css({
					width: active_tab.outerWidth(),
					height: active_tab.outerHeight(),
					top: active_tab.position().top,
					left: active_tab.position().left,
				});
			}

			connectedCallback() {
				const ani_bg = $('<i>', { class: 'bg' });

				this.appendChild(ani_bg.get(0));

				const waitTransition = $(this).closest('.menu, .modal').length > 0;
				let watchResize = false;

				const init = () => {
					watchResize = true;
					this.updateAniBg();
					ani_bg.addClass('ani');
				}

				if (!waitTransition) {
					requestAnimationFrame(init);
				} else {
					$(this).closest('.menu, .modal').one('transitionend', init);
				}

				this.resizeObserver = new ResizeObserver(() => {
					if (watchResize) this.updateAniBg()
				});

				this.querySelectorAll('a').forEach(tab => this.resizeObserver.observe(tab));
			}

			disconnectedCallback() {
				$(this).find('i.bg').remove();

				if (this.resizeObserver) {
					this.resizeObserver.disconnect();
				}
			}
		});
	}
}

$.valHooks['ws-slider'] = {
	get: function(el) {
		return $(el).attr('value');
	},
	// todo якщо треба, можна додати перевірку option (див. $.valHooks.select)
	set: function(el, value) {
		$(el).attr('value', value);
	}
};

;class WsTaskMenuGrid extends WsMenu {
	_unmount = [];
	_forceDropdown = true;

	static get observedAttributes() {
		return ['task-id', 'com-id'];
	}

	get menuBoxSelector() {
		return '#quickGridTaskMenu'
	}

	get taskUrl() {
		const taskId = this.attr('task-id');
		const comId = this.attr('com-id');
		let url = App.helper.url.task(taskId)
		if (comId) {
			url += '#com' + comId;
		}
		return url;
	}

	onShow(menuBox) {
		menuBox.css('--menu-default-width', 'auto');
		const {unbind} = menuBox.addDelegatedEventListener('click', '.menu__item[data-key]', (e, menuItem) => {
			const key = menuItem.dataset.key;
			switch (key) {
				case 'open': {
					App.core.goto(this.taskUrl);
					break;
				}
				case 'filter': {
					App.page.filter_update({'task': this.attr('task-id')});
					break;
				}
			}
			App.menu.hide();
		});
		this._unmount.push(unbind);
	}

	onHide(menuBox) {
		this._unmount.forEach(unbind => unbind());
		this._unmount = [];
	}
}

class WsTaskGridRowMenu extends WsMenu {
	showMenu(event) {
		App.menu.log_mouse_position(event);
		App.controls.task_menu.show(this.ref('anchor'), App.helper.url.task(this.attr('task-id')),)
	}
}

class WsUserTemplateMenu extends WsMenu {

	/**
	 * @returns {LifecycleLayer}
	 */
	static defineLifecycle() {
		/**
		 * @this {WsUserTemplateMenu}
		 */
		return function ({once, on}) {
			once('mount:before', () => {
				this.useStore('team', App.state.team, {
					select: (store) => store.get(this.propJson('selectedTemplate', {}).user)
				});
			});
			once('mount:after', () => {
				this._menuBox.addEventListenerWs('userTemplate:saved', ({detail}) => {
					this.setProp('currentTemplate', detail);
				});
				const selectTemplateAnchor = this.ref('select_template');
				if (!selectTemplateAnchor) {
					return;
				}
				selectTemplateAnchor.addEventListenerWs('click', (e) => {
					App.controls.user_template.select_template_and_go({
						anchor: selectTemplateAnchor, backup: true,
					}, {type: this.propInt('template-type')}, {
						onSelect: (data) => {
							this.setProp('selectedTemplate', data);
							App.menu.hide();
							App.menu.hide();
							App.helper.nextTick(() => {
								this.emitEvent('update:selectedTemplate', data);
							});
						}
					})
				});
			});
			on('update', () => {
				[this.propJson('selectedTemplate', {}).id_user, this.propJson('currentTemplate', {}).id_user].forEach((id) => {
					id && App.state.team.ensure(id)
				})
			})
		};
	}

	selectDefaultTemplate(e, el) {
		const data = {
			id: Number(el.dataset.id),
			id_user: Number(el.dataset.idUser),
			name: el.dataset.name,
		};
		this.setProp('selectedTemplate', data);
		App.menu.hide();
		App.helper.nextTick(() => {
			this.emitEvent('update:selectedTemplate', data);
		});
	}

	templateContext() {
		const superContext = super.templateContext();
		superContext.selectedTemplate = this.propJson('selectedTemplate', {});
		superContext.selectedTemplate.user = App.state.team.get(superContext.selectedTemplate.id_user);
		superContext.currentTemplate = this.propJson('currentTemplate', {});
		superContext.currentTemplate.user = App.state.team.get(superContext.currentTemplate.id_user);
		return superContext;
	}

	template() {
		return `
			<self class="display_contents">
				<slot ws-on-{clickEventName}="showMenu" name="anchor" data-ref="anchor"></slot>
				<slot data-ref="menu" name="menu" ws-style="--menu-default-width: width"></slot>
				<slot></slot>
			</self>
		`;
	}

	clearSelectedTemplate() {
		this.setProp('selectedTemplate', {});
		App.helper.nextTick(() => {
			this.emitEvent('update:selectedTemplate', {});
		});
	}

	deleteOwnCurrentTemplate(e, el) {
		App.controls.confirm.menu(el, {
			message: App.object_state.locale.ask_delete,
			ok_label: App.object_state.locale.yes_delete,
			onconfirm: () => App.controls.user_template.delete_template(this.propJson('currentTemplate').id, {
				onSuccess: ({message}) => {
					this.setProp('currentTemplate', {});
					App.message.success(message)
				}
			})
		});

	}
}

class WsSaveUserTemplateMenu extends WsMenu {

	/**
	 * @returns {LifecycleLayer}
	 */
	static defineLifecycle() {
		/**
		 * @this {WsSaveUserTemplateMenu}
		 */
		return function ({once, on}) {
			once('constructed', () => {
				this._form = App.helper.useForm({
					initialValues: {
						name: '', visibility: 0, type: this.propInt('template-type'),
					}, validate({name, visibility}) {
						if (!name?.trim()) {
							return {name: 'Name cannot be empty'};
						}
						if (App.controls.datatable.customize_menu.is_dirty()) {
							return {_form: 'Please apply or discard your changes to the datatable before saving the template.'};
						}
						if (![0, 1, 2, 3].includes(Number(visibility))) {
							return {visibility: 'Invalid visibility value'};
						}
						return {};
					}, onSubmit: (values) => {
						App.controls.user_template.save_template(values, {
							onSuccess: this._onSaved
						});
					}
				});
				this._form.subscribe(() => this.invalidateLifecycle('form:change'));
				this.useConnection('datatable:menu:change', () => {
					const {unbind} = document.querySelector('#dataTable__menu').addEventListenerWs('change', () => {
						this.invalidateLifecycle('datatable:change-edited');
					});
					return unbind;
				})
			});
		};
	}

	/** @type {OnSavedCallback} */
	_onSaved = ({message, data}) => {
		App.menu.hide();
		this.emitEvent('userTemplate:saved', data);
		App.message.success(message)
	}

	provides() {
		return {
			form: this._form,
		}
	}

	templateContext() {
		const superContext = super.templateContext();
		superContext.isValid = this._form.isValid;
		superContext.form = this._form;
		superContext.canSaveTemplate = !App.controls.datatable.customize_menu.is_dirty();
		return superContext;
	}
}

class WsMoreUserTemplateMenu extends WsMenu {

	_unmount = [];
	copyBox = true;

	get menuBoxSelector() {
		return '#userTemplateMoreMenu'
	}

	onShow(menuBox) {
		menuBox.querySelector('[data-role="edit_group"]')?.toggle(this.propBool('can-edit'))
		menuBox.querySelector('[data-role="delete_group"]')?.toggle(this.propBool('can-edit'))
		const {unbind} = menuBox.addDelegatedEventListener('click', '.menu__item[data-key]', (e, menuItem) => {
			const key = menuItem.dataset.key;
			const templateId = this.propInt('template-id');
			switch (key) {
				case 'delete': {
					App.controls.confirm.menu(menuItem, {
						message: App.object_state.locale.ask_delete,
						ok_label: App.object_state.locale.yes_delete,
						onconfirm: () => App.controls.user_template.delete_template(templateId, {
							onSuccess: ({message}) => {
								App.message.success(message)
								App.menu.hide();
							}
						})
					});
					break;
				}
				case 'edit': {
					App.controls.edit_field_menu.show({
						anchor: this.slot('anchor'),
						backup: true
					}, {
						onSubmit: (value) => {
							App.controls.user_template.update_template(templateId, {
								name: value
							}, {
								onSuccess: ({message}) => {
									App.message.success(message)
									App.menu.hide();
								}
							});
						}
					}, {
						maxLength: 44,
						value: this.prop('template-name'),
					})
					break;
				}
			}
		});
		this._unmount.push(unbind);
	}

	onHide(menu) {
		this._unmount.forEach(unbind => unbind());
		this._unmount = [];
	}


}


App.components.ws_special_menus = {
	onBoot: function () {
		customElements.define("ws-task-menu-grid", WsTaskMenuGrid);
		customElements.define("ws-task-grid-row-menu", WsTaskGridRowMenu);
		customElements.define("ws-user-template-menu", WsUserTemplateMenu);
		customElements.define("ws-save-user-template-menu", WsSaveUserTemplateMenu);
		customElements.define("ws-more-user-menu", WsMoreUserTemplateMenu);
	}
};
;class WSSwitch extends RenderableComponent {
	static get observedAttributes() {
		return [
			'color',
			'checked',
			'size',
		]
	}

	get checked() {
		return App.helper.parseBoolean(this.attr('checked', false));
	}

	templateContext() {
		return {
			color: this.attr('color', 'a'),
			checked: this.checked,
			size: this.attr('size', 'small'),
		}
	}

	template() {
		return `
			<self class="sw_pre"
				ws-host-class="[ 'sw_color_' + color, checked && 'sw_act', 'sw_' + size] " 
				ws-host-on-click="toggle"
				>
				<span class="sw" ><span></span></span>
			</self>
		`
	}



	toggle() {
		this.checked ? this.uncheck() : this.check();
	}

	check(silent = false) {
		this.setAttribute('checked', 'true');
		if (!silent) {
			this.dispatchEvent(new CustomEvent('checked', {bubbles: true, composed: true, cancelable: false}));
			this.dispatchEvent(new CustomEvent('change', {
				bubbles: true, composed: true, cancelable: false, detail: {
					checked: true
				}
			}));
		}
	}

	uncheck(silent = false) {
		this.removeAttribute('checked');
		if (!silent) {
			this.dispatchEvent(new CustomEvent('unchecked', {bubbles: true, composed: true, cancelable: false}));
			this.dispatchEvent(new CustomEvent('change', {
				bubbles: true, composed: true, cancelable: false, detail: {
					checked: false
				}
			}));
		}
	}
}

App.components.ws_switch = {
	onBoot: function () {
		customElements.define("ws-switch", WSSwitch);
	}
};
;class WSSwitcher extends RenderableComponent {
	static get observedAttributes() {
		return ['value', 'horizontal'];
	}

	bindonclick(event) {
		App.device.is_mobile() ? this.toggleMobile(event) : this.toggleDesktop(event);
	}

	templateContext() {
		return {
			options: this.options.map((o, i) => { o.index = i; return o; }),
			horizontal: this.propBool('horizontal', true),
			activeIndex: this.activeIndex,
		};
	}

	/**
	 * @returns {Array}
	 */
	get options() {
		return this.propJson('options', []);
	}

	get activeIndex() {
		return this._getIndex(this.attr('value'));
	}

	_getIndex(value) {
		return this.options.findIndex(o => o.value === value);
	}

	template() {
		return `
			<self>
				<a
					data-ref="switcher"
					class="switcher withRipple"
					ws-class="[ horizontal && 'switcher--horizontal' ]"
					ws-attr-data-active-index="activeIndex"
					ws-style="--switcher-n: options.length; --switcher-active-i: activeIndex + 1;"
				>
					<div class="switcher__track">
						{{ for (option in options) }}
							<div
								data-ref="item"
								class="switcher__item"
								value="{option.value}"
								ws-class="[ {option.index} == activeIndex && 'switcher__item--active' ]"
							></div>
						{{ endfor }}
					</div>
				</a>
			</self>
		`;
	}

	toggleMobile(event) {
		const current_index = Number(this.activeIndex);
		const current_item = this.refs('item')[current_index];

		const next_item = current_item.nextElementSibling ?? this.refs('item')[0];

		this.selectOption(next_item);
	}

	toggleDesktop(event) {

		const current_index = Number(this.activeIndex);
		const current_item = this.refs('item')[current_index];

		if (event.target === current_item) {
			return;
		}

		const target_item = event.target.closest('[data-ref=item]');
		const next_item = target_item ?? current_item.nextElementSibling ?? this.refs('item')[0];

		this.selectOption(next_item);
	}

	selectOption(item) {
		const new_index = this._getIndex(item.getAttribute('value'));
		const new_option = this.options[new_index];
		const switcher = this.ref('switcher');

		switcher.classList.toggle('switcher--forward', new_index > this.activeIndex);
		switcher.classList.toggle('switcher--backward', new_index < this.activeIndex);

		this.setAttribute('value', new_option.value);

		const onclick = new_option.onclick;
		if (!onclick) return;

		if (typeof onclick === 'function') {
			opt.onclick();
		} else if (typeof onclick === 'string') {
			new Function(onclick)();
		}
	}
}

App.components.ws_switcher = {
	onBoot: function () {
		customElements.define("ws-switcher", WSSwitcher);
	}
};
;class FieldType extends SingletonMixin() {

	editMode = 'inline';
	defaultIcon = 'editor/text_style';
	focusRef = 'input_value';
	inlineActions = [];
	minWidthForInline = 120;
	menuWidth = 280;
	validateOnInput = true;

	/**
	 * @return {string[]}
	 */
	get observedAttributes() {
		return ['value'];
	}


	decode(raw) {
		return {value: raw ?? ''};
	}

	/**
	 * @param {Record<string, any>} decoded
	 * @return {string}
	 */
	encode(decoded) {
		return decoded;
	}

	/**
	 * @param {Record<string, any>} decoded
	 * @param {CustomField} c
	 * @return {ValidationResult}
	 */
	validate(decoded, c) {
		return ValidationResult.ok();
	}

	/**
	 * @param {Record<string, any>} decoded
	 * @param {CustomField} c
	 * @return {string|number}
	 */
	preview(decoded, c) {
		return decoded.value || '';
	}

	/**
	 * @param {Record<string, any>} decoded
	 * @return {boolean}
	 */
	hasValue(decoded) {
		return !!(decoded.value || '').trim();
	}

	/**
	 * @param {Record<string, any>} decoded
	 * @return {string}
	 */
	hintValue(decoded) {
		return '';
	}

	/**
	 * @param {CustomField} c
	 * @param {Record<string, any>} ctx
	 */
	expose(c, ctx) {
	}

	/**
	 * @param {CustomField} component
	 * @param {Event} e
	 */
	onClick(component, e) {
		component.edit(e);
	}

	/**
	 * @param {CustomField} component
	 * @param {CustomFieldsState} state
	 */
	onStateChange(component, state) {
	}

	/**
	 * @param {CustomField} component
	 * @param {String} key
	 * @param {any} value
	 */
	onChange(component, key, value) {
	}

	/**
	 * @param {CustomField} component
	 */
	onApply(component) {
	}

	/**
	 * @param {CustomField} component
	 */
	openMenu(component) {
		throw new Error(`${this.constructor.name}: openMenu not implemented`);
	}

	/**
	 * @param {CustomField} component
	 * @param {Event} e
	 */
	openEditMenu(component, e) {
		component.edit(e);
		App.helper.nextTick(() => {
			const box = component.querySelector('.custom-field__edit');
			if (!box) return;

			component._menuEditRoot = box;
			box.addClass('menu').addClass('menu-primary');

			App.menu.show({
				anchor: component,
				backup: false,
				type: 'left',
				width: this.menuWidth,
				box,
				onhide: () => {
					component._menuEditRoot = null;
					box.removeClass('menu').removeClass('menu-primary');
					component.append(box);
					App.helper.nextTick(() => {
						if (component.prop('state') !== 'edit') return;
						component.cancel();
					});
				},
			});
		});
	}

	/**
	 * @param {Event} e
	 */
	filterInput(e) {
	}

	/**
	 * @param {Event} e
	 * @param {'up'|'down'|'left'|'right'} direction
	 * @param {CustomField} c
	 */
	arrowControl(e, direction, c) {
	}

	/**
	 * @param {CustomField} component
	 * @return {Record<string, any>}
	 */
	resolveContext(component) {
		return component.requestHandshake('custom_field_context', {
			details: {id_field: component.idField},
		});
	}

	/**
	 * @param {CustomField} component
	 * @param {(menu:HTMLElement, component: CustomField, url: string) => {}} onShow
	 * @param {(menu:HTMLElement, component: CustomField, url: string) => {}} onHide
	 * @param {Record<string, any>} request
	 * @return {Pick<MenuShowData, 'url'|'title'|'cache_trigger'|'width'|'type'|'onload'|'onshow'|'onhide'>}
	 */
	buildMenuParams(component, {onShow, onHide, request = {}} = {}) {
		const {external_edit_url} = this.resolveContext(component);
		const url = App.helper.url.add_query(external_edit_url, '', {
			render: 'menu',
			template: 'menu',
			id_field: component.idField,
			...request,
		});

		return {
			url,
			title: App.object_state.locale['user'],
			cache_trigger: 'user',
			width: 324,
			type: 'left',
			onload: (menu) => App.controls.menu.init(menu),
			onshow: (menu) => onShow?.(menu, component, url),
			onhide: (menu) => onHide?.(menu, component, url),
		};
	}

	/**
	 * @param {CustomField} component
	 */
	useStore(component) {

	}

	/**
	 *
	 * @param {Record<string, any>} field
	 * @return {Record<string, any>}
	 */
	syncFields(field) {
		return {};
	}

	/**
	 * @param {CustomField} component
	 */
	onMount(component) {
	}

	/**
	 * @param {CustomField} component
	 */
	detailedPreview(component) {}
}


class ValidationResult {

	static _OK = null;

	error;
	meta;
	message;
	fieldErrors;

	constructor({error = false, meta = {}, message = '', fieldErrors = {}} = {}) {
		this.error = error;
		this.meta = meta;
		this.message = message;
		this.fieldErrors = fieldErrors;
	}

	static ok(meta) {
		if (!meta) return this._OK ||= new ValidationResult();
		return new ValidationResult({meta});
	}

	static fail(message, {fieldErrors = {}, meta = {}} = {}) {
		return new ValidationResult({
			error: true,
			message,
			meta,
			fieldErrors,
		});
	}
}


class TextType extends FieldType {

	inlineActions = ['copy'];

	/**
	 * @return {string[]}
	 */
	get observedAttributes() {
		return ['value', 'placeholder', 'max-length', 'apply-on-icon'];
	}

	expose(c, ctx) {
		ctx.applyOnIcon = c.prop('apply-on-icon');
		ctx.copyValue = c.prop('value');
		ctx.maxLength = c.prop('max-length');
		ctx.openValue = c.prop('value');
	}

	hintValue(decoded) {
		return decoded.value || '';
	}

	/**
	 * @return {ValidationResult}
	 */
	validate(decoded, c) {
		const len = (decoded.value || '').length;
		const maxLength = c.prop('max-length') ? c.propInt('max-length') : null;
		const lengthLeft = maxLength === null ? null : maxLength - len;
		const validator = Validator.make(decoded,  {
			value: [StringRule.make({
				max: maxLength || Infinity,
			})]
		})
		validator.validate();
		if (!validator.fails()) {
			return ValidationResult.ok({
				lengthLeft,
				showLengthLeft: maxLength !== null && lengthLeft <= 20,
			});
		}

		return ValidationResult.fail(validator.getErrors('value').join('; '), {
			meta: {lengthLeft, showLengthLeft: true},
			fieldErrors: validator.getErrors(),
		});
	}
}

class TextareaType extends TextType {
	defaultIcon = 'editor/paragraph';
	minWidthForInline = 160;
	editMode = 'menu';
	menuWidth = 500;
	openEditMenu(component, e) {
		component.edit(e);
		App.helper.nextTick(() => {
			const box = component.querySelector('.custom-field__edit');
			if (!box) return;

			component._menuEditRoot = box;
			box.addClass('menu').addClass('menu-primary');

			App.menu.show({
				anchor: component,
				backup: false,
				type: 'left',
				width: Math.max(this.menuWidth, component.offsetWidth),
				box,
				offset: {
					left: -12
				},
				onhide: () => {
					component._menuEditRoot = null;
					box.removeClass('menu').removeClass('menu-primary');
					component.append(box);
					App.helper.nextTick(() => {
						if (component.prop('state') !== 'edit') return;
						component.cancel();
					});
				},
			});
		});
	}
}

class EmailType extends TextType {
	defaultIcon = 'at_sign';
	minWidthForInline = 160;
	validateOnInput = false;

	inlineActions = ['copy', 'open'];

	validate(decoded, c) {
		const validator = Validator.make(decoded,  {
			value: [NullableRule, EmailRule]
		})
		validator.validate();
		if (!validator.fails()) {
			return ValidationResult.ok({})
		}
		return ValidationResult.fail(validator.getErrors('value').join('; '), {fieldErrors: validator.getErrors()});
	}
}

class AddressType extends TextType {
	defaultIcon = 'location';
	minWidthForInline = 160;

	inlineActions = ['copy', 'open'];
}

class NumberType extends TextType {

	defaultIcon = 'hash';

	/**
	 * @return {string[]}
	 */
	get observedAttributes() {
		return [...super.observedAttributes, 'max', 'min', 'step', 'prefix'];
	}

	expose(c, ctx) {
		super.expose(c, ctx);
		ctx.min = c.prop('min');
		ctx.max = c.prop('max');
		ctx.step = c.prop('step');
		ctx.filterInput = c._boundFilterInput ||= (e) => this.filterInput(e);
		ctx.stepCallback = c._boundArrowControl ||= (e, dir) => this.arrowControl(e, dir, c);
	}

	validate(decoded, c) {
		const validator = Validator.make(decoded,  {
			value: [NullableRule, NumberRule.make({
				min: c.prop('min') === null ? -Infinity : c.propFloat('min'),
				max: c.prop('max') === null ? Infinity : c.propFloat('max')
			})]
		})
		validator.validate();
		if (!validator.fails()) {
			return ValidationResult.ok({})
		}
		return ValidationResult.fail(validator.getErrors('value').join('; '), {fieldErrors: validator.getErrors()});
	}

	preview(decoded, c) {
		let str = decoded.value ?? '';
		if (c.prop('prefix')) str = `${c.prop('prefix')} ${str}`;
		if (c.prop('suffix')) str = `${str} ${c.prop('suffix')}`;
		return str;
	}

	_isValidNumericString(data) {
		return /^-?\d*(?:[,.]\d*)?$/.test(data);
	}

	_exceedsStepDecimals(data, stepDecimals) {
		if (stepDecimals === null || !data) return false;
		const pasteDecimals = (data.split(/[,.]/)[1] || '').length;
		return pasteDecimals > stepDecimals;
	}

	_wouldExceedDecimals(value, selStart, selEnd, data, stepDecimals) {
		if (stepDecimals === null) return false;
		const afterEdit = value.slice(0, selStart) + data + value.slice(selEnd);
		const sepIndex = afterEdit.search(/[,.]/);
		return sepIndex !== -1 && afterEdit.length - sepIndex - 1 > stepDecimals;
	}

	_isSeparatorAllowed(value, selStart, selEnd, stepDecimals) {
		if (stepDecimals !== null && stepDecimals === 0) return false;
		const stripped = value.slice(0, selStart) + value.slice(selEnd);
		return !stripped.includes('.') && !stripped.includes(',');
	}

	filterInput(e) {
		const {data, inputType} = e;
		const {target: input} = e;
		const stepRaw = input.step;
		const stepDecimals = (stepRaw && stepRaw !== 'any') ? (stepRaw.split('.')[1] || '').length : null;

		if (inputType === 'insertFromPaste') {
			if ((data && !this._isValidNumericString(data)) || this._exceedsStepDecimals(data, stepDecimals)) {
				e.preventDefault();
			}
			return;
		}

		if (!data) return;

		const {value, selectionStart: selStart, selectionEnd: selEnd} = input;

		if (/^\d+$/.test(data)) {
			if (this._wouldExceedDecimals(value, selStart, selEnd, data, stepDecimals)) e.preventDefault();
			return;
		}

		if (data === '-' && selStart === 0 && !value.slice(selEnd).includes('-')) return;

		if ((data === '.' || data === ',') && this._isSeparatorAllowed(value, selStart, selEnd, stepDecimals)) return;

		e.preventDefault();
	}

	arrowControl(e, direction, c) {
		const val = c.propFloat('value', 0);
		const step = c.propFloat('step', 1);
		if (Number.isNaN(val) || Number.isNaN(step) || step <= 0) return;

		const min = c.prop('min') === null ? -Infinity : c.propFloat('min');
		const max = c.prop('max') === null ? Infinity : c.propFloat('max');
		const raw = direction === 'up' ? val + step : val - step;

		const decimals = (String(step).split('.')[1] || '').length;
		const next = decimals > 0
			? Number.parseFloat(Math.min(max, Math.max(min, raw)).toFixed(decimals))
			: Math.round(Math.min(max, Math.max(min, raw)));

		const strValue = String(next);
		c.change(e, 'value', strValue);
		const input = c.ref('input_value');
		if (input) input.value = strValue;
	}

}

class NumberWithUnitType extends NumberType {

	defaultIcon = 'hash';

	/**
	 * @return {string[]}
	 */
	get observedAttributes() {
		return [...super.observedAttributes, 'unit'];
	}

	expose(c, ctx) {
		super.expose(c, ctx);
		ctx.min = c.prop('min');
		ctx.max = c.prop('max');
		ctx.step = c.prop('step');
		ctx.unit = c.prop('unit');
		ctx.filterInput = c._boundFilterInput ||= (e) => this.filterInput(e);
		ctx.stepCallback = c._boundArrowControl ||= (e, dir) => this.arrowControl(e, dir, c);
	}


	preview(decoded, c) {
		return decoded.value ?? '';
	}
}


class PhoneType extends TextType {

	defaultIcon = 'phone';
	validateOnInput = false;

	validate(decoded) {
		const validator = Validator.make(decoded, {
			value: [NullableRule, RegexRule.make({
				pattern: /^\+?[\d\s()\-]{7,}$/,
			})]
		}, {
			'value': {
				'validator_messages.regex': App.i18n.t('validator_messages.phone_format')
			}
		})
		validator.validate();
		if (!validator.fails()) {
			return ValidationResult.ok();
		}
		return ValidationResult.fail(validator.getErrors('value').join('; '), {fieldErrors: validator.getErrors()});
	}
}


class LinkType extends FieldType {

	editMode = 'menu';
	defaultIcon = 'language';
	focusRef = 'input_name';
	menuWidth = 324;
	inlineActions = ['copy', 'open'];

	get observedAttributes() {
		return ['value', 'name-placeholder', 'link-placeholder'];
	}

	decode(raw) {
		try {
			const parsed = JSON.parse(raw || '{}');
			return {name: parsed.name || '', link: parsed.link || ''};
		} catch {
			return {name: '', link: ''};
		}
	}

	encode(decoded) {
		return {value: JSON.stringify({name: decoded.name || '', link: decoded.link || ''})};
	}

	expose(c, ctx) {
		const decoded = c.decodeValue();
		ctx.placeholder = c.prop('name-placeholder');
		ctx.linkPlaceholder = c.prop('link-placeholder');
		ctx.link = decoded.link;
		ctx.name = decoded.name;
		const normalizedUrl = this.normalizeUrl(c, decoded.link);
		ctx.copyValue = normalizedUrl;
		ctx.openValue = normalizedUrl;
		ctx.hintValue = normalizedUrl;
		ctx.favicon = c.prop('favicon');
		ctx.faviconLoaded = (e, el) => {
			if (el.naturalWidth !== 32) {
				c._faviconErrored = true;
				c.setProp('favicon', null);
			}
		}
	}

	normalizeUrl(component, url) {
		if (!component.propBool('is-web')) {
			return url;
		}
		url = URLBuilder.parse(url);
		if (!url.scheme.length) {
			url.apply('https://')
		}
		return url;
	}


	loadFavicon(c) {
		const decoded = c.decodeValue();
		const domain = App.helper.url.domain(decoded.link);
		if (domain !== c._lastDomain) {
			c._faviconErrored = false;
			c._lastDomain = domain;
		}
		if (!c._faviconErrored) {
			c.setProp('favicon', App.helper.url.favicon(decoded.link));
		}
	}

	onApply(component) {
		this.loadFavicon(component);

	}

	onMount(component) {
		this.loadFavicon(component);
	}


	preview(decoded) {
		return decoded.name || decoded.link || '';
	}

	hasValue(decoded) {
		return !!(decoded.link || '').trim();
	}

	openEditMenu(component, e) {
		const decoded = component.decodeValue();
		if (decoded.link?.length) {
			App.menu.show({
				anchor: component,
				type: 'left',
				force_dropdown: true,
				box: '#quickCustomFieldLinkMenu',
				onshow: (menu) => {
					const canEdit = !component.propBool('readonly');
					$(menu).find('[data-key=edit]').toggle(canEdit);
					const url = this.normalizeUrl(component, decoded.link);
					$(menu).find('[data-key=copy]')
						.attr('data-copy-val', url)
						.attr('rel', App.object_state.locale?.copied || 'Скопійовано!');
					const {unbind} = menu.addDelegatedEventListener('click', '[data-key]', (e, el) => {
						switch (el.dataset.key) {
							case 'edit': {
								App.menu.hide();
								component.setProp('linkTemp', decoded.link);
								component.setProp('nameTemp', decoded.name);
								this.#editMenu(component, e);
								break;
							}
							case 'open': {
								App.menu.hide();
								component.actions.open(e, url);
								break;
							}
							case 'copy': {
								const val = $(el).attr('data-copy-val');
								App.core.clipboard_from_menu(el, val);
								break;
							}
						}
					});
					menu.unbind = unbind;
				},
				onhide: (menu) => {
					menu.unbind()
				}
			})
		} else {
			this.#editMenu(component, e);
		}

	}

	#editMenu(component, e) {
		const decoded = component.decodeValue();
		App.menu.show({
			anchor: component,
			box: document.querySelector('#editorLinkMenu').cloneNode(true),
			width: 330,
			type: 'left',
			onshow: (menu) => {
				const submit = (e) => {
					component.change(e, 'name', label.value);
					component.change(e, 'link', href.value);
					component.apply(e);
				}
				const cancel = e => {
					component.cancel(e);
				}
				const toggleBtns = () => {
					deleteBtn.toggleClass('hiddenBlock', href.value.length === 0);
					openBtn.toggleClass('hiddenBlock', href.value.length === 0);
				}

				const deleteBtn = menu.querySelector('[name*=delete]');
				const openBtn = menu.querySelector('[name*=open]');
				const submitBtn = menu.querySelector('[name*=primary]');
				const label = menu.querySelector('input[name=label]');
				const href = menu.querySelector('input[name=href]');

				label.value = decoded.name;
				href.value = decoded.link;
				toggleBtns();

				deleteBtn.addEventListener('click', e => {
					href.value = '';
					submit(e)
				})
				submitBtn.addEventListener('click', e => {
					submit(e)
				})
				openBtn.addEventListener('click', e => {
					component.actions.open(e, this.normalizeUrl(component, href.value));
				})
				href.addEventListener('input', () => {
					toggleBtns();
				});
				[label, href].forEach(input => input.addEventListener('keydown', (e) =>  {
					let key = e.keyCode ? e.keyCode : e.charCode;
					switch (key) {
						case App.keycode.Enter:
							submit(e);
							break;
						case App.keycode.Escape:
							cancel(e);
							break;
					}
				}))
			},
			onhide: (menu) => {
				menu.remove();
			}
		})
	}
}


class BooleanType extends FieldType {

	editMode = 'none';
	defaultIcon = null;

	get observedAttributes() {
		return ['value', 'true-label', 'false-label'];
	}

	onClick(component, e) {
		component.change(e, 'value', String(!component.propBool('value', false)));
		component.apply(e);
	}

	syncFields(field) {
		if (!field) return null;
		return {
			'true-label': field.options.find(o => o.key == 1)?.value || 'Yes',
			'false-label': field.options.find(o => o.key == 0)?.value || 'No',
		};
	}

	preview(decoded, c) {
		return c.propBool('value', false) ? c.prop('true-label', 'Yes') : c.prop('false-label', 'No');
	}

	expose(c, ctx) {
		super.expose(c, ctx);
		ctx.boolValue = c.propBool('value', false);
	}

	hasValue(decoded) {
		const {value} = decoded;
		return value !== undefined
			&& ((typeof value === 'string' && value.length > 0) || typeof value === 'boolean');
	}
}


class UserType extends FieldType {

	editMode = 'external';
	defaultIcon = 'person';

	useStore(component) {
		component.useStore('team', App.state.team, {
			invalidate: (changeset) => !!changeset.get(component.prop('value'))
		});
	}

	expose(component, ctx) {
		App.state.team.ensure(component.prop('value'), component.getValueProof());
		ctx.user = App.state.team.get(component.prop('value'));
	}

	preview(decoded, c) {
		const id_user = c.prop('value');
		return id_user ? App.state.team.get(id_user).name : '';
	}

	hasValue(decoded) {
		return !!decoded.value;
	}

	buildUserMenuParams(component, options = {}) {
		return this.buildMenuParams(component, {
			...options,
			onShow: (menu, component) => {
				App.controls.user_select_and_go.onshow(menu);
				options.onShow?.(menu, component);
			},
		});
	}

	openMenu(component) {
		App.menu.show({
			anchor: component,
			backup: false,
			...this.buildUserMenuParams(component, {
				onShow(menu) {
					menu.unbind?.();
					const {unbind} = menu.addDelegatedEventListener('click', '.menu__item[data-id]', (event, item) => {
						component.change(event, 'value', item.dataset.id);
						component.apply(event);
					});
					menu.unbind = unbind;
				},
				onHide: (menu) => menu.unbind?.(),
			}),
		});
	}
}

class ContactType extends FieldType {

	editMode = 'external';
	defaultIcon = 'person';


	useStore(component) {
		component.useStore('contacts', App.state.contacts, {
			invalidate: (changeset) => !!changeset.get(component.prop('value'))
		});
	}

	expose(component, ctx) {
		App.state.contacts.ensure(component.prop('value'), component.getValueProof());
		ctx.user = App.state.contacts.get(component.prop('value'));
	}

	preview(decoded, c) {
		const id_user = c.prop('value');
		return id_user ? App.state.contacts.get(id_user).name : '';
	}

	hasValue(decoded) {
		return !!decoded.value;
	}

	buildContactMenuParams(component, options = {}) {
		return this.buildMenuParams(component, {
			...options,
			onShow: (menu, component, url) => {
				App.controls.contact_select_and_go.init.apply(menu, [{url}]);
				options.onShow?.(menu, component);
			},
		});
	}

	openMenu(component) {
		App.menu.show({
			anchor: component,
			backup: false,
			...this.buildContactMenuParams(component, {
				onShow(menu) {
					menu.unbind?.();
					const {unbind} = menu.addDelegatedEventListener('click', '.menu__item[data-id]', (event, item) => {
						component.change(event, 'value', item.dataset.id);
						component.apply(event);
					});
					menu.unbind = unbind;
				},
				onHide: (menu) => menu.unbind?.(),
			}),
		});
	}
}

class UserMultipleType extends UserType {

	defaultIcon = 'news/users';
	#iconSize = 24;

	useStore(component) {
		component.useStore('team', App.state.team, {
			invalidate: (changeset) => this.#getUsersIds(component).some((i) => changeset.has(i))
		});
	}

	expose(c, ctx) {
		const userIds = this.#getUsersIds(c);
		ctx.users = userIds.map(id => App.state.team.get(id));
		const componentWidth = c.firstElementChild.innerWidth;
		let possibleUsersCount = c.prop('format') === 'grid' ? Math.floor(componentWidth / this.#iconSize) : 10;
		if (possibleUsersCount < 2) possibleUsersCount = 0;
		const diff = userIds.length - possibleUsersCount;
		ctx.moreText = diff > 1 ? `${possibleUsersCount < 1 ? '' : '+'}${userIds.length - possibleUsersCount}` : null;
		ctx.displayCount = diff > 1 ? possibleUsersCount : userIds.length;

		userIds.forEach(i => App.state.team.ensure(i, c.getValueProof()))
	}
	#getUsersIds(component) {
		return component.prop('value')?.split(',').filter(Boolean) || [];
	}

	preview() {
		return '';
	}

	hasValue(decoded) {
		return !!decoded.value?.length;
	}

	openMenu(component) {
		this.detailedPreview(component);
	}

	#openMenu(component) {
		App.menu.show({
			anchor: component,
			backup: false,
			...this.buildUserMenuParams(component, {
				onShow(menu) {
					menu._unbinders?.forEach(f => f());
					menu._unbinders = [];

					const {unbind: unbindApply} = menu.addDelegatedEventListener('click', '.menu__group > ws-btn[name*=primary]', (e) => {
						const ids = [...menu.querySelectorAll('.menu__item-active[data-id]')]
							.map(el => el.dataset.id)
							.join(',');
						component.change(e, 'value', ids);
						component.apply(e);
					});
					menu._unbinders.push(unbindApply);

					const ids = component.prop('value', '').split(',');
					const selector = ids.map(id => `.menu__item[data-id="${id}"]`).join(', ');
					menu.querySelectorAll('.menu__item-active').removeClass('menu__item-active');
					if (selector) menu.querySelectorAll(selector).addClass('menu__item-active');

					$(menu).trigger('after_interaction');
				},
				onHide(menu, component) {
					menu._unbinders?.forEach(f => f());
					menu._unbinders = [];
					component.cancel();
				},
			}),
		});
	}

	detailedPreview(component) {
		const ids = this.#getUsersIds(component);
		const readonly = component.propBool('readonly');
		if (!ids.length) {
			if (!readonly) {
				return this.#openMenu(component);
			}
			return;
		}
		if (ids.length === 1) {
			if (!readonly) {
				return this.#openMenu(component);
			}
			App.controls.user_menu.show(component, ids[0], 'left');
			return;
		}
		const ctrl = App.controls.menu;
		const menu = ctrl.create_menu({
			id: `custom-field-detailed-preview-menu-${component.idField}`,
			search: true,
			button_text: App.object_state.locale.edit,
			button: !readonly,
			groups: [{
				search: true,
				checkbox: true,
				items: ids.map(id => {
					const {name, avatar} = App.state.team.get(id);
					return ctrl.create_item({
						title: name,
						avatar,
						dataset: {
							id
						}
					}, {})
				}),
			}],
		});
		menu.show({
			type: 'left',
			anchor: component,
			onload: (m) => {
				ctrl.init(m)
				m.addDelegatedEventListener('click', '.menu__item[data-id]', (e, el) => {
					App.menu.hide();
					App.controls.user_menu.show(component, el.dataset.id, 'left');
				})
				m.addDelegatedEventListener('click', '.menu__group-search ws-btn', (e, el) => {
					menu.destroy();
					this.#openMenu(component)
				})
			},
			onhide: () => {
				menu.destroy();
			},
		})
	}

	onMount(component) {
		let lastWidth = component.firstElementChild.innerWidth;
		const resizeObserver = new ResizeObserver(() => {
			const newWidth = component.firstElementChild.innerWidth;
			if (newWidth !== lastWidth) {
				lastWidth = newWidth;
				component.invalidateLifecycle('resizeObserver:observe');
			}
		})
		component.useConnection('resizeObserver', {
			connect: () => {
				resizeObserver.observe(component);
			},
			disconnect: () => {
				resizeObserver.unobserve(component);
			}
		})
	}


}

class ContactMultipleType extends ContactType {

	defaultIcon = 'news/users';
	#iconSize = 24;

	useStore(component) {
		component.useStore('team', App.state.contacts, {
			invalidate: (changeset) => this.#getUsersIds(component).some((i) => changeset.has(i))
		});
	}

	expose(c, ctx) {
		const userIds = this.#getUsersIds(c);
		// const readonly = c.propBool('readonly');
		ctx.users = userIds.map(id => App.state.contacts.get(id));
		const componentWidth = c.firstElementChild.innerWidth;
		let possibleUsersCount = c.prop('format') === 'grid' ? Math.floor(componentWidth / this.#iconSize) : 10;
		if (possibleUsersCount < 2) possibleUsersCount = 0;
		const diff = userIds.length - possibleUsersCount;
		ctx.moreText = diff > 1 ? `${possibleUsersCount < 1 ? '' : '+'}${userIds.length - possibleUsersCount}` : null;
		ctx.displayCount = diff > 1 ? possibleUsersCount : userIds.length;

		userIds.forEach(i => App.state.contacts.ensure(i, c.getValueProof()))
	}

	#getUsersIds(component) {
		return component.prop('value')?.split(',').filter(Boolean) || [];
	}

	preview() {
		return '';
	}

	hasValue(decoded) {
		return !!decoded.value?.length;
	}

	openMenu(component) {
		this.detailedPreview(component);
	}

	#openMenu(component) {
		const ids = this.#getUsersIds(component);
		App.menu.show({
			anchor: component,
			backup: false,
			...this.buildContactMenuParams(component, {
				request: {
					button: 1
				},
				onShow(menu) {
					menu._unbinders?.forEach(f => f());
					menu._unbinders = [];

					const {unbind: unbindApply} = menu.addDelegatedEventListener('click', '.menu__group-search ws-btn', (e) => {
						const add_ids = [...menu.querySelectorAll('.menu__item-active[data-id]:not(.menu__item-disabled)')]
							.map(el => el.dataset.id)
							.filter(Boolean);

						if (add_ids.length > 0) {
							component.change(e, 'value', [...ids, ...add_ids].join(','));
							component.apply(e);
						} else {
							App.menu.hide();
						}
					});
					menu._unbinders.push(unbindApply);

					const selector = ids.map(id => `.menu__item[data-id^="${id}"]`).join(', ');
					menu.querySelectorAll('.menu__item-active').removeClass('menu__item-active', 'menu__item-disabled');
					if (selector) menu.querySelectorAll(selector).addClass('menu__item-active', 'menu__item-disabled');
				},
				onHide(menu, component) {
					menu._unbinders?.forEach(f => f());
					menu._unbinders = [];
					component.cancel();
				},
			}),
		});
	}

	detailedPreview(component) {
		const self = this;
		const ids = this.#getUsersIds(component);
		const readonly = component.propBool('readonly');
		if (!ids.length) {
			if (!readonly) {
				return this.#openMenu(component);
			}
			return;
		}
		if (ids.length === 1) {
			if (!readonly) {
				return this.#openMenu(component);
			}
			App.controls.contact_menu.show(ids[0]);
			return;
		}
		const ctrl = App.controls.menu;
		const menu = ctrl.create_menu({
			id: `custom-field-detailed-preview-menu-${component.idField}`,
			search: true,
			button_text: App.i18n.t('add'),
			button: !readonly,
			button_icon: 'person_add',
			groups: [{
				search: true,
				checkbox: true,
				items: ids.map(id => {
					const {name, avatar} = App.state.contacts.get(id);
					return ctrl.create_item({
						title: name,
						avatar,
						dataset: {
							id
						}
					}, {})
				}),
			}],
		});
		menu.show({
			type: 'left',
			anchor: component,
			width: 320,
			onload: (m) => {
				ctrl.init(m)
				m.addDelegatedEventListener('click', '.menu__item[data-id]', (e, el) => {
					const id = e.target.closest('.menu__item')?.dataset.id;
					if (readonly) {
						App.controls.contact_menu.show(id);
					} else {
						const ask_menu = ctrl.create_menu({
							id: menu.id + '-ask',
							groups: [
								{items: [
									ctrl.create_item({ left_icon: 'roles/contact', title: App.i18n.t('open'), dataset: {action: 'view'} }, {}),
									ctrl.create_item({ left_icon: 'person_remove', title: App.i18n.t('remove'), delete: true, dataset: {action: 'remove'} }, {}),
								]}
							],
						});
						ask_menu.show({
							type: 'submenu',
							anchor: el,
							backup: true,
							width: 160,
							onload: (m2) => {
								ctrl.init(m2)
								m2.addDelegatedEventListener('click', '.menu__item[data-action]', (e, el) => {
									const action = el.dataset.action;
									if (action === 'view') {
										App.controls.contact_menu.show(id);
									} else if (action === 'remove') {
										component.change(e, 'value', self.#getUsersIds(component).filter(i => i !== id).join(','));
										component.apply(e);
										$(m).find('.menu__item[data-id='+id+']').remove();
									}
								});
							},
							onhide: () => {
								ask_menu.destroy();
							},
						});
					}
				})
				m.addDelegatedEventListener('click', '.menu__group-search ws-btn', (e, el) => {
					menu.destroy();
					this.#openMenu(component)
				})
			},
			onhide: () => {
				menu.destroy();
			},
		})
	}

	onMount(component) {
		let lastWidth = component.firstElementChild.innerWidth;
		const resizeObserver = new ResizeObserver(() => {
			const newWidth = component.firstElementChild.innerWidth;
			if (newWidth !== lastWidth) {
				lastWidth = newWidth;
				component.invalidateLifecycle('resizeObserver:observe');
			}
		})
		component.useConnection('resizeObserver', {
			connect: () => {
				resizeObserver.observe(component);
			},
			disconnect: () => {
				resizeObserver.unobserve(component);
			}
		})
	}
}

class SelectType extends FieldType {

	editMode = 'external';
	defaultIcon = 'editor/bulleted_list';

	expose(c, ctx) {
		const selectedId = c.prop('value');
		const option = this.options(c).find(o => o.key == selectedId);
		ctx.selected = option
			? {key: selectedId, value: option.value, icon: option.icon, color: option.color}
			: {};
	}

	preview(decoded, c) {
		return this.options(c).find(o => o.key == c.prop('value'))?.value || '';
	}

	hasValue(decoded) {
		return !!decoded.value;
	}

	openMenu(component) {
		const ctrl = App.controls.menu;
		const items = this.options(component);
		const menu = ctrl.create_menu({
			id: `custom-field-menu-${component.idField}`,
			search: true,
			groups: [{
				search: true,
				select: true,
				items: items.map(option => ctrl.create_item({
					title: option.value,
					left_icon: option.icon || 'shape-circle-12',
					style: {'--icon-color': 'var(--tag-color)'},
					dataset: {id: option.key},
					classes: [option.color ? `tag${option.color}` : ''],
				}, {})),
			}],
		});
		menu.show({
			anchor: component,
			type: 'left',
			onload: (m) => ctrl.init(m),
			onshow(m) {
				m.addDelegatedEventListener('click', '.menu__item[data-id]', (event, item) => {
					component.change(event, 'value', item.dataset.id);
					component.apply(event);
				});
			},
			onhide: () => menu.destroy(),
		});
	}

	options(component) {
		return component.propJson('options', App.custom_fields.fields[component.idField]?.options || []);
	}
}

class SelectMultipleType extends SelectType {

	defaultIcon = 'list_alt';

	expose(c, ctx) {
		const selectedIds = c.prop('value')?.split(',') || [];
		const options = this.options(c);
		ctx.selected = selectedIds
			.map(id => {
				const option = options.find(o => o.key == id);
				return option ? {key: id, value: option.value, icon: option.icon, color: option.color} : null;
			})
			.filter(Boolean);
		const readonly = c.propBool('readonly');
		ctx.moreText = selectedIds.length > 10 ? `${readonly ? '' : '+'}${selectedIds.length - 10}` : (readonly ? '' : '+');
	}

	preview() {
		return '';
	}

	hasValue(decoded) {
		return !!decoded.value?.length;
	}

	openMenu(component) {
		const ctrl = App.controls.menu;
		const items = this.options(component);
		const menu = ctrl.create_menu({
			id: `custom-field-menu-${component.idField}`,
			search: true,
			button: true,
			groups: [{
				search: true,
				checkbox: true,
				items: items.map(option => ctrl.create_item({
					title: option.value,
					left_icon: option.icon || 'shape-circle-12',
					style: {'--icon-color': 'var(--tag-color)'},
					dataset: {id: option.key},
					checkbox: true,
					classes: [option.color ? `tag${option.color}` : ''],
				}, {})),
			}],
		});
		menu.show({
			anchor: component,
			type: 'left',
			onload: (m) => ctrl.init(m),
			onshow(m) {
				let ids = component.prop('value', '').split(',');

				m.addDelegatedEventListener('click', '.menu__item[data-id]', () => {
					ids = [...m.querySelectorAll('.menu__item-active[data-id]')]
						.map(el => el.dataset.id)
						.join(',');
				});
				m.addDelegatedEventListener('click', '.menu__group-search ws-btn', (event) => {
					component.change(event, 'value', ids);
					component.apply(event);
				});

				m.querySelectorAll('.menu__item[data-id]').forEach(el => {
					el.classList.toggle('menu__item-active', ids.includes(el.dataset.id));
				});
			},
			onhide: () => {
				component.cancel();
				menu.destroy();
			},
		});
	}
}

class TimeType extends FieldType {

	editMode = 'none';
	inlineActions = ['copy'];

	get observedAttributes() {
		return ['value', 'placeholder'];
	}

	onClick() {
	}

	preview({value}, component) {
		const date = this.initAndGetTimeInput(component)?.timepicker('getTime');
		if (!date) {
			return;
		}
		if (App.config.is_24h) {
			return new Intl.DateTimeFormat('en-GB', {
				hour: '2-digit',
				minute: '2-digit',
				hour12: false
			}).format(date);
		}
		return new Intl.DateTimeFormat('en-US', {
			hour: 'numeric',
			minute: 'numeric',
			hour12: true
		}).format(date);
	}

	hasValue({value}) {
		return value?.length > 0;
	}

	expose(c, ctx) {
		ctx.copyValue = c.prop('value');
	}

	initAndGetTimeInput(component) {
		const input = $(component.ref('display_value'))
			.add(component.ref('placeholder_value'))
			.add(component.querySelector('.custom-field__icon'));
		if (input.length === 0) return;
		input.timepicker({
			minTime: '00:00',
			maxTime: '24:00',
			minWorkTime: '00:00',
			maxWorkTime: '24:00',
			timeFormat: App.config.is_24h ? 'H:i' : 'g:ia',
			step: component.propInt('step', 5),
			orientation: 'l',
		});
		input.timepicker('setTime', component.prop('value'));
		if (component.propBool('readonly')) {
			input.off('click');
		}
		return input;
	}

	onStateChange(component, state) {
		App.helper.nextTick(() => {
			const input = this.initAndGetTimeInput(component);
			input.on('selectTime', (e, data) => {
				if (!data) return;
				component.change(e, 'value', data.time);
				component.apply(e);
			});

			input.timepicker('setTime', component.prop('value'));
		});
	}
}

class DateType extends FieldType {

	editMode = 'external';

	preview({value}) {
		return value;
	}

	hasValue(decoded) {
		return !!decoded.value;
	}

	expose(c, ctx) {
		ctx.copyValue = c.prop('value');
	}

	openMenu(component) {
		App.menu.show({
			anchor: component,
			backup: false,
			...this.buildMenuParams(component, {
				onShow(menu) {
					App.controls.menu_datepicker.onshow(menu, {
						onSelect: (date) => {
							component.change(null, 'value', date)
							component.apply();
						},
						maxDate: undefined,
						defaultDate: component.prop('value') ? App.helper.date.from_input(component.prop('value')) : null,
						beforeShowDay: undefined
					});
				},
				onHide() {
					component.cancel();
				},
			}),
		});
	}
}

;class CustomField extends RenderableComponent {

	static precompile = true;

	static templateVariantKey(context) {
		return `${context.type}_${context.format}`
	}

	static get observedAttributes() {
		return ['icon', 'hint', 'error'];
	}


	static ACTIONS = {
		copy: {
			callback(e, value) {
				if (value) App.core.clipboard(value);
				if (!e) {
					return;
				}
				e.stopPropagation();
				const target = e.currentTarget;
				const originalIcon = target.getAttribute('right-icon');
				target.setAttribute('right-icon', 'check');
				App.helper.nextTick(() => {
					target.setAttribute('right-icon', originalIcon);
				}, 700)
			},
		},
		open: {
			callback(e, value) {
				if (value) App.core.new_window(value);
				e?.stopPropagation();
			},
		},
		openAddress: {
			callback(e, value) {
				if (value) App.core.new_window("https://maps.google.com/?q=" + encodeURIComponent(value));
				e?.stopPropagation();
			}
		},
		openEmail: {
			callback(e, value) {
				if (value) App.core.new_window(`mailto:${value}`);
				e?.stopPropagation();
			}
		},
		call: {
			callback(e, value) {
				if (value) App.core.new_window(`tel:${value}`);
				e?.stopPropagation();
			},
		},
	};


	/**
	 *
	 * @type {Readonly<Record<string, FieldType>>}
	 */
	static TYPES = Object.freeze({
		text: TextType.getInstance(),
		address: AddressType.getInstance(),
		email: EmailType.getInstance(),
		textarea: TextareaType.getInstance(),
		number: NumberType.getInstance(),
		number_with_unit: NumberWithUnitType.getInstance(),
		percent: NumberWithUnitType.getInstance(),
		phone: PhoneType.getInstance(),
		link: LinkType.getInstance(),
		boolean: BooleanType.getInstance(),
		user: UserType.getInstance(),
		contact: ContactType.getInstance(),
		user_multiple: UserMultipleType.getInstance(),
		contact_multiple: ContactMultipleType.getInstance(),
		select: SelectType.getInstance(),
		select_multiple: SelectMultipleType.getInstance(),
		time: TimeType.getInstance(),
		date: DateType.getInstance(),
	});

	get idInst() {
		return this.prop('inst');
	}

	get idEntity() {
		return this.prop('entity');
	}

	get idField() {
		return this.prop('field');
	}

	static createKey(field, id_entity) {
		return `${field.id_inst}/${id_entity}/${field.id}`;
	}

	static parseKey(key) {
		const [idInst, idEntity, idField] = key.split('/');
		return {idInst, idEntity, idField};
	}

	static create(field, id_entity, attrs) {
		const type = App.custom_fields.type(field.id_type);
		if (attrs['initial-value'] == null && attrs['value'] == null) {
			App.state.custom_values.ensure(field.id_inst, id_entity, field.id);
		}
		return CustomField.build({
			attributes: {
				...attrs,
				type: type.input,
				'data-key': CustomField.createKey(field, id_entity),
			},
		})
	}


	/**
	 * @returns {LifecycleLayer}
	 */
	static defineLifecycle() {
		/**
		 * @this {CustomField}
		 */
		return function ({on, once}) {
			once('constructed', () => {
				this._lastValidation = ValidationResult.ok();
			});
			once('mount:before', () => {

				const {idInst, idEntity, idField} = CustomField.parseKey(this.prop('data-key', ''));

				this.setProp('inst', idInst, {to: 'data', silent: true});
				this.setProp('entity', idEntity, {to: 'data', silent: true});
				this.setProp('field', idField, {to: 'data', silent: true});

				if (this.prop('value')) {
					App.state.custom_values.set(this.idInst, this.idEntity, this.idField, this.prop('value'));
				}

				this.useStore('fields', App.state.custom_fields, {
					scope: this.idField,
					select: (store) => store.find(this.idField),
					sync: (field) => ({
						...field?.attributes ?? {},
						...this.config.syncFields(field),
						descr: field.descr
					}),
				});
				this.useStore('value', App.state.custom_values, {
					scope: App.state.custom_values.makeValueKey(this.idInst, this.idEntity, this.idField),
					select: (store) => store.get(this.idInst, this.idEntity, this.idField),
					sync: (raw) => ({value: raw || ''}),

				});
				this.config.useStore(this);
				this.config.onMount(this)
			});
			once('mount:after', () => {
				this.#syncStateFromValue();
				this.#syncInputsFromProps();
				this.config.observedAttributes.forEach(attr => this.observeAttribute(attr));
				this.setProp('lastValue', this.prop('value'));
				this.setProp('width', this.clientWidth)
			});
			on('update:after', () => {
				if (this.prop('state') !== 'edit') this.#syncStateFromValue();
				this.#syncInputsFromProps();
			});
			on('connected', () => {
				this._applyEventDebounce = App.helper.debounce(() => {
					const {value} = this.#encodeFields(this.decodeValue());
					if (this.prop('lastValue') == value) {
						return;
					}
					this.setProp('lastValue', value);
					this.emitEvent('apply', {
						value,
						id_field: this.idField,
					})
				}, 200);
			});
			on('disconnected', () => {
				this._applyEventDebounce.clear();
			});
		};
	}

	getValueProof() {
		return {
			id_inst: this.idInst,
			id_entity: this.idEntity,
			id_field: this.idField,
		};
	}

	templateContext() {
		const config = this.config;
		const type = this.prop('type');
		const state = this.prop('state', 'empty');
		const readonly = this.propBool('readonly', false);
		const decoded = this.decodeValue();

		const validation = this._lastValidation;
		const externalError = this.prop('error');
		const error = !!externalError || validation.error;
		const hasValue = config.hasValue(decoded);
		const editMode = this.#effectiveEditMode();
		const isMenu = editMode === 'menu';
		const inEdit = state === 'edit';

		const fieldErrors = {...validation.fieldErrors};
		if (externalError && !fieldErrors.value) {
			fieldErrors.value = externalError;
		}

		const ctx = {
			state,
			readonly,
			error,
			hasValue,
			isMenu,
			inEdit,
			editMode,
			type,
			placeholder: this.prop('placeholder', ''),
			displayValue: config.preview(decoded, this),
			hint: this.prop('hint'),
			icon: this.prop('icon', config.defaultIcon),
			hintValue: config.hintValue(decoded),
			showEmpty: !hasValue && (!inEdit || isMenu),
			showDisplay: hasValue && (!inEdit || isMenu),
			showEdit: inEdit && editMode !== 'none' && editMode !== 'external',
			fieldErrors,
			value: this.prop('value'),
			actions: this.actions,
			change: this.callbacks.change,
			clickHandler: this.callbacks.clickHandler,
			errorText: validation.message || externalError || '',
			validationMeta: validation.meta,
			format: this.prop('format', 'detailed'),
			decoded,
		};

		config.expose(this, ctx);
		return ctx;
	}

	preventEvent(e) {
		e.preventDefault();
		e.stopPropagation();
	}

	template() {
		return `cf_${this.prop('type')}_${this.prop('format', 'detailed')}`;
	}


	get actions() {
		return this.__actions ||= Object.fromEntries(
			Object.entries(CustomField.ACTIONS)
				.map(([key, {callback}]) => [key, (e, ...args) => {
					// if (this.#measureEditMode() === 'menu') return this.callbacks.clickHandler(e);
					callback.call(this, e, ...args);
				}])
		);
	}

	get callbacks() {
		return this.__callbacks ||= {
			change: (e, key, val = e.target.value) => this.change(e, key, val),
			clickHandler: (e) => {
				e.stopPropagation();
				if (this.propBool('readonly')) {
					if (this.propBool('allow-menu')) {
						return this.#openMenu(e);
					}
					this.config.detailedPreview(this);
					return;
				}
				const editMode = this.#measureEditMode();
				if (editMode === 'external' || editMode === 'menu') return this.#openMenu(e);
				this.config.onClick(this, e);
			},
		};
	}


	get config() {
		return CustomField.TYPES[this.prop('type')];
	}

	#effectiveEditMode() {
		const config = this.config;
		if (config.editMode !== 'inline') return config.editMode;
		return this._lastMeasuredEditMode ?? 'inline';
	}

	#measureEditMode() {
		const config = this.config;
		if (config.editMode !== 'inline') return config.editMode;
		this._lastMeasuredEditMode = this.offsetWidth < config.minWidthForInline ? 'menu' : 'inline';
		return this._lastMeasuredEditMode;
	}


	#openMenu(e) {
		const config = this.config;

		if (config.editMode === 'external') {
			config.openMenu(this);
			return;
		}

		this.edit(e);
		config.openEditMenu(this, e);
	}


	decodeValue() {
		return this.config.decode(this.prop('value', ''));
	}

	#encodeFields(decoded) {
		return this.config.encode(decoded);
	}


	#validate() {
		this.#hideValidationHint();
		this._lastValidation = this.config.validate(this.decodeValue(), this);
		return this._lastValidation;
	}

	#showValidationHint() {
		const root = this._menuEditRoot || this;
		App.components.custom_field.show_validation_hint(root);
	}

	#hideValidationHint() {
		App.components.custom_field.hide_validation_hint();
	}

	#syncStateFromValue() {
		const hasValue = this.config.hasValue(this.decodeValue());
		this.#setState(hasValue ? 'display' : 'empty');
	}

	/**
	 * @param {CustomFieldsState} newState
	 */
	#setState(newState) {
		if (this.prop('state') === newState) return;
		this.setProp('state', newState);
		this.emitEvent('change-state', {state: newState});
		this.config.onStateChange(this, newState);
	}

	#syncInputsFromProps() {
		if (this.prop('state') !== 'edit') return;
		const decoded = this.decodeValue();
		for (const key in decoded) {
			const input = this.ref(`input_${key}`);
			if (!input || document.activeElement === input) continue;
			const val = decoded[key] ?? '';
			if (input.value !== val) input.value = val;
		}
	}


	edit(e) {
		if (this.propBool('readonly') || this.prop('state') === 'edit') return;
		this.setProp('editSnapshot', this.#encodeFields(this.decodeValue()));
		this.#setState('edit');
		App.helper.nextTick(() => {
			const root = this._menuEditRoot || this;
			const input = root.querySelector(`[data-ref="${this.config.focusRef}"]`);
			if (!input) return;
			App.helper.nextTick(() => {
				input.focusWithSelection();
			})
		});
	}

	change(e, key, value = e.target.value) {
		if (this.propBool('readonly')) return;
		this.setProp('error', false);
		const encoded = this.#encodeFields({...this.decodeValue(), [key]: value});
		for (const k in encoded) this.setProp(k, encoded[k]);
		if (this.config.validateOnInput) {
			const {error} = this.#validate();
			if (error) this.#showValidationHint();
		}
		this.config.onChange(this, key, value);
		e?.stopPropagation();
	}


	#applyValue() {
		if (this.propBool('readonly')) return false;
		const {error} = this.#validate();
		if (error) {
			this.invalidateLifecycle('validation:error');
			this.#showValidationHint();
			return false;
		}
		this.setProp('error', false);
		this._applyEventDebounce();
		this.#syncStateFromValue();
		this.config.onApply(this);
		return true;
	}

	#cancelValue() {
		const snapshot = this.propJson('editSnapshot', null);
		if (snapshot) {
			for (const key in snapshot) this.setProp(key, snapshot[key]);
		}
		this.setProp('error', false);
		this.emitEvent('cancel', {});
		this.#syncStateFromValue();
		const {error} = this.#validate();
		if (error) {
			this.#showValidationHint();
		}
	}

	#closeMenu() {
		if (!this.propBool('hiddingMenu')) {
			this.setProp('hiddingMenu', true, {silent: true});
			if (App.menu.active_anchor === this) App.menu.hide();
			this.setProp('hiddingMenu', false, {silent: true});
		}
	}


	apply(e) {
		if (this.#applyValue()) this.#closeMenu();
		e?.stopPropagation();
		this.#hideValidationHint();
	}

	cancel(e) {
		this.#cancelValue();
		this.#closeMenu();
		e?.stopPropagation();
		this.#hideValidationHint();
	}

	outsideClick(e) {
		if (this.prop('state') !== 'edit') return;
		if (App.menu.active_anchor === this) return;
		this._lastValidation.error ? this.cancel(e) : this.apply(e);
	}


	setExternalError(message, fieldErrors) {
		this.setProp('error', message || false);
		if (fieldErrors) {
			this._lastValidation = ValidationResult.fail(message, {fieldErrors});
		}
		this.#showValidationHint();
	}

	clearExternalError() {
		this.setProp('error', false);
		this.#validate();
	}
}


App.components.custom_field = {
	onBoot() {
		customElements.define('custom-field', CustomField);
	},

	show_validation_hint: App.helper.debounce(function (el) {
		const target = el.querySelector('.custom-field__error-icon');
		if (target) App.hint.force_show(target);
	}, 500),
	hide_validation_hint() {
		App.components.custom_field.show_validation_hint.clear();
		App.hint.hide();
	}
};
/**
 * @typedef {'edit'|'disaplay'|'empty'} CustomFieldsState
 */

;class DashboardBlock extends HTMLElement {

	static TAG_NAME = 'dashboard-block';

	/** @type {Record<string, DashboardBlockControllerTarget>} */
	_targets = {};

	createTarget(name, {beforeMount, mounted, beforeUnmount, unmounted} = {}
	) {
		this._targets[name] = new DashboardBlockControllerTarget({
			beforeMount: (controller) => {
				this.beforeMount(controller);
				 beforeMount?.(controller);
			},
			mounted: (controller) => {
				this.mounted(controller);
				 mounted?.(controller);
			},
			beforeUnmount: (controller) => {
				this.beforeUnmount(controller);
				 beforeUnmount?.(controller);
			},
			unmounted: (controller) => {
				this.unmounted(controller);
				 unmounted?.(controller);
			},
		});
		return this._targets[name];
	}

	target(name) {
		return this._targets[name];
	}

	get targets() {
		return this._targets;
	}

	init() {
		this.createTarget('self').mount(this, this);
		this.createTarget('modal', {
			beforeUnmount: (controllerTarget) => {
				const modal_body = controllerTarget.controller.body;
				const self_body = this.target('self').controller.body;
				const keys = [
					'type',
					'sel_user',
					'selection',
					'order',
				];
				const isChanged = keys.some((key) => modal_body.dataset[key] !== self_body.dataset[key]);
				if (isChanged) {
					this.refresh();
				}
			},
		});
		App.bus.app.emit('block_mounted', {}, {block: this});

	}

	beforeMount(controllerTarget) {
	}


	mounted(controllerTarget) {
		App.core.call_queue.add(`dashboard_block_${this.id}`, () => {
			this.closest('.dashboard')?.classList?.remove('dashboard-loading');
		}, this, null, 1);
		controllerTarget.target.addDelegatedEventListener('click', '.dashboard__block__expand ws-btn', this.onExpandBtn.bind(this));
		controllerTarget.target.addDelegatedEventListener('click', '.dashboard__block__header .avatar [data-user]', this.onAvatarClick.bind(this));
	}

	beforeUnmount(controllerTarget) {
		controllerTarget.controller.abortAsync('getTabContent');
		controllerTarget.target.removeDelegatedEventListener('click', '.dashboard__block__expand ws-btn', this.onExpandBtn.bind(this));
		controllerTarget.target.removeDelegatedEventListener('click', '.dashboard__block__header .avatar [data-user]', this.onAvatarClick.bind(this));
	}

	unmounted(controllerTarget) {

	}

	getItemsSelector() {
		return '.scrollZone > .flex_row:not(.tabs)';
	}

	onExpandBtn() {
		const url = this.target('self').controller.composeUrl(true, { height: window.innerHeight * 3}) + '&render_type=modal';
		App.dashboard_view.show({
			url,
			onload: (modal) => {
				modal.classList.add('dashboardView-fullscreen', 'dashboard');
				if (!this.target('modal').isMounted()) {
					this.target('modal').mount(this, modal)
				}
			},
			onhide: () => {
				this.target('modal').unmount();
			}
		});
	}

	onAvatarClick(event, element) {
		const id_user = +element.dataset.user;
		App.controls.user_menu.show(element, id_user);
	}

	needRefresh(_data) {
		throw new Error("Implement in subclass");
	}

	static get shouldBeRefreshedByEvents() {
		throw new Error("Implement in subclass");
	}

	refresh() {
		this.target('self').controller.refresh();
	}

	get container() {
		return this.getAttribute('data-container');
	}


	static getAllOnPage({container}) {
		let selector = this.TAG_NAME;
		container && (selector += `[data-container="${container}"]`);
		return Array.from(document.querySelectorAll(selector));
	}

	callController(method, ...args) {
		const results = [];
		for (const targetName in this.targets) {
			results.push(this.targets[targetName].controller?.[method]?.(...args));
		}
		return results.find(result => Boolean(result));
	}

	getControllerValue(property) {
		for (const targetName in this.targets) {
			const value = this.targets[targetName].controller?.[property];
			if (value !== undefined) return value;
		}
	}

}

App.components.dashboard_block = {
	onBoot: function () {
		customElements.define('dashboard-block', DashboardBlock);
	},
};

;class DashboardBlockTasksListener extends DashboardBlock {

	static TAG_NAME = 'dashboard-block-tasks-listener';

	get tasksAttribute() {
		return this.getAttribute('data-tasks-attribute') || 'data-task';
	}

	get tasks() {
		return Array.from(this.querySelectorAll(`[${this.tasksAttribute}]`)).map(containerWithTask => {
			return Number.parseInt(containerWithTask.getAttribute(this.tasksAttribute));
		});
	}

	get usersAttribute() {
		return this.getAttribute('data-users-attribute') || 'data-user';
	}

	get users() {
		return Array.from(this.querySelectorAll(`[${this.usersAttribute}]`)).map(containerWithUser => {
			return Number.parseInt(containerWithUser.getAttribute(this.usersAttribute));
		});
	}

	needRefresh({event, id, data}) {
		return this._needRefreshConditions[event]?.({id, data}) || false;
	}

	get _needRefreshConditions() {
		const  additionalTaskAddConditionBySelection = this.additionalTaskAddConditionBySelection;
		const additionalTaskAddConditionByType = this.additionalTaskAddConditionByType;
		return  {
			task_user_to: ({id, data}) =>
				App.helper.array.has(this.tasks, id) || App.helper.array.has(this.users, data?.id),

			task_add: ({id, data}) =>
				(App.helper.array.has(this.tasks, id) || App.helper.array.has(this.users, data?.id_user_to))
			|| (additionalTaskAddConditionBySelection({id, data}) && additionalTaskAddConditionByType({id, data})),

			task_done: ({id, data}) =>
				App.helper.array.has(this.tasks, id) ||
				(data?.related_users ?? []).some(u => App.helper.array.has(this.users, u)),

			task_undone: ({id, data}) =>
				App.helper.array.has(this.tasks, id) ||
				(data?.related_users ?? []).some(u => App.helper.array.has(this.users, u)),

			task_terms: ({id, data}) =>
				App.helper.array.has(this.tasks, id) ||
				(data?.related_users ?? []).some(u => App.helper.array.has(this.users, u)),
		};
	}

	get additionalTaskAddConditionBySelection() {
		const selection = this.getControllerValue('body').getAttribute('data-selection');
		let additionalTaskAddCondition = () => true;
		switch (selection) {
			case 'user_to':
				additionalTaskAddCondition = ({id, data}) => App.me.id === data?.id_user_to;
				break;
			case 'user_from':
				additionalTaskAddCondition = ({id, data}) => App.me.id === data?.id_user_from;
				break;
			case 'user_subscribe':
				additionalTaskAddCondition = ({id, data}) => data?.class.split(' ')?.includes(`s${App.me.id}`)
				break;
			case 'user_department':
				additionalTaskAddCondition = ({id, data}) => data?.class.split(' ')?.includes(`ugs${App.me.id_group}_${App.me.id_group_sub}`)
				break;
		}
		return additionalTaskAddCondition;
	}

	get additionalTaskAddConditionByType() {
		const type = this.getControllerValue('body').getAttribute('data-type');
		let additionalTaskAddCondition = () => false;
		switch (type) {
			case 'all':
				additionalTaskAddCondition = () => true;
				break;
			case 'upcoming':
				additionalTaskAddCondition = ({id, data}) => data?.class.split(' ')?.includes(`p${App.components.task_terms.list_task_classes['deadline']}`)
				break;
		}
		return additionalTaskAddCondition;
	}


	static get shouldBeRefreshedByEvents() {
		return ['task_user_to', 'task_add', 'task_done', 'task_undone', 'task_terms'];
	}

}


App.components.dashboard_block_tasks_listener = {
	onBoot: function () {
		customElements.define(DashboardBlockTasksListener.TAG_NAME, DashboardBlockTasksListener);
		this.bootBusEvents();
	},
	bootBusEvents: function () {
		this.bootTaskBusEvents();
	},

	bootTaskBusEvents: function () {
		DashboardBlockTasksListener.shouldBeRefreshedByEvents.forEach(event => {
			App.bus.state.on(event, ({id, data}) => {
				const blocks = [
					...DashboardBlockTasksListener.getAllOnPage({container: 'tasks'}),
					...DashboardBlockTasks.getAllOnPage({container: 'tasks'}),
					...DashboardBlockTasksActivity.getAllOnPage({container: 'tasks'}),
					...DashboardBlockPriorities.getAllOnPage({container: 'tasks'}),
					...DashboardBlockProjectTasks.getAllOnPage({container: 'tasks'}),
				];
				blocks.forEach(block => {
					if (block.needRefresh({event, id, data})) {
						this.debouncedRefresh(block);
					}
				});
			});
		});
	},

	debouncedRefresh(block) {
		App.core.call_queue.add(
			`call_once.dashboard_block_${block.container}_${block.id}`,
			() => block.refresh(),
			App,
			null,
			0.1
		);
	}

}

;class DashboardBlockInteract extends DashboardBlock {

	static TAG_NAME = 'dashboard-block-interact';

	//some needed variables
	isProcessing = false;
	itemClass = '.sidePanel__list__item:not(.sidePanel__list__item-is-stats)';
	clearClass = '.stats-clear';

	mounted(controller) {
		super.beforeMount(controller);
		this._onClickInteraction = this.onClickInteractionItem.bind(this);
		this._onClickClear = this.onClickClear.bind(this);
		controller.target.addDelegatedEventListener('click', this.itemClass, this._onClickInteraction);
		controller.target.addDelegatedEventListener('click', this.clearClass, this._onClickClear);

		this.dashboardInteractMenuClick();
	}

	beforeUnmount(controller) {
		super.beforeUnmount(controller);
		controller.target.removeDelegatedEventListener('click', this.itemClass, this._onClickInteraction);
		controller.target.removeDelegatedEventListener('click', this.clearClass, this._onClickClear);
	}

	getDashboardElements(dashboard_block) {
		// Find core elements inside the block
		const header_btn = dashboard_block.querySelector('.dashboard__block__header-replace');
		const insert_here = dashboard_block.querySelector('.dashboard__stats__insert');
		const stats_insert = dashboard_block.querySelectorAll('.menu__stats--insert');
		const hide_elements = dashboard_block.querySelectorAll('.menu__group-select-hide');

		return {
			header_btn,
			insert_here,
			stats_insert,
			hide_elements
		};
	}

	onClickInteractionItem(e, el) {
		const item = el ?? e.target.closest(this.itemClass);
		if (!item) return;

		// Build the request URL with encoded type param
		const endpoint = this.callController('composeUrl', true);
		const url = App.helper.url.add_query(endpoint, '', {
			type: item.dataset.itemKey,
			is_stats_only: 1,
			debug: 'mysql',
		});

		// Execute AJAX request with loader
		this.callController('withLoader', () =>
			$.ajax({
				type: 'POST',
				url: url,
				success: (html) => {
					const dashboard_block = item.closest('.dashboard__block');
					const {
						header_btn,
						insert_here,
						hide_elements
					} = this.getDashboardElements(dashboard_block);

					hide_elements.forEach(el => el.style.display = 'none');

					if (insert_here) insert_here.insertAdjacentHTML('beforeend', html);

					if (header_btn) {
						header_btn.classList.add('is-shown');

						const headerEl = insert_here.querySelector('[data-type-header]');
						if (headerEl) {
							const header = headerEl.dataset.typeHeader;
							const key = headerEl.dataset.typeKey;

							if (key) {
								header_btn.innerHTML = `<span>${header}</span>`
								this.dashboardInteractMenu(key);
							}

						}
					}

					this.callController('initScrolls');

				}
			})
		);
	}

	onClickClear(e) {
		const dashboard_block = e.target.closest('.dashboard__block');
		if (!dashboard_block) return;

		const {
			header_btn,
			stats_insert,
			hide_elements
		} = this.getDashboardElements(dashboard_block);

		hide_elements.forEach(el => el.style.display = 'block');
		stats_insert.forEach(el => el.remove());

		if (header_btn) {
			header_btn.classList.remove('is-shown');
			header_btn.innerHTML = '';
		}

		this.callController('initScrolls');

		// ✅ Delay avatar reprocessing until layout stabilizes
		requestAnimationFrame(() => {
			setTimeout(() => {
				const avatarGroups = dashboard_block.querySelectorAll('.componentTeamAvatars');
				if (avatarGroups.length) this.processAvatars(avatarGroups);
			}, 100);
		});
	}

	connectedCallback() {
		const avatarGroups = this.querySelectorAll('.componentTeamAvatars');
		if (!avatarGroups.length) return;

		const debouncedProcess = App.helper.debounce(() => this.processAvatars(avatarGroups), 100);

		// Run once initially
		this.processAvatars(avatarGroups);

		// Watch for resize/layout changes
		const resizeObserver = new ResizeObserver(() => debouncedProcess());
		resizeObserver.observe(this);

		// Cleanup
		this._cleanupObservers = () => {
			resizeObserver.disconnect();
			debouncedProcess.clear?.();
		};
	}

	disconnectedCallback() {
		if (this._cleanupObservers) this._cleanupObservers();
		this.isProcessing = false; // optional reset
	}

	getInnerWidth(el) {
		const style = getComputedStyle(el);
		return el.clientWidth
			- parseFloat(style.paddingLeft || 0)
			- parseFloat(style.paddingRight || 0)
			- parseFloat(style.borderLeftWidth || 0)
			- parseFloat(style.borderRightWidth || 0);
	}

	processAvatars(avatarGroups) {
		if (this.isProcessing) return;
		this.isProcessing = true;

		requestAnimationFrame(() => {

			let maxUsedWidth = 0;
			let maxUsedWidthAdj = [];

			// Reset hidden avatars and calculate natural width
			avatarGroups.forEach(group => {
				const hiddenAvatars = group.querySelectorAll(':scope > span:not(.more)[style*="display: none"]');
				hiddenAvatars.forEach(av => (av.style.display = 'inline-block'));
				group.style.width = 'auto';
				maxUsedWidth = Math.max(maxUsedWidth, group.scrollWidth);
			});

			// Apply avatar width and visibility per group
			avatarGroups.forEach(group => {
				const parent = group.closest(this.itemClass);
				if (!parent) return;

				const maxWidthCoef = App.device.is_mobile ? 0.4 : 0.5;
				const parentWidth = this.getInnerWidth(parent);
				const finalWidth = Math.min(maxUsedWidth, parentWidth * maxWidthCoef);
				group.style.width = finalWidth + 'px';

				const avatars = Array.from(group.querySelectorAll(':scope > span:not(.more)'));
				let totalWidth = 0;
				let visibleCount = 0;

				avatars.forEach(av => {
					const w = av.offsetWidth || 24;
					if (totalWidth + w > finalWidth) return;
					totalWidth += w;
					visibleCount++;
				});

				avatars.forEach((av, i) => {
					av.style.display = i < visibleCount ? 'inline-block' : 'none';
				});

				// Apply smooth scale gradient effect
				if (visibleCount > 0) {
					const firstScale = 1.2;
					const lastScale = 1.0;
					const step = (firstScale - lastScale) / Math.max(visibleCount - 1, 1);
					avatars.forEach((av, i) => {
						if (i < visibleCount) {
							const scale = firstScale - step * i;
							av.style.transform = `scale(${scale.toFixed(2)})`;
							av.style.transition = 'transform 0.2s ease';
						} else {
							av.style.transform = 'scale(1)';
						}
					});
				}

				// Handle "+N" hidden avatars indicator
				const hiddenCount = avatars.length - visibleCount;
				let moreEl = group.querySelector('.more');

				if (hiddenCount > 0) {
					if (!moreEl) {
						moreEl = document.createElement('span');
						moreEl.className = 'more';
						group.appendChild(moreEl);
					}
					moreEl.textContent = `+${hiddenCount}`;
					moreEl.style.display = 'inline-block';

					const widthMore = moreEl.offsetWidth || 28;
					const adjWidth = totalWidth + widthMore;
					if (adjWidth > finalWidth) {
						group.style.width = adjWidth + 'px';
						maxUsedWidthAdj.push(adjWidth);
					}
				} else if (moreEl) {
					moreEl.remove();
				}
			});

			// Apply unified max width if needed
			if (maxUsedWidthAdj.length > 0) {
				const maxWidthValue = Math.max(...maxUsedWidthAdj);
				avatarGroups.forEach(group => {
					group.style.width = maxWidthValue + 'px';
					//group.style.maxWidth = maxWidthValue + 'px';
				});
			}

			this.isProcessing = false;
		});
	}

	dashboardInteractMenu(key) {
		const menu = document.querySelector('#dashboard-interact-selectionmenu');
		if (!key || !menu) return;

		const activeClass = 'menu__item-active';
		const activeItem = menu.querySelector(`[data-type-key="${key}"]`);

		menu.querySelector(`.${activeClass}`)?.classList.remove(activeClass);
		activeItem?.classList.add(activeClass);
	}

	 dashboardInteractMenuClick() {
		const menu = document.querySelector('#dashboard-interact-selectionmenu');
		if (!menu) return;

		menu.addEventListener('click', e => {
			const item = e.target.closest('.menu__item');
			if (!item || !menu.contains(item)) return;

			const triggerKey = item.dataset.typeKey;
			if (!triggerKey) return;

			const clearBtn = document.querySelector(this.clearClass);
			if (clearBtn) {
				clearBtn.dispatchEvent(new MouseEvent('click', { bubbles: true }));
			}

			App.menu.hide();

			const el = document.querySelector(`#dashboard-interact [data-item-key="${triggerKey}"]`);
			if (el) {
				el.dispatchEvent(new MouseEvent('click', { bubbles: true }));
			}
		});
	}


}

App.components.dashboard_block_interact = {
	onBoot: function () {
		customElements.define(DashboardBlockInteract.TAG_NAME, DashboardBlockInteract);

	}
}

;class DashboardBlockPriorities extends DashboardBlockTasksListener {

	static TAG_NAME = 'dashboard-block-priorities';

	mounted(controller) {
		super.mounted(controller);

		controller.target.addDelegatedEventListener('click', '.dashboard__block__header .reset', this.onClickResetFilter.bind(this));
		controller.target.addDelegatedEventListener('click', '.dashboard__block__header .ws-utility-cursor-pointer', this.onClickUtilityCursorPointer.bind(this));
		controller.controller.removeBlockScroll();
	}

	getItemsSelector({isModalTarget} = {}) {
		return isModalTarget ? '.scrollZone > .flex_row' : '.scrollZone > .flex_row:not(.tabs)'
	}

	beforeUnmount(controller) {
		super.beforeUnmount(controller);

		controller.target.removeDelegatedEventListener('click', '.dashboard__block__header .reset', this.onClickResetFilter.bind(this));
		controller.target.removeDelegatedEventListener('click', '.dashboard__block__header .ws-utility-cursor-pointer', this.onClickUtilityCursorPointer.bind(this));
	}

	onClickResetFilter(e, el) {
		this.callController('doFilter', el, true);
	}

	onClickUtilityCursorPointer(e, el) {
		const block = this;
		e.stopPropagation();
		App.controls.user_select_and_go.show_context(el, App.helper.url.add_query('/ajax/user/', App.actions.get('user_select_and_go:show')), {
			onshow: function() {
				$(this).off().on('click', '.menu__item', function() {
					$(this).attr('data-sel-user', $(this).attr('data-id'));
					block.callController('doFilter', this, true);
					App.menu.hide();
					return false;
				})
				$(this).attr('data-block-id', block.id);
			},
		});
	}
}


App.components.dashboard_block_priorities = {
	onBoot: function () {
		customElements.define(DashboardBlockPriorities.TAG_NAME, DashboardBlockPriorities);
	},
}

;class DashboardBlockProjectTasks extends DashboardBlockTasksListener {

	static TAG_NAME = 'dashboard-block-project-tasks';

	mounted(controller) {
		super.mounted(controller);
		controller.target.addDelegatedEventListener('click', '.dashboard__block__header .reset', this.#onClickResetFilter);
		controller.target.addDelegatedEventListener('click', '.dashboard__block__header .ws-utility-cursor-pointer', this.#onClickUtilityCursorPointer);
		controller.controller.removeBlockScroll();
	}

	getItemsSelector({isModalTarget} = {}) {
		return isModalTarget ? '.scrollZone > .flex_row' : '.scrollZone > .flex_row:not(.tabs)'
	}

	beforeUnmount(controller) {
		super.beforeUnmount(controller);
		controller.target.removeDelegatedEventListener('click', '.dashboard__block__header .reset', this.#onClickResetFilter);
		controller.target.removeDelegatedEventListener('click', '.dashboard__block__header .ws-utility-cursor-pointer', this.#onClickUtilityCursorPointer);
	}



	#onClickUtilityCursorPointer = (e, el) => {
		const block = this;
		e.stopPropagation();
		App.controls.project_select_and_go.show_context(el, null, {
			onshow: function() {
				$(this).off().on('click', '.menu__item', function() {
					$(this).attr('data-sel-project', $(this).attr('data-id'));
					block.callController('doFilter', this, true);
					App.menu.hide();
					return false;
				})
				$(this).attr('data-block-id', block.id);
			},
		});
	}
	#onClickResetFilter = (e, el) => {
		this.callController('doFilter', el, true);
	}
}


App.components.dashboard_block_project_tasks = {
	onBoot: function () {
		customElements.define(DashboardBlockProjectTasks.TAG_NAME, DashboardBlockProjectTasks);
	},
}

;class DashboardBlockProjects extends DashboardBlock {

	static TAG_NAME = 'dashboard-block-projects';

	mounted(controller) {
		super.mounted(controller);
		controller.target.addDelegatedEventListener('click', '.projectsList__item .proj_color', this.onClickProjColor);
		controller.target.addDelegatedEventListener('click', '.projectsList__item div.project_last_action', this.onClickLastAction);
		controller.target.addDelegatedEventListener('click', '.projectsList__item', this.onClickProjItem);
		controller.controller.removeBlockScroll();
	}

	beforeUnmount(controller) {
		super.beforeUnmount(controller);
		controller.target.removeDelegatedEventListener('click', '.projectsList__item .proj_color', this.onClickProjColor);
		controller.target.removeDelegatedEventListener('click', '.projectsList__item div.project_last_action', this.onClickLastAction);
		controller.target.removeDelegatedEventListener('click', '.projectsList__item', this.onClickProjItem);
	}

	onClickProjColor(e, el) {
		e.stopPropagation();
		if (el.hasAttribute('data-can-edit')) {
			App.controls.project_color.show(el);
		}
	}

	onClickLastAction(e, el) {
		e.stopPropagation();
		App.right_panel.show({url: el.getAttribute('data-url-activity')});
	}

	onClickProjItem(e, el) {
		App.core.goto(el.getAttribute('data-href'));
	}
}


App.components.dashboard_block_projects = {
	onBoot: function () {
		customElements.define(DashboardBlockProjects.TAG_NAME, DashboardBlockProjects);
	}
}

;class DashboardBlockStatsGeneral extends DashboardBlock {

	static TAG_NAME = 'dashboard-block-stats-general';

	mounted(controller) {
		super.mounted(controller);
		if (!controller.controller.isModalTarget()) {
			controller.controller.removeBlockScroll();
		}
	}

	getItemsSelector({isModalTarget} = {}) {
		return '.sidePanel__list__item.flex_row:not(.tabs),.menu__group-fixed  .menu__item.flex_row'
	}

}


App.components.dashboard_block_stats_general = {
	onBoot: function () {
		customElements.define(DashboardBlockStatsGeneral.TAG_NAME, DashboardBlockStatsGeneral);
	}
}

;class DashboardBlockStatsProjects extends DashboardBlock {

	static TAG_NAME = 'dashboard-block-stats-projects';

	mounted(controller) {
		super.mounted(controller);
		controller.target.addDelegatedMultipleEventListener(['click', 'contextmenu'], '.sidePanel__list__item', this.onClickListItem);
		controller.target.querySelectorAll('[data-setting]:has(ws-switch)').forEach((el) => {
			el.addEventListener('click', this.onChangeSwitch.bind(this));
		});
		if (!controller.controller.isModalTarget()) {
			controller.controller.removeBlockScroll();
		}
	}

	getItemsSelector() {
		return '.sidePanel__list__item.flex_row:not(.tabs),.menu__group-fixed  .menu__item.flex_row';
	}

	beforeUnmount(controller) {
		super.beforeUnmount(controller);
		controller.target.removeDelegatedMultipleEventListener(['click', 'contextmenu'], '.sidePanel__list__item', this.onClickListItem);
		controller.target.querySelectorAll('[data-setting]:has(ws-switch)').forEach((el) => {
			el.removeEventListener('click', this.onChangeSwitch.bind(this));
		});
	}

	onClickListItem(e, el) {
		const id_project = el.querySelector('div[data-project-id]').getAttribute('data-project-id');
		if (id_project) {
			App.project_view.show(id_project);
		}
		return false;
	}

	onChangeSwitch(e) {
		const switchEl = e.currentTarget.querySelector('ws-switch')
		const setting = e.currentTarget.getAttribute('data-setting');
		const value = !(switchEl.checked ? 1 : 0);
		this.setAttribute('data-custom-' + setting, value);
		this.callController('doFilter', this, true, false);
	}


}


App.components.dashboard_block_stats_projects = {
	onBoot: function () {
		customElements.define(DashboardBlockStatsProjects.TAG_NAME, DashboardBlockStatsProjects);
	}
}

;class DashboardBlockStatsUsers extends DashboardBlock {

	static TAG_NAME = 'dashboard-block-stats-users';

	mounted(controller) {
		super.mounted(controller);
		controller.target.addDelegatedMultipleEventListener(['click', 'contextmenu'], '.sidePanel__list__item', this.onClickListItem);
		if (!controller.controller.isModalTarget()) {
			controller.controller.removeBlockScroll();
		}
	}

	getItemsSelector() {
		return '.sidePanel__list__item.flex_row:not(.tabs),.menu__group-fixed  .menu__item.flex_row';
	}

	beforeUnmount(controller) {
		super.beforeUnmount(controller);
		controller.target.removeDelegatedMultipleEventListener(['click', 'contextmenu'], '.sidePanel__list__item', this.onClickListItem);
	}

	onClickListItem(e, el) {
		const id_user = el.querySelector('div[data-user-id]').getAttribute('data-user-id');
		if (id_user) {
			App.controls.user_menu.show(el, id_user, '', App.current_page.project || '');
		}
		return false;
	}


}


App.components.dashboard_block_stats_users = {
	onBoot: function () {
		customElements.define(DashboardBlockStatsUsers.TAG_NAME, DashboardBlockStatsUsers);
	}
}

;class DashboardBlockTasks extends DashboardBlockTasksListener {

	static TAG_NAME = 'dashboard-block-tasks';

	mounted(controller) {
		super.mounted(controller);
		controller.controller.removeBlockScroll();
	}

	getItemsSelector({isModalTarget} = {}) {
		return isModalTarget ? '.scrollZone > .flex_row' : '.scrollZone > .flex_row:not(.tabs)'
	}
}


App.components.dashboard_block_tasks = {
	onBoot: function () {
		customElements.define(DashboardBlockTasks.TAG_NAME, DashboardBlockTasks);
	},
}

;class DashboardBlockTasksActivity extends DashboardBlockTasksListener {

	static TAG_NAME = 'dashboard-block-tasks-activity';

	mounted(controller) {
		super.mounted(controller);
		controller.controller.removeBlockScroll();
	}

}


App.components.dashboard_block_tasks_activity = {
	onBoot: function () {
		customElements.define(DashboardBlockTasksActivity.TAG_NAME, DashboardBlockTasksActivity);
	},
}

;class DatatableHierarchyMenu extends RenderableComponent {

	static get observedAttributes() {
		return [
			'hierarchy'
		];
	}

	templateContext() {
		return {
			expandAll: this.expandAll.bind(this),
			collapseAll: this.collapseAll.bind(this),
			processSwitchHierarchy: this.processSwitchHierarchy.bind(this),
			hierarchy: App.helper.parseBoolean(this.attr('hierarchy', false))
		};
	}

	template() {
		return `
		<self>
		<slot></slot>
		</self>
	`;
	}

	collapseAll() {
		App.controls.datatable.collapseAll();
		App.menu.hide();
	}

	expandAll() {
		App.controls.datatable.expandAll();
		App.menu.hide();

	}

	processSwitchHierarchy(e, el) {
		this.toggleAttr('hierarchy');
		App.controls.datatable.customize_menu.process_switcher_click.call(el, e, false);
	}

	toggleAttr(attrName) {
		const currentValue = App.helper.parseBoolean(this.attr(attrName, false));
		this.setAttribute(attrName, currentValue ? 'false' : 'true');
	}

	cancel() {
		this.ref('hierarchySwitch').toggle();
		App.menu.hide();
	}

	submit() {
		App.controls.datatable.customize_menu.save_button_click(false);
		App.menu.hide();
	}


}

App.components.datatable_controls_menu = {
	onBoot: function () {
		customElements.define("datatable-hierarchy-menu", DatatableHierarchyMenu);
	}
};
;class WsInMenuToggle extends RenderableComponent {
	static get observedAttributes() {
		return [
			'active',
			'icon',
			'label'
		];
	}

	templateContext() {
		return {
			active: App.helper.parseBoolean(this.attr('active', false)),
			icon: this.attr('icon', ''),
			label: this.attr('label', '')
		};
	}

	toggle() {
		this.ref('switch').toggle();
	}

	prevent(event) {
		event.stopPropagation();
	}


	template() {
		return `
			<self class="menu__item menu__itemFake flex_row" ws-host-on-click="toggle">
				<ws-icon ws-attr-name="icon"></ws-icon>
				<span class="in flex_content" ws-text="label:htmlenc"></span>
				<ws-switch data-ref="switch" ws-on-click="prevent" ws-attr-checked="active" color="a"></ws-switch>
			</self>
		`
	}
}

App.components.ws_inmenu_toggle = {
	onBoot: function () {
		customElements.define("ws-inmenu-toggle", WsInMenuToggle);
	}
};
;class WsSelectableMenu extends RenderableComponent {

	_menuBox = null;

	static get observedAttributes() {
		return [];
	}
	static defineLifecycle() {
		return function ({on}) {
			on('mount:after', () => {
				this._menuBox = this.ref('menu');
			});
		}
	}

	templateContext() {
		return {
			selectOption: this.selectOption.bind(this),
			showMenu: this.showMenu.bind(this),
			activeOption: this.activeOption,
		};
	}

	connectedCallback() {
		super.connectedCallback();
		this.dispatchActiveOptionChange();
	}

	template() {
		return `
			<self>
				<ws-btn right-icon="arrows/chevron-down" name="btn btn-28 btn-g btn-fill"
						ws-on-click="showMenu"
						class="ws-selectable-menu__trigger" ws-attr-text="activeOption.value:htmlenc" data-ref="anchor">
				</ws-btn>
				<div ws-style="width: '140px'" class="menu menu-secondary" data-ref="menu" >
					<div class="menu__group__wrapper flex_column">
						<div class="menu__group">
							<slot ws-on-click="selectOption"></slot>
						</div>
					</div>
				</div>
			</self>
		`
	}

	showMenu() {
		App.menu.show({
			anchor: this.ref('anchor'),
			box: this._menuBox,
			type: 'mymenu',
			force_dropdown: true,
			backup: true,
		});
	}

	selectOption(event) {
		const option = event.currentTarget;
		this.unselectAll();
		option.setAttribute('active', 'true');
		this.invalidateLifecycle();
		this.dispatchActiveOptionChange();
		App.menu.hide();
	}

	dispatchActiveOptionChange() {
		const activeOption = this.activeOption;
		this.dispatchEvent(new CustomEvent('select', {
			detail: {
				selectedKey: activeOption.key
			}
		}));
	}

	unselectAll() {
		this._menuBox.querySelectorAll('ws-selectable-menu-item').forEach(item => {
			item.removeAttribute('active');
		});
	}

	get activeOption() {
		const activeItem = this._menuBox?.querySelector('ws-selectable-menu-item[active="true"]');
		if (activeItem) {
			return {
				key: activeItem.key,
				value: activeItem.value
			};
		} else {
			const firstItem = this._menuBox?.querySelector('ws-selectable-menu-item');
			if (!firstItem) {
				return {
					key: null,
					value: null
				}
			}
			firstItem.setAttribute('active', 'true');
			return {
				key: firstItem.key,
				value: firstItem.value
			}
		}
	}

}

class WsSelectableMenuItem extends RenderableComponent {
	static get observedAttributes() {
		return ['key', 'active'];
	}

	templateContext() {
		return {
			key: this.attr('key', ''),
			active: App.helper.parseBoolean(this.attr('active', false)),
			value: this.innerText
		};
	}

	get key() {
		return this.templateContext().key;
	}

	get value() {
		return this.templateContext().value;
	}

	get active() {
		return this.templateContext().active;
	}

	template() {
		return `
		<self
			class="menu__item flex_row"
			ws-host-class="[active && 'menu__item-active']"
			key="{key}"
			value="{value:htmlenc}"
		>
			<span class="in flex_content"><slot/></span>
		</self>
	`;
	}



}

App.components.ws_selectable_menu = {
	onBoot: function () {
		customElements.define("ws-selectable-menu", WsSelectableMenu);
	}
};
App.components.ws_selectable_menu_item = {
	onBoot: function () {
		customElements.define("ws-selectable-menu-item", WsSelectableMenuItem);
	}
}
;class ModalDataTable extends RenderableComponent {

	 static get observedAttributes() {
		return [
			'has-actions'
		]
	 }

	 templateContext() {
		return {
			hasActions: this.hasAttribute('has-actions'),
		}
	 }

	template() {
		// language=HTML
		return `
			<self ws-host-class="['flex_column', 'flex_content', 'modal__dataTable', 'modal__dataTable-reactive', hasActions && 'modal__dataTable-withActions']">
				<slot></slot>
			</self>
		`;
	}
}

class ModalDataTableBody extends RenderableComponent {

	static defineLifecycle() {
		return function ({on}) {
			on('mount:after', () => {
				// modal has its own scrollbar initialization
				if (this.closest('.modal')) return;
				App.controls.js_scrollbars.init(this);
			});
		}
	}

	template() {
		// language=HTML
		return `
		<self class="modal__dataTable__body scrollZone">
			<slot></slot>
		</self>
		`
	}
}

class ModalDataTableHead extends RenderableComponent {
	template() {
		// language=HTML
		return `
			<self class="modal__dataTable__head flex_row">
				<slot></slot>
			</self>
		`
	}
}

class ModalDataTableRow extends RenderableComponent {
	template() {
		// language=HTML
		return `
			<self class="modal__dataTable__item flex_row">
				<slot></slot>
			</self>
		`
	}
}

App.components.modal_datatable_components = {
	onBoot() {
		customElements.define("modal-datatable", ModalDataTable);
		customElements.define("modal-datatable-body", ModalDataTableBody);
		customElements.define("modal-datatable-head", ModalDataTableHead);
		customElements.define("modal-datatable-row", ModalDataTableRow);
	}
}
;class ModalDataTableCell extends RenderableComponent {

	static get observedAttributes() {
		return ['name', 'min-w', 'max-w', 'w', 'no-border', 'no-padding']
	}

	templateContext() {
		let maxW = this.attr('max-w');
		const maxWMobile = this.attr('max-w-mobile');
		if (App.device.is_mobile() && maxWMobile !== null) {
			maxW = maxWMobile;
		}
		return {
			name: this.attr('name'),
			minWidth: App.helper.number.to_css_unit(this.attr('min-w', '40')),
			maxWidth: App.helper.number.to_css_unit(maxW),
			width: App.helper.number.to_css_unit(this.attr('w')),
			isSlotText: this.slot().length === 1 && this.slot()[0].nodeType === Node.TEXT_NODE,
			noBorder: this.hasAttribute('no-border'),
			noPadding: this.hasAttribute('no-padding'),
		}
	}

	template() {
		// language=HTML
		return `
			<self ws-host-class="['td', 'td_'+name, noBorder && 'td--no-border', noPadding && 'td--no-padding']" 
				  ws-host-style="min-width: minWidth; max-width: maxWidth; width: width;"
			>
				<span ws-class="[isSlotText && 'text_overflow', isSlotText && 'display_inline']">
					<slot></slot>
				</span>
			</self>
		`;
	}

	setWidth(width) {
		this.setAttribute('w', width);
	}

	setMinWidth(width) {
		this.setAttribute('min-w', width);
	}

	setMaxWidth(width) {
		this.setAttribute('max-w', width);
	}


}

App.components.modal_datatable_cell = {
	onBoot() {
		customElements.define("mdt-cell", ModalDataTableCell);
	}
}

class ModalDataTableCellEditable extends ModalDataTableCell {

	static get observedAttributes() {
		return [
			...super.observedAttributes,
			'value',
			'validator',
			'clipboard',
			'pencil',
			'action',
			'action-name',
			'action-right-icon',
			'action-tooltip',
			'readonly',
		];
	}

	static defineLifecycle() {
		return function ({on}) {
			on('mount:after', () => {
				this.ref('editable').update();
			});
		}
	}

	templateContext() {
		return {
			...super.templateContext(),
			value: this.prop('value', ''),
			validator: this.prop('validator', ''),
			pencil: this.propBool('pencil', false) ? 'true' : 'false',
			clipboard: this.propBool('clipboard', false) ? 'true' : 'false',
			action: this.propBool('action', false) ? 'true' : 'false',
			actionName: this.prop('action-name', ''),
			actionRightIcon: this.prop('action-right-icon', ''),
			actionTooltip: this.prop('action-tooltip', ''),
			readonly: this.propBool('readonly', false) ? 'true' : 'false',
		};
	}


	template() {
		// language=HTML
		return `
			<self ws-host-class="['td', 'td_'+name, noBorder && 'td--no-border']"
				  ws-host-style="min-width: minWidth; max-width: maxWidth; width: width;">
				<ws-editable ws-attr-name="name"
							 name="{name}"
							 ws-attr-value="value"
							 value="{value}"
							 ws-attr-validator="validator"
							 validator="{validator}"
							 ws-attr-clipboard="clipboard"
							 clipboard="{clipboard}"
							 ws-attr-pencil="pencil"
							 pencil="{pencil}"
							 ws-attr-action="action"
							 action="{action}"
							 ws-attr-action-name="actionName"
							 action-name="{actionName}"
							 ws-attr-action-right-icon="actionRightIcon"
							 action-right-icon="{actionRightIcon}"
							 ws-attr-action-tooltip="actionTooltip"
							 action-tooltip="{actionTooltip}"
							 ws-attr-readonly="readonly"
							 readonly="{readonly}"
							 data-ref="editable"
				>
				<span ws-class="[isSlotText && 'text_overflow', isSlotText && 'display_inline']"
					  ws-attr-data-role="isSlotText && 'value'">
					<slot></slot>
				</span>
				</ws-editable>
			</self>
		`;
	}
}

App.components.modal_datatable_cell_editable = {
	onBoot() {
		customElements.define("mdt-cell-editable", ModalDataTableCellEditable);
	}
}
;class ModalDataTableMassTasksRow extends ModalDataTableRow {

	static defineLifecycle() {
		return function ({on}) {
			on('mount:after', () => {
				const self = this;
				const context_menu = new TaskContextMenu({
					components: [
						{type: 'priority', canBeRemoved: false},
						{type: 'stage', canBeRemoved: false},
						{type: 'assignee', canBeRemoved: false},
					],
					input: this.querySelector('input[name="name"]'),
				});
				let unsubscribe;
				context_menu.on('task_context_menu.component.show', function (component) {
					unsubscribe?.();
					const formField = self.querySelector(`mdt-cell[name="${component.type}"] form-field`);
					formField.firstElementChild.emitEvent('click', {
						anchor: component.element(),
						backup: true,
					});
					const {unbind} = formField.addEventListenerWs('change', () => {
						context_menu?.emit('task_context_menu.component.selected', component.type);
					}, {once: true});
					unsubscribe = unbind;
				})
			});
		}
	}
}

App.components.modal_datatable_mass_tasks_row = {
	onBoot() {
		customElements.define("mdt-mass-tasks-row", ModalDataTableMassTasksRow);
	}
}
;class ModalDataTableTasks extends ModalDataTable {
	apply(e, cell) {
		const {detail: {el, value, has_error}} = e;
		if (has_error) {
			return;
		}
		const row = cell.closest('.modal__dataTable__item');
		const task_id = row.getAttribute('data-task-id');
		const field_name = cell.getAttribute('name');
		switch (field_name) {
			case 'name':
				const endpoint = App.helper.url.add_query(
					App.helper.endpoint.task(task_id),
					App.actions.get(`task_edit_name:apply`),
					'name='+encodeURIComponent(value)+'&nohide=true'
				);
				$.getScript(endpoint);
				break;
		}
		cell.setAttribute('value', value);
	}

	action(e, cell) {
		switch (cell.getAttribute('name')) {
			case 'name': {
				App.modal.hide();
				App.task_view.show({url: App.helper.endpoint.task(cell.closest('.modal__dataTable__item').attr('data-task-id'))});
				break;
			}
		}
	}

	template() {
		// language=HTML
		return `
			<self
					class="flex_column flex_content modal__dataTable modal__dataTable-reactive"
					ws-host-class="[hasActions && 'modal__dataTable-withActions']"
					ws-host-delegated-on-apply="mdt-cell-editable|apply"
					ws-host-delegated-on-action="mdt-cell-editable|action"
					
			>
				<slot></slot>
			</self>
		`;
	}





}

App.components.modal_datatable_tasks = {
	onBoot() {
		customElements.define("modal-datatable-tasks", ModalDataTableTasks);
	}
}
;class SidePanelGroup extends RenderableComponent {
	static get observedAttributes() {
		return ['group-title', 'title-prefix', 'title-action', 'group-style', 'level', 'collapsible', 'collapsed', 'has-subgroups', 'table-url', 'table-open-label'];
	}
	static defineLifecycle() {
		return function ({on}) {
			on('mount:after', () => {
				this._syncSubgroups();
			});
			on('update:before', () => {
				this._syncSubgroups();
			})
		}
	}

	templateContext() {
		const parseBool = App.helper.parseBoolean;
		let titleAction = this.attr('title-action', null);
		titleAction = titleAction ? new Function(titleAction).bind(this.ref('title')) : null;
		const tableUrl = this.attr('table-url', '');
		return {
			titlePrefix: this.attr('title-prefix'),
			titleRaw: this.attr('group-title'),
			titleAction: titleAction,
			hasAction: !!titleAction,
			groupStyle: this.attr('group-style', ''),
			collapsible: parseBool(this.attr('collapsible', false)),
			collapsed: parseBool(this.attr('collapsed', false)),
			level: parseInt(this.attr('level', 1), 10),
			childrenCount: this.childrenCount,
			toggleCollapse: this.toggleCollapse.bind(this),
			tableUrl,
			tableOpenLabel: this.attr('table-open-label', ''),
			hasTableUrl: !!tableUrl,
			openTable: this.openTable.bind(this),
		};
	}

	openTable(e) {
		e.preventDefault();
		e.stopPropagation();
		App.core.goto(e.currentTarget.href);
	}

	template() {
		return `
		<self class="sidePanel__list__group" ws-attr-data-group-style="groupStyle">
			<span ws-if="level == 1" class="mm_float_pre"></span>
			<span ws-if="titlePrefix.length || titleRaw.length" class="sidePanel__list__group__title flex_row mm_float" data-ref="title">
				<span class="in flex_content flex_row flex_overflow flex_shrink" ws-on-click="titleAction" ws-attr-has-action="hasAction">
					{titlePrefix}
					<span class="flex_shrink text_overflow" data-title ws-html="titleRaw"></span>
				</span>
				<div ws-if="collapsible" class="space space-expand space-expand-on" ws-on-click="toggleCollapse">
					<ws-btn  ws-if="collapsed">
						<button type="button" class="btn btn-a btn-fill">
							<ws-icon class="btn-left-icon" name="arrows/arrow_drop-left"></ws-icon>
							<span ws-html="childrenCount"></span>
						</button>
					</ws-btn>
					<ws-btn ws-if="!collapsed" name="btn btn-g btn-ghost" left-icon="arrows/arrow_drop-down"></ws-btn>
				</div>
				<span ws-if="hasTableUrl" class="flex_content flex_grow"></span>
				<a ws-if="hasTableUrl" href="{tableUrl}" class="goTo withBtnHover flex_noshrink" ws-on-click="openTable">
					<span ws-html="tableOpenLabel"></span>
					<ws-btn name="btn btn-a btn-fill btn-24" left-icon="arrows/arrow_diagonal-up-right"></ws-btn>
				</a>
			</span>
			<slot ws-show="!collapsed"></slot>
		</self>
	`;
	}


	_syncSubgroups() {
		const level = this.templateContext().level;
		if (!this.attr('level')) {
			this.setAttribute('level', level);
		}
		this.slot().forEach((el) => {
			if (el.tagName?.toLowerCase() === 'sidepanel-group') {
				el.setAttribute('level', level + 1);
			}
		});
	}

	toggleCollapse() {
		const collapsed = !this.templateContext().collapsed;
		this.setAttribute('collapsed', collapsed);
		$.ajax({
			method: 'POST',
			url: this.attr('collapse-url'),
			data: {
				collapsed,
				id: this.attr('group-id')
			}
		})


	}

	get childrenCount() {
		const diffSelector = this.attr('diff-selector');
		const countInNodeTotal = (node) => {
			if (!node || node.nodeType !== Node.ELEMENT_NODE) return 0;
			let count = node.classList?.contains('sidePanel__list__item') ? 1 : 0;
			return count + [...node.children].reduce((sum, child) => sum + countInNodeTotal(child), 0);
		};
		const countInNodeDiff = (node) => {
			if (!node || node.nodeType !== Node.ELEMENT_NODE) return 0;
			let count = (node.classList?.contains('sidePanel__list__item') && node.matches(diffSelector)) ? 1 : 0;
			return count + [...node.children].reduce((sum, child) => sum + countInNodeDiff(child), 0);
		};
		const totalCount = this.slot().reduce((total, root) => total + countInNodeTotal(root), 0);
		const diffCount = diffSelector ? this.slot().reduce((total, root) => total + countInNodeDiff(root), 0) : null;
		let str = totalCount;
		if (diffCount !== null) {
			str = diffCount + `<span class="sidePanel-costs-collapse-diff"> / ${str}</span>`;
		}
		return str;
	}
}

App.components.sidepanel_group = {
	onBoot: () => customElements.define('sidepanel-group', SidePanelGroup),
};

;class SidePanelTuneMenuBody extends RenderableComponent {

	static get observedAttributes() {
		return [];
	}

	static defineLifecycle() {
		return function ({on}) {
			on('mount:after', () => {
				const dataAttrs = this.attributeObserver._runtimeObservedAttributes;
				const data = {};
				for (const attr of Object.keys(dataAttrs)) {
					data[App.helper.string.to_snake_case(attr)] = this.attr(attr);
				}
				this._originals = data;
			});
		}
	}

	templateContext() {
		const dataAttrs = this.attributeObserver._runtimeObservedAttributes;
		const data = {};
		for (const attr of Object.keys(dataAttrs)) {
			data[App.helper.string.to_snake_case(attr)] = this.attr(attr);
		}
		let edited = false;
		for (const key in data) {
			if (data[key] != this._originals?.[key]) {
				edited = true;
				break;
			}
		}

		return {
			...data,
			locale: App.object_state.locale,
			edited,
			size_class: App.device.is_mobile() ? 'btn-36' : 'btn-28'
		}
	}

	template() {
		return `
			<self style="width: 330px" data-menu="sidepanel__filter-menu"
				 class="menu menu-primary menu-autoWidthMax menu-bigSwitchers">
					<div class="menu__group__wrapper flex_column">
						<div class="scrollZone">
							<slot/>
						</div>
					</div>
					<div class="menu__group menu__group-bottom menu__group-buttons flex_row">
						<ws-btn
							ws-on-click="reset"
							name="btn {size_class} btn-g btn-skeleton menuBtnNoResize"
							text="{locale.reset}"
							data-menu-btn-no-resize="true"
						></ws-btn>
						<span class="flex_gap"></span>
						<ws-btn
							ws-on-click="submit"
							name="btn {size_class} btn-a btn-solid menuBtnNoResize"
							ws-if="edited"
							text="{locale.apply}"
						></ws-btn>
					</div>
			</self>

		`
	}

	reset(e) {
		App.controls.confirm.menu(e.currentTarget, {
			message: App.object_state.locale.reset_confirm,
			backup: true,
			on_confirm: () => {
				$.ajax({
					url: this.attr('reset-url'),
					method: 'POST',
					success: () => {
						this._invalidateMenu();
					}
				})
			}
		});
	}
	submit() {
		const dataAttrs = this.attributeObserver._runtimeObservedAttributes;
		const data = {};
		for (const attr of Object.keys(dataAttrs)) {
			data[App.helper.string.to_snake_case(attr)] = this.attr(attr);
		}
		$.ajax({
			url: this.attr('save-url'),
			method: 'POST',
			data,
			success: () => {
				this._invalidateMenu();
			}
		})
	}

	_invalidateMenu() {
		App.menu.hide();
		const menu_invalidate_key = this.attr('menu-invalidate-key');
		if (menu_invalidate_key) {
			menu_invalidate_key.split(',').forEach((key) => {
				const clean_key = key.trim();
				if (clean_key) App.mymenu.invalidate_window(clean_key);
			});
		}
		this.remove();
	}
}

App.components.sidepanel_tune_menu_body = {
	onBoot: function () {
		customElements.define("sidepanel-tune-menu-body", SidePanelTuneMenuBody);
	}
};
;App.components.task_list_item = {
	onBoot: function() {
		customElements.define("task-list-item", class extends HTMLElement {
			constructor() {
				super();
			}

			render() {

			}
		})
	}
}

;class PrioritySelector extends RenderableComponent {
	static get observedAttributes() {
		return ['value', 'input-name'];
	}

	templateContext() {
		return {
			value: this.prop('value'),
			inputName: this.prop('input-name', 'priority'),
		}
	}

	onClick(e) {
		const eventData = e.detail || {};
		App.controls.priority.open(eventData.anchor || this, {
			backup: eventData.backup || false,
			onApply: (priority) => {
				this.onSelected({priority});
			}
		}, () =>{});
	}

	onSelected({priority}) {
		this.setProp('value', priority);
		this.emitEvent('selected', {priority});
	}

	get value() {
		return this.prop('value');
	}

	template() {
		// language=HTML
		return `
			<self class="space" ws-host-on-click="onClick">
				<a ws-class="['priorb', 'prior'+value]">
					<span class="display_contents" ws-text="value"></span>
					<ws-icon ws-if="!value" name="timer-pause"></ws-icon>
				</a>
				<input type="hidden" ws-attr-name="inputName" ws-attr-value="value"/>
			</self>
		`;
	}
}

App.components.priority_selector = {
	onBoot() {
		customElements.define('priority-selector', PrioritySelector);
	}
}
;class ProjectSelector extends RenderableComponent {

	static get observedAttributes() {
		return ['name', 'ids'];
	}

	templateContext() {
		return {
			name: this.attr('name'),
			ids: this.ids,
			ids_string: this.attr('ids'),
			onClick: this.onClick.bind(this),
			onDelete: this.onDelete.bind(this),
			onSelected: this.onSelected.bind(this),
		}
	}

	get ids() {
		return App.helper.string.to_ids(this.attr('ids', ''));
	}

	get value() {
		return this.ids;
	}

	onClick(event) {
		const eventData = event.detail || {};
		const isMultiMode = this.ids.length > 1 || eventData.multi;
		const requirements = this.requestHandshake('project_selector_requirements') || {};
		const multipleEnabled = App.helper.parseBoolean(this.attr('multiple-enabled', false));

		const requestOptions = {
			requirements: true,
			use_sidebar_config: true,
			...(isMultiMode
				? { multiple: true }
				: {
					multiple_enabled: (requirements.multiple_enabled || multipleEnabled) ? 1 : 0,
					ids_assignee: requirements.ids_assignee
				})
		};
		this.unbinds = [];

		App.controls.project_select_and_go.show_context(eventData.anchor || this.firstElementChild, null, {
			request: requestOptions,
			onload: (menuElement) => {
				App.controls.menu.init($(menuElement));
			},
			onshow: (menuElement) => {
				menuElement.unbinds?.forEach((unbind) => unbind());
				menuElement.unbinds = [];
				const {unbind: unbindItem} = menuElement.addDelegatedEventListener('click', '.menu__item, .menu__itemFake',  (e, element) => {
					const detail = isMultiMode
						? this.buildMultiDetail(menuElement)
						: this.buildSingleDetail(element);

					if (!isMultiMode) App.menu.hide();
					this.onSelected(detail);
				});
				menuElement.unbinds.push(unbindItem);

				if (!isMultiMode) {
					const {unbind: unbindMulti} = menuElement.addDelegatedEventListener('click', '.multi-select', () => {
						App.menu.hide(true);
						this.onClick({ detail: { multi: true } });
					});
					menuElement.unbinds.push(unbindMulti);
				}
				const selector = this.ids.map(id => `.menu__item[data-id="${id}"]`).join(', ');
				menuElement.querySelectorAll('.menu__item-active').removeClass('menu__item-active');
				if (selector) menuElement.querySelectorAll(selector).addClass('menu__item-active');
			},

			backup: eventData.backup || false
		});

		event.stopPropagation?.();
	}

	buildMultiDetail(menuElement) {
		const activeItems = Array.from(menuElement.querySelectorAll('.menu__item-active'));
		const activeItem = activeItems[0];
		return {
			ids: [...new Set(activeItems.map(item => item.getAttribute('data-id').toInt()))],
			element: menuElement,
			multi: true,
			name: activeItem?.querySelector('.in')?.textContent.trim(),
			icon: activeItem?.querySelector('span.space')?.innerHTML.trim()
		};
	}

	buildSingleDetail(element) {
		return {
			ids: [element.getAttribute('data-id').toInt()],
			element: element,
			multi: false,
			name: element.querySelector('.in').textContent.trim(),
			icon: element.querySelector('span.space').innerHTML.trim()
		};
	}

	onDelete(e) {
		e.stopPropagation();
		this.onSelected({ ids: [] });
		this.emitEvent('delete');
	}

	onSelected({ ids, name, icon }) {
		if (!App.helper.parseBoolean(this.attr('auto-change', true))) return;

		this.setAttribute('ids', ids.join(','));

		if (ids.length > 1) {
			this.setSlot('icon', '<ws-icon name="project-solid"></ws-icon>');
			this.setAttribute('name', App.format.quantity(ids.length, App.object_state.locale['projects'], QTY_WITH_TEXT));
		} else if (!ids.length) {
			this.removeAttribute('name');
			this.setSlot('icon', '');
		} else {
			this.setSlot('icon', icon);
			this.setAttribute('name', name);
		}
		this.emitEvent('selected', { ids, name, icon });
	}

	template() {
		return `
			<self class="display_contents" ws-host-on-click="onClick">
				<ws-chip ws-if="!ids.length" name="chip chip-dashed">
					<div class="chip chip-dashed">
						<span>{locale.project_selector.no_project}</span>
						<ws-icon name="arrows/chevron_sm-down" class="chevron-attr"></ws-icon>
<!--						<ws-icon name="lock_sm" data-title="{locale.project_selector.project_lock:htmlenc}"></ws-icon>-->
					</div>
				</ws-chip>
				<ws-chip ws-if="ids.length">
					<div class="chip chip-outline">
						<slot name="icon"></slot>
						<span ws-text="name"></span>
						<ws-icon name="arrows/chevron_sm-down" class="chevron-attr"></ws-icon>
						<ws-icon name="close_sm" ws-on-click="onDelete" class="delete cross-attr"></ws-icon>
					</div>
				</ws-chip>
				<input ws-if="ids.length" type="hidden" ws-attr-name="(ids.length === 1 && 'id_project') || 'ids_project'" ws-attr-value="ids_string">
			</self>
		`;
	}

}

App.components.project_selector = {
	onBoot() {
		customElements.define('project-selector', ProjectSelector);
	}
};

;class Stage_selector extends RenderableComponent {
	static get observedAttributes() {
		return ['stage-id', 'name', 'input-name', 'color', 'icon', 'percent-style'];
	}

	templateContext() {
		return {
			id: this.prop('stage-id'),
			name: this.prop('name'),
			inputName: this.prop('input-name', 'id_stage'),
			color: this.prop('color', ''),
			icon: this.prop('icon', ''),
			percentStyle: this.prop('percent-style', ''),
		}
	}

	onClick(e) {
		const eventData = e.detail || {};
		const {url, userSelector} = this.requestHandshake('stage_selector_requirements');
		if (!url) return;

		App.controls.project_task_stage_and_go.show_context(eventData.anchor || this, url, {
			backup: eventData.backup || false,
			onshow:  (menu) => {
				menu.unbind?.();
				const {unbind: unbindItem} = menu.addDelegatedEventListener('click', '.menu__item',  (e, el) => {
					this.onSelected({
						name: el.querySelector('.flex_content').textContent,
						color: el.getAttribute('data-color'),
						id: el.getAttribute('data-id'),
						icon: el.children[0] ? el.children[0].getAttribute('name') : '',
						percentStyle: el.getAttribute('data-percent-style') || '',
					})
					const assigned_user = el.querySelector('.av_pre');
					userSelector && assigned_user && userSelector.onSelected({
						name: assigned_user.getAttribute('data-name'),
						avatar: assigned_user.innerHTML,
						id: assigned_user.getAttribute('data-id'),
					});
					App.menu.hide();
				});
				menu.unbind = unbindItem;
			}
		});
	}

	onSelected({id, name, color, icon, percentStyle}) {
		this.setProp('stage-id', id);
		this.setProp('name', name);
		this.setProp('color', color);
		this.setProp('icon', icon);
		this.setProp('percent-style', percentStyle);
		this.emitEvent('selected', {id, name, color, icon, percentStyle});
	}

	get value() {
		return this.prop('stage-id');
	}

	get data() {
		return {
			id: this.prop('stage-id'),
			name: this.prop('name'),
			color: this.prop('color'),
			icon: this.prop('icon'),
			percentStyle: this.prop('percent-style'),
		}
	}



	template() {
		// language=HTML
		return `
			<self class="stage-selecto ws-utility-cursor-pointer" ws-host-on-click="onClick">
				<ws-icon ws-attr-name="icon" ws-class="['tag', 'tag'+color]" ws-attr-data-title="name"
						 ws-style="--percent:percentStyle"></ws-icon>
				<input type="hidden" ws-attr-name="inputName" ws-attr-value="id">
			</self>
		`;
	}

}

App.components.stage_selector = {
	onBoot() {
		customElements.define('stage-selector', Stage_selector);
	}
}
;class SubscribersSelector extends RenderableComponent {

	static get observedAttributes() {
		return ['ids', 'draw-more'];
	}

	static defineLifecycle() {
		return function ({on}) {
			on('update:before', () => {
				const ids = this.ids;
				let items = this.prop('items', {});
				if (!Object.values(items).length || App.helper.array.equal(ids, Object.keys(items).map(Number))) {
					return;
				}
				const newItems = {};
				ids.forEach(id => {
					if (items[id]) {
						newItems[id] = items[id];
					}
				});
				this.setProp('items', newItems);
				return true;
			})
		}
	}

	templateContext() {
		const items = Object.values(this.prop('items', {}));
		const special_items = Object.values(this.prop('special_items', {}));
		return {
			ids: this.ids,
			ids_string: this.attr('ids'),
			drawMore: App.helper.parseBoolean(this.attr('draw-more', false)),
			onClick: this.onClick.bind(this),
			moreText: items.length > 6 ? `+${items.length - 5}` : '+',
			items: items,
			special_items: special_items,
		}
	}


	get ids() {
		return App.helper.string.to_ids(this.attr('ids', ''));
	}

	get idsAppend() {
		return App.helper.string.to_ids(this.attr('ids-append', ''));
	}


	get value() {
		return [...this.ids, ...this.idsAppend];
	}

	get items() {
		return Object.values(this.prop('items', {}));
	}

	onClick(event) {
		const eventData = event.detail || {};
		const {ids_project, hidden, url} = this.requestHandshake('subscribers_selector_requirements') || {};
		const request = {
			type: 'subscribers',
			ids_project: ids_project.length > 1 ? ids_project.join(',') : undefined,
			hidden: hidden.length ? hidden.join(',') : undefined,
		};

		App.controls.user_select_and_go.show_context(eventData?.anchor || this, url, {
			backup: eventData?.backup || false,
			request,
			type: 'left',
			last_value_target: this,
			onload:  (menuElement) => {
				App.controls.menu.init($(menuElement));
			},
			onshow: (menuElement) => {
				menuElement.unbind?.();
				const btn = menuElement.querySelector('.menu__group-head ws-btn');
				const {unbind: unbindBtn} =btn.addEventListenerWs('click',  () => {
					const activeElements = Array.from(menuElement.querySelectorAll('.menu__item-active'));
					const detail = {
						element: menuElement,
						ids: activeElements.map(item => item.getAttribute('data-id')),
						activeItems: activeElements.map(item => ({
							name: item.querySelector('.in')?.textContent || '',
							id: item.getAttribute('data-id'),
							avatar: item.querySelector('.av_sm')?.outerHTML || '',
							element: item,
						})),
					}
					this.onSelected(detail);
					App.menu.hide();
				});
				menuElement.unbind = unbindBtn;
				const selector = this.ids.map(id => `.menu__item[data-id="${id}"]`).join(', ');
				menuElement.querySelectorAll('.menu__item-active').removeClass('menu__item-active');
				if (selector) menuElement.querySelectorAll(selector).addClass('menu__item-active');
				$(menuElement).trigger('after_interaction');
			}
		});
	}

	onSelected({activeItems}) {
		this.setProp('ids', activeItems.map(item => item.id).join(','));
		const items = {};
		activeItems.forEach(item => items[item.id] = item);
		this.setProp('items', items);
		this.emitEvent('selected', {activeItems});
	}

	appendSubscriber({id, name, avatar}) {
		const items = this.prop('items', {});
		if (!items[id]) {
			items[id] = {id, name, avatar};
			this.setProp('items', items);
			this.setProp('ids', [...this.ids, id].join(','));
		}
	}

	template() {
		// language=HTML
		return `
			<self class="in flex_row taskCreate__subscribers" data-title="{locale.task_menu.subscribers}"
				  ws-host-on-click="onClick">
				<div class="in flex_row">
					<a class="taskCreate__subscribers__item taskCreate__subscribers__item--special" ws-for="item, index in special_items | key: item.id"
					   ws-attr-data-id="item.id" ws-attr-data-title="item.name" ws-html="item.avatar">
					</a>
					<a class="taskCreate__subscribers__item" ws-for="item, index in items | key: item.id"
					   ws-attr-data-id="item.id" ws-attr-data-title="item.name" ws-html="item.avatar">
					</a>
					<span class="more" ws-text="moreText"></span>
				</div>
				<input ws-if="ids.length" type="hidden" name="ids_subscribe" ws-attr-value="ids_string">
			</self>
		`
	}
}

App.components.subscribers_selector = {
	onBoot() {
		customElements.define('subscribers-selector', SubscribersSelector);
	}
}
;class TaskSelector extends RenderableComponent {

	static get observedAttributes() {
		return ['name', 'id', 'url'];
	}

	templateContext() {
		return {
			name: this.attr('name'),
			id: this.attr('id'),
			url: this.attr('url'),
			onDelete: this.onDelete.bind(this),
		}
	}

	onClick(event) {
		const eventData = event.detail || {};
		const urlFromAttr = this.attr('url');
		const {url} = this.requestHandshake('task_selector_requirements') || {};
		App.controls.task_select_and_go.show_context(eventData.anchor || this.firstElementChild, url || urlFromAttr, {
			request: {type: 'create'},
			onload: (menu) => {
				App.controls.menu.init($(menu));
			},
			onshow:  (menu) => {
				menu.unbind?.();
				const {unbind: unbindItem} = menu.addDelegatedEventListener('click', '.menu__item',  (e, el) => {
					const detail = {
						name: el.querySelector('.in')?.textContent || '',
						url: el.getAttribute('data-url'),
						id: el.getAttribute('data-id'),
						icon: el.querySelector('task-stage')?.innerHTML || '',
						element: el,
					}
					this.onSelected(detail);
					this.emitEvent('selected', detail);
					App.menu.hide();
				});
				menu.unbind = unbindItem;
			},
			backup: eventData?.backup || false,
		});

	}

	onDelete(e) {
		e?.stopPropagation();
		this.onSelected({});
		this.emitEvent('delete');
	}

	onSelected({name, id, icon, url} = {}) {
		this.setAttribute('name', name || '');
		this.setAttribute('id', id || '');
		this.setSlot('icon', icon || '');
		this.setAttribute('url', url || '');
	}

	get value() {
		return this.getAttribute('id');
	}

	template() {
		// language=HTML
		return `
			<self class="display_contents" ws-host-on-click="onClick">
				<ws-chip ws-if="!id" name="chip chip-outline" text="{locale.task_selector.no_task}"></ws-chip>
				<ws-chip ws-if="id">
					<div class="chip chip-outline">
						<slot name="icon"></slot>
						<span ws-text="name"></span>
						<ws-icon name="close_sm" class="delete cross-attr" ws-on-click="onDelete"></ws-icon>
					</div>
				</ws-chip>
				<input ws-if="id" type="hidden" name="id_parent" ws-attr-value="id" ws-attr-data-url="url">
			</self>
		`


	}

}

App.components.task_selector = {
	onBoot() {
		customElements.define('task-selector', TaskSelector);
	}
}
;class UserSelector extends RenderableComponent {

	static get observedAttributes() {
		return ['user-id', 'name', 'input-name'];
	}

	templateContext() {
		return {
			id: this.prop('user-id'),
			name: this.prop('name'),
			inputName: this.attr('input-name', 'id_user'),
		}
	}

	onClick(e) {
		const eventData = e.detail || {};
		const {url} = this.requestHandshake('user_selector_requirements') || {};
		if (!url) {
			return;
		}
		App.controls.user_select_and_go.show_context(eventData.anchor || this, url, {
			request: {
				type: 'assign',
				select_user_format: 'FLD_LL_F'
			},
			backup: eventData.backup || false,
			onload: (menu) => {
				App.controls.menu.init($(menu));
			},
			onshow: (menu) => {
				menu.unbind?.();
				const {unbind: unbindItem} = menu.addDelegatedEventListener('click', '.menu__item[data-id]', (event, item) => {
					this.onSelected({
						id: item.getAttribute('data-id'),
						name: item.querySelector('.in').textContent,
						avatar: item.querySelector('.av_sm') ? item.querySelector('.av_sm').outerHTML : '',
						element: item,
					})
					App.menu.hide();
				});
				menu.unbind = unbindItem;
			}
		});
	}

	onSelected({id, name, avatar}) {
		this.setProp('user-id', id);
		this.setProp('name', name);
		this.setSlot('avatar', avatar);
		this.emitEvent('selected', {id, name, avatar});
	}

	template() {
		// language=HTML
		return `
			<self class="user-selector data flex_row" ws-host-on-click="onClick">
				<span class="space"><slot name="avatar"></slot></span>
				<span class="in flex_content flex_overflow" ws-text="name"></span>
				<slot name="after"></slot>
				<input type="hidden" ws-attr-name="inputName" ws-attr-value="id">
			</self>
		`;
	}

	get value() {
		return this.prop('user-id');
	}

	get data() {
		return {
			id: this.prop('user-id'),
			name: this.prop('name'),
			avatar: this.slot('avatar')[0]?.outerHTML || '',
		}
	}
}

App.components.user_selector = {
	onBoot() {
		customElements.define('user-selector', UserSelector);
	}
}


;class ScheduleDateLine extends RenderableComponent {
	static get observedAttributes() {
		return [
			...inferAttributesFrom(WSCheckbox, 'ws-checkbox'),
			...inferAttributesFrom(ScheduleDateProgressbar, 'schedule-date-progressbar'),
			...inferAttributesFrom(ScheduleTimePicker, 'schedule-time-picker'),
			'date'
		];
	}

	templateContext() {
		return {
		};
	}


	get date() { return this.attr('date', ''); }
	get checkbox() { return this.ref('checkbox'); }
	get progressbar() { return this.ref('progressbar'); }
	get timepicker() { return this.ref('timepicker'); }

	template() {
		return `
		<self>
			<ws-checkbox data-ref="checkbox" ${drawBinds(this, 'ws-checkbox')}></ws-checkbox>
			<schedule-date-progressbar data-ref="progressbar" ${drawBinds(this, 'schedule-date-progressbar')}></schedule-date-progressbar>
			<schedule-time-picker data-ref="timepicker" ${drawBinds(this, 'schedule-time-picker')}></schedule-time-picker>
		</self>
		`;
	}

}

/**
 * @param {Object} from
 * @param {string} prefix
 */
const drawBinds = (from, prefix,) => {
	const binds = [];
	from.constructor.observedAttributes?.forEach(attr => {
		if (attr.startsWith(prefix + '-')) {
			const originalAttr = attr.slice(prefix.length + 1);
			binds.push(`ws-proxy-attr-${originalAttr}="${attr}"`);
		}
	});
	return binds.join(' ');
}



/**
 * @param {*} from
 * @param {string} fromName
 */
const inferAttributesFrom = (from, fromName) => {
	const attributes = [];
	from.observedAttributes?.forEach(attr => {
		attributes.push(`${fromName}-${attr}`);
	});
	return attributes;
}

App.components.schedule_date_line = {
	onBoot() { customElements.define("schedule-date-line", ScheduleDateLine); }
};
;class ScheduleDateProgressbar extends RenderableComponent {

	static get observedAttributes() {
		return ["date", "month", "day-of-week", "subtext", "subtext-type", "selected", "selected-new", "date-work-time", "holiday-icon", "end-text", "rest", "disabled", "selected-tasks"];
	}

	getTimedAttribute(name, def) {
		return App.helper.parseTimeToMinutes(this.attr(name, def));
	}

	setTimedAttribute(name, minutes) {
		this.setAttribute(name, App.helper.minutesToHM(minutes));
	}

	templateContext() {
		const disabled = App.helper.parseBoolean(this.attr("disabled", false));
		const date = this.attr("date");
		const month = this.attr("month");
		const dayOfWeek = this.attr("day-of-week");
		const subtext = this.attr("subtext");
		const subtextType = this.attr("subtext-type", "base");
		const selected = this.getTimedAttribute("selected", 0);
		const selectedNew = this.getTimedAttribute("selected-new", 0);
		const dateWorkTime = this.getTimedAttribute("date-work-time");
		const holidayIcon = this.attr("holiday-icon", null);
		const endText = this.attr("end-text", null);
		const rest = Math.max(0, dateWorkTime - selected - selectedNew);
		const overloadFromSelected = Math.max(selected - dateWorkTime, 0);
		const overloadFromSelectedNew = Math.max(selectedNew - overloadFromSelected - (dateWorkTime - selected), 0);
		const overload = overloadFromSelected + overloadFromSelectedNew;
		const selectedTasks = JSON.parse(this.attr('selected-tasks', '{}'));

		return {
			date,
			month,
			dayOfWeek,
			subtext,
			subtextType,
			selected,
			selectedNew,
			dateWorkTime,
			holidayIcon,
			endText,
			rest,
			disabled,
			overload,
			overloadFromSelectedNew,
			overloadFromSelected,
			selectedTasks,
			workMinutes: dateWorkTime + overload,
			tooltipNew: App.helper.template.fill('schedule-date-progressbar__tooltip', {
				norm: App.helper.minutesToHM(dateWorkTime ),
				booked: App.helper.minutesToHM(selected),
				added: App.helper.minutesToHM(selectedNew),
				overload: overload ? App.helper.minutesToHM(overload) : false,
				rest: rest ?  App.helper.minutesToHM(rest) : false
			}),
			tooltipSelected: App.helper.template.fill('schedule-date-progressbar-selected__tooltip', {
				tasks: selectedTasks,
				booked: App.helper.minutesToHM(selected),
			}),
			...this.segmentsData({
				selected,
				selectedNew,
				dateWorkTime,
				disabled,
				overload,
				overloadFromSelectedNew,
				overloadFromSelected
			})
		};
	}

	segmentsData(data) {
		let {
			selected,
			selectedNew,
			dateWorkTime,
			disabled,
			overload,
			overloadFromSelectedNew,
			overloadFromSelected
		} = data;

		disabled && (selectedNew = overload = 0);

		const pctBase = (dateWorkTime + overload) || 1;
		const toPct = v => (v / pctBase) * 100;
		const selectedPct = Math.max(0, toPct(selected - overloadFromSelected));
		const selectedNewPct = Math.max(0, toPct(selectedNew - overloadFromSelectedNew));
		const overloadPct = Math.max(0, toPct(overload));
		const restPct = Math.max(0, 100 - selectedPct - selectedNewPct - overloadPct);
		return {
			selectedPct: selectedPct + '%',
			selectedPctActive: selectedPct > 0.0001,
			selectedNewPct: selectedNewPct + '%',
			selectedNewPctActive: selectedNewPct > 0.0001,
			overloadPct: overloadPct + '%',
			overloadPctActive: overloadPct > 0.0001,
			restPct: restPct + '%',
			restPctActive: restPct > 0.0001,
		}
	}

	template() {
		return `
			<self>
				<div class="schedule-date-progressbar__container">
					<div class="schedule-date-progressbar__text-container">
						<div class="schedule-date-progressbar__text-container-inner-left">
							<span class="schedule-date-progressbar__text-inner-left--primary" ws-text="date"></span>
							<span class="schedule-date-progressbar__text-inner-left--secondary" ws-text="month"></span>
						</div>
						<div class="schedule-date-progressbar__text-container-inner-right">
							<span class="schedule-date-progressbar__text-inner-right--primary"
								  ws-text="dayOfWeek"></span>
							<span ws-if="subtext?.length"
								  ws-class="['schedule-date-progressbar__text-inner-right--secondary', 'schedule-date-progressbar__text-inner-right--secondary-'+subtextType]"
								  ws-text="subtext"></span>
						</div>
						<slot name="holidayIcon"/>
						<span ws-if="endText?.length" ws-text="endText"
							  class="schedule-date-progressbar__end-text"></span>
					</div>
					<div class="schedule-date-progressbar__bar">
						<div ws-if="selectedPctActive" ws-attr-data-title="tooltipSelected" class="schedule-date-progressbar__seg seg-selected"
							 ws-style="flex-basis:selectedPct" ></div>
						<div ws-if="selectedNewPctActive" ws-attr-data-title="tooltipNew" class="schedule-date-progressbar__seg seg-selected-new"
							 ws-style="flex-basis:selectedNewPct" ></div>
						<div ws-if="overloadPctActive" ws-attr-data-title="tooltipNew" class="schedule-date-progressbar__seg seg-overload"
							 ws-style="flex-basis:overloadPct" ></div>
						<div ws-if="restPctActive" ws-attr-data-title="tooltipNew" class="schedule-date-progressbar__seg seg-rest"
							 ws-style="flex-basis:restPct"></div>
					</div>
					<div class="schedule-date-progressbar__scale"
						 ws-style="--work-minutes: workMinutes"></div>
				</div>
			</self>
		`
	}



	addSelectedNew(minutes) {
		this.setTimedAttribute('selected-new', this.getTimedAttribute("selected-new", 0) + minutes);
	}

	removeSelectedNew(minutes) {
		this.setTimedAttribute('selected-new', Math.max(0, this.getTimedAttribute("selected-new", 0) - minutes));
	}

	disable() {
		this.setAttribute('disabled', 'true');
	}
	enable() {
		this.setAttribute('disabled', 'false');
	}

}


App.components.schedule_date_progressbar = {
	onBoot() {
		customElements.define("schedule-date-progressbar", ScheduleDateProgressbar);
	}
};

;class ScheduleHoursPie extends RenderableComponent {


	static get observedAttributes() {
		return ["my", "over", "tracked", "rest", "total", "dateend"];
	}


	getTimedAttribute(name, def) {
		return App.helper.parseTimeToMinutes(this.attr(name, def));
	}

	setTimedAttribute(name, minutes) {
		this.setAttribute(name, App.helper.minutesToHM(minutes));
	}

	templateContext() {
		const my = this.getTimedAttribute('my', 0);
		const tracked = this.getTimedAttribute('tracked', 0);
		const total = this.getTimedAttribute('total', 0);
		const dateend = this.attr('dateend', null);
		const over = Math.max(0, my + tracked - total);

		let rest;
		if (this.hasAttribute("rest")) {
			rest = this.getTimedAttribute('rest', 0);
		} else {
			rest = App.helper.clamp(total - tracked - my);
		}

		return {
			my,
			over,
			tracked,
			rest,
			total,
			total_text: Math.round(total / 60),
			dateend,
			total_eq_rest: total === rest,
			hours_text: App.format.quantity(total, App.object_state.locale['hrs']),
			chart_gradient: this.buildChartGradient({my, over, tracked, rest}),
			tooltip: App.helper.template.fill('schedule-hours-pie__tooltip', {
				estimate: App.helper.minutesToHM(total),
				tracked: App.helper.minutesToHM(tracked),
				added: App.helper.minutesToHM(my),
				left: App.helper.minutesToHM(Math.max(0, total - tracked - my)),
				dateend,
				overload: over ? App.helper.minutesToHM(over) : false,
			})
		};
	}

	template() {
		return `
		<self ws-host-attr-data-title="tooltip">
			<div ws-if="total_eq_rest" class="schedule-hours-pie schedule-hours-pie--text">
				<span class="schedule-hours-pie__text--primary" ws-text="total_text"></span>
				<span class="schedule-hours-pie__text--secondary" ws-text="hours_text"></span>
			</div>
			<div ws-if="!total_eq_rest" class="schedule-hours-pie" ws-style="background: chart_gradient"></div>
		</self>
		`
	}

	buildChartGradient(data) {
		let {my, over, tracked, rest} = data;

		const pct = (my + over + tracked + rest) / 100;

		const toPct = v => (v / pct);
		my = toPct(my);
		over = over ? Math.max(5, toPct(over)) : 0; // минимум 5%, чтобы было видно
		tracked = toPct(tracked);
		rest = toPct(rest);

		const stops = [];
		let acc = 0;
		const push = (color, val) => {
			if (val <= 0) return;
			const from = acc, to = acc + val;
			acc = to;
			stops.push(`${color} ${from}% ${to}%`);
		};

		push("var(--base-txt-ghost, rgba(0, 34, 61, 0.14))", tracked); // серый
		push("var(--base-hlt-b-invert, #8162E0)", my);         // мой кусок
		push("var(--base-hlt-w-invert, #D93643)", over);       // перебор
		push("transparent", rest);                             // остаток

		return `conic-gradient(${stops.join(",")}) padding-box`;
	}

	track(minutes) {
		const my = this.getTimedAttribute('my', 0);
		this.setTimedAttribute('my', my + minutes);
	}

	untrack(minutes) {
		const my = this.getTimedAttribute('my', 0);
		this.setTimedAttribute('my', Math.max(0, my - minutes));
	}
}

App.components.schedule_hours_pie = {
	onBoot() {
		customElements.define("schedule-hours-pie", ScheduleHoursPie);
	}
};

;class ScheduleTimePicker extends RenderableComponent {

	static get observedAttributes() {
		return ["value", "max-time", "disabled"];
	}


	templateContext() {
		const filled = this.hasAttribute("value") && !App.helper.parseBoolean(this.attr('disabled', false));
		const {hours, minutes} = App.helper.parseTime(this.totalMinutes);
		return {
			value: this.attr("value", "00:00"),
			maxTime: this.attr("max-time", "09:45"),
			filled,
			text: `${filled ? this.hoursPadded(hours) : '-'} : ${filled ? this.minutesPadded(minutes) : '--'}`,
			plusClick: (e) => {
				this.pressBtn(e, 15);
			},
			minusClick: (e) => {
				this.pressBtn(e, -15);
			},
		}
	}

	pressBtn(e, step) {
		this.setTotalMinutes(this.totalMinutes + (e.shiftKey ? step * 4 : step));
		this.dispatchEvent(new CustomEvent('time-control-btn-clicked', {
			bubbles: true, composed: true, cancelable: false
		}));
	}

	template() {
		return `
			<self>
				<div ws-class="['schedule-time-picker__container', filled && 'schedule-time-picker__container--filled']">
					<ws-btn ws-on-click="minusClick"
							ws-long-press="minusClick"
							name="btn btn-24 btn-g btn-plain schedule-time-picker__button schedule-time-picker__button--no-hover"
							right-icon="input-circle-minus"></ws-btn>
					<ws-btn ws-on-click="minusClick"
							ws-long-press="minusClick"
							name="btn btn-24 btn-g btn-plain schedule-time-picker__button schedule-time-picker__button--hover"
							right-icon="input-circle-solid-minus"></ws-btn>

					<span class="schedule-time-picker__text" ws-text="text" data-ref="text"></span>
					<ws-btn ws-on-click="plusClick"
							ws-long-press="plusClick"
							name="btn btn-24 btn-g btn-plain schedule-time-picker__button schedule-time-picker__button--no-hover "
							right-icon="input-circle-plus"></ws-btn>
					<ws-btn ws-on-click="plusClick"
							ws-long-press="plusClick"
							name="btn btn-24 btn-g btn-plain schedule-time-picker__button schedule-time-picker__button--hover"
							right-icon="input-circle-solid-plus"></ws-btn>
				</div>
			</self>
		`;
	}

	static defineLifecycle() {
		return function ({on}) {
			on('mount:after', () => {
				$(this.text).timepicker({
					forceRoundTime: true,
					minTime: '00:00',
					maxTime: '08:00',
					minWorkTime: '00:00',
					maxWorkTime: '08:00',
					step: '15',
					timeFormat: 'H:i',
					orientation: 'c',
				});
				$(this.text).on('selectTime', (e, {time}) => {
					this.setTotalMinutes(App.helper.parseTimeToMinutes(time));
				});
			});
		}
	}


	get totalMinutes() {
		return App.helper.parseTimeToMinutes(this.attr("value", "00:00"));
	}

	get maxMinutes() {
		return App.helper.parseTimeToMinutes(this.attr("max-time", "09:45"));
	}

	get text() {
		return this.ref("text");
	}

	setTotalMinutes(v) {
		const newTotalMinutes = Math.max(0, v);
		const oldTotalMinutes = this.totalMinutes;

		const {hours: newHours, minutes: newMins} = App.helper.parseTime(newTotalMinutes);

		if (newTotalMinutes <= 0) {
			this.removeAttribute('value');
		} else {
			this.setAttribute(
				"value",
				`${newHours.toString().padStart(1, '0')}:${newMins.toString().padStart(2, '0')}`
			);
		}
		if (newTotalMinutes > oldTotalMinutes) {
			this.dispatchEvent(new CustomEvent('add-time', {
				detail: {addedMinutes: newTotalMinutes - oldTotalMinutes},
				bubbles: true, composed: true, cancelable: false
			}));
		} else if (newTotalMinutes < oldTotalMinutes) {
			this.dispatchEvent(new CustomEvent('remove-time', {
				detail: {removedMinutes: oldTotalMinutes - newTotalMinutes},
				bubbles: true, composed: true, cancelable: false
			}));
		}
		this.dispatchEvent(new CustomEvent('change', {
			detail: {newTotalMinutes, oldTotalMinutes},
			bubbles: true, composed: true, cancelable: false
		}));

	}

	disable() {
		this.setAttribute('disabled', 'true');
	}

	enable() {
		this.setAttribute('disabled', 'false');
	}

	hoursPadded(hours) {
		return hours.toString().padStart(1, '0');
	}

	minutesPadded(minutes) {
		return minutes.toString().padStart(2, '0');
	}

}

App.components.schedule_time_picker = {
	onBoot() {
		customElements.define("schedule-time-picker", ScheduleTimePicker);
	}
};
;class ScheduleWeekDivider extends RenderableComponent {

	static get observedAttributes() {
		return ["type", "text"];
	}

	templateContext() {
		return {
			type: this.attr("type", "base"),
			text: this.attr("text", ""),
		}
	}

	template() {
		return `
		<self ws-host-class="['schedule-week-divider', 'schedule-week-divider--' + type]">
				<div class="schedule-week-divider__line"></div>
				<div class="schedule-week-divider__text" ws-text="text"></div>
				<div class="schedule-week-divider__line"></div>
			</self>
		`;
	}

}

App.components.schedule_week_divider = {
	onBoot() { customElements.define("schedule-week-divider", ScheduleWeekDivider); }
};

;class TdTags extends RenderableComponent {

	static get observedAttributes() {
		return [
			'task-id'
		]
	}
	template() {
		return `<self class="display_contents">
					<slot></slot>
				</self>`;
	}
}

App.components.td_tags = {
	onBoot: function () {
		customElements.define('td-tags', TdTags);
		App.bus.state.on('task_tag',
			({id, data: {html}}) => {
				document.querySelectorAll('td-tags[task-id="'+id+'"]').forEach((el) => {
					el.setSlot(null, html);
				});
			})
	}
}
;class TdTask extends RenderableComponent {
	static get observedAttributes() {
		return [
			'task-id',
			'done',
			'use-filter'
		]
	}

	templateContext() {
		const state = this.attr('state', 'allowed');
		return {
			state: state,
			task_id: this.attr('task-id', null),
			done: App.helper.parseBoolean(this.attr('done', false)),
			use_filter: App.helper.parseBoolean(this.attr('use-filter', true)),
			applyToFilter: this.applyToFilter.bind(this),
			openTask: this.openTask.bind(this),
			is_allowed: state === 'allowed',
			is_disallowed: state === 'disallowed',
		}
	}

	provides() {
		return {
			applyToFilter: () => this.applyToFilter.bind(this),
			done: () => App.helper.parseBoolean(this.attr('done', false)),
		}
	}

	applyToFilter(e) {
		e.stopPropagation();
		App.page.filter_update({'task': this.attr('task-id')});
	}

	openTask(e) {
		const context = this.templateContext();
		if (context.is_disallowed || App.device.is_mobile() ) {
			return;
		}
		e.stopPropagation();
		App.task_view.show({url: App.helper.endpoint.task(this.attr('task-id'))});
	}

	template() {
		return `
			<self class="display_contents flex_row td_onclick" ws-host-on-click="openTask">
				{{ if (is_mobile) }}
				<ws-task-menu-grid ws-attr-task-id="task_id">
					{{ endif }}
					<div ws-class="['data', 'flex_content', 'flex_row', provided.done && 'done', provided.done && 'muted']" slot="anchor">
						<span class="space">
						{{ if (is_disallowed) }}
							<ws-icon name="block" data-title="{locale.task_access_denied}"></ws-icon>
						{{ endif }}
						{{ if (is_allowed) }}
							<slot name="stage"/>
						{{ endif }}
						</span>
						<div class="in flex_content flex_overflow text_overflow">
							<slot name="title"/>
						</div>
						<ws-btn name="btn btn-b btn-24 btn-fill" left-icon="filter"
								ws-on-click="provided.applyToFilter"></ws-btn>
					</div>
					{{ if (is_mobile) }}
				</ws-task-menu-grid>
				{{ endif }}
			</self>
		`
	}

}

App.components.td_task = {
	onBoot: function () {
		customElements.define('td-task', TdTask);
		App.bus.state.on('task_name', ({id, data: {name}}) => {
			document.querySelectorAll('td-task[task-id="' + id + '"]').forEach((el) => {
				el.setSlot('title', name);

			});
		})
	}
}
;class TdTaskName extends RenderableComponent {

	static get observedAttributes() {
		return [
			'state',
			'name',
			'done',
			'level',
			'show-visibility-icon',
			'hierarchy',
			'task-id',
		];
	}

	templateContext() {

		const state = this.attr('state', 'allowed');
		return {
			state: state,
			done: App.helper.parseBoolean(this.attr('done', false)),
			is_allowed: state === 'allowed',
			is_disallowed: state === 'disallowed',
			lvl: this.attr('level'),
			name: this.attr('name'),
			show_visibility_icon: App.helper.parseBoolean(this.attr('show-visibility-icon', true)),
			hierarchy: App.helper.parseBoolean(this.attr('hierarchy', false)),
		}
	}


	template() {
		// language=HTML
		return `
			<self class="display_contents">
				<slot name="before"></slot>
				<span ws-if="lvl" class="space space-level1"></span>
				<span ws-if="lvl" class="space space-level2"></span>
				<div class="name flex_content flex_overflow text_overflow" ws-text="name" data-role="value"></div>
				{{ if (is_disallowed && show_visibility_icon) }}
				<ws-icon name="block" data-title="{locale.task_access_denied}"></ws-icon>
				{{ endif }}
				{{ if (is_allowed) }}
				<slot name="icons"></slot>
				{{ endif }}
				<span class="flex_gap"></span>
				<slot name="actions"></slot>
				{{ if (hierarchy) }}
				<span class="space space-asTD space-expand" data-action="collapse">
					<ws-icon name="arrows/arrow_drop_sm-down"></ws-icon>
					<span class="child_num"></span>
				</span>
				{{ endif }}
			</self>
		`;
	}
}

App.components.td_task_name = {
	onBoot() {
		customElements.define("td-task-name", TdTaskName);
		App.bus.state.on('task_name', ({id, data: {name}}) => {
			document.querySelectorAll('td-task-name[task-id="' + id + '"]').forEach((el) => {
				el.setAttribute('name', name);
			});
		})
	}
}
;class FloatingWindow extends RenderableComponent {
	static TAG_NAME = 'floating-window';

	_initialHeightPx = null;

	_right = '20px';
	_width = '600px';
	_height = '';
	_borderRadius = '12px 12px 0 0';

	static get observedAttributes() {
		return ['fullscreen', 'active', 'fullscreenable', 'exit-confirm', 'should_show_exit_confirm'];
	}

	/** @returns {LifecycleLayer} */
	static defineLifecycle() {
		return function ({on})  {
			on('connected', () => {
				App.components.floating_window.window.opening();
			});
			on('mount:after', () => {
				App.components.floating_window.window.opened();
			})
			on('unmount:before', () => {
				App.components.floating_window.window.closing();
			})
			on('unmount:after', () => {
				App.components.floating_window.window.closed();
			})
		}
	}


	isFullscreen() {
		return App.helper.parseBoolean(this.attr('fullscreen', false)) && App.helper.parseBoolean(this.attr('fullscreenable', true));
	}

	setLayout(next) {
		if ('right' in next) this._right = next.right;
		if ('width' in next) this._width = next.width;
		if ('height' in next) this._height = next.height;
		if ('borderRadius' in next) this._borderRadius = next.borderRadius;

		this.invalidateLifecycle('floating_window:set_layout');
	}

	_setInitialHeight(pxStringOrNull) {
		this._initialHeightPx = pxStringOrNull;
		this.invalidateLifecycle('floating_window:set_initial_height');
	}

	_captureCurrentHeightIfNeeded() {
		if (this._initialHeightPx) return;
		this.invalidateLifecycle(`${this.height}px`);
	}

	templateContext() {
		return {
			fullscreenable: this.propBool('fullscreenable', true),
			fullscreen: this.isFullscreen(),
			initial_height: this._initialHeightPx,
			right: this._right,
			width: this._width,
			height: this._height,
			border_radius: this._borderRadius,
			active:this.propBool('active'),
			exit_confirm: this.propBool('exit-confirm'),
			should_show_exit_confirm: this.propBool('should_show_exit_confirm'),
			toggleFullscreen: ()  => this.toggleFullscreen(),
			exit: (confirmed) => this.exit(confirmed),
		};
	}

	get needExitConfirmation() {
		return true;
	}

	template() {
		// language=HTML
		return `
			<self class="floating-window flex_column"
				  ws-host-class="[fullscreen && 'floating-window--fullscreen', active && 'floating-window--active', exit_confirm && 'editBlock-initClose']"
				  ws-host-style="
					--fw-initial-height: initial_height;
					--fw-right: right;
					--fw-width: width;
					--fw-height: height;
					--fw-radius: border_radius
				  "
			>
				<div class="floating-window__head flex_row">
					<ws-btn name="btn btn-g btn-28 btn-plain"
							ws-if="fullscreenable"
							ws-attr-right-icon="(fullscreen && 'peek-full') || 'peek-compact'"
							ws-on-click="toggleFullscreen"
							ws-attr-data-title="(fullscreen && locale.collapse) || locale.expand">
					</ws-btn>
					<div class="flex_content flex_row floating-window__head-content">
						<slot name="head"></slot>
					</div>
					<ws-btn name="btn btn-g btn-28 btn-plain" right-icon="close" ws-on-click="exit()" class="close"
							data-title="{locale.close}"></ws-btn>
				</div>
				<div class="floating-window__body">
					<slot></slot>
				</div>
				<div class="floating-window__footer flex_row">
					<slot name="footer"></slot>
				</div>
				{{ if (exit_confirm) }}
				<div class="editBlock-backdrop" ws-if="should_show_exit_confirm" ws-on-click="exit(false)"></div>
				<div class="editBlock-close" ws-if="should_show_exit_confirm">
					<div class="editBlock-close-title">
						<div class="text">{locale.editblock_exit_alert.title}</div>
						<ws-btn name="btn btn-36 btn-g btn-fill" right-icon="close"
								ws-on-click="exit(false)"></ws-btn>
					</div>
					<div class="editBlock-close-text">{locale.editblock_exit_alert.text}</div>
					<div class="editBlock-close-buttons">
						<ws-btn name="btn btn-g btn-36 btn-solid btn-cancel" ws-on-click="exit(false)"
								text="{locale.editblock_exit_alert.button_stay}"></ws-btn>
						<ws-btn name="btn btn-g btn-36 btn-outline btn-ok" ws-on-click="exit(true)"
								text="{locale.editblock_exit_alert.button_exit}"></ws-btn>
					</div>
				</div>
				{{ endif }}
			</self>
		`;
	}


	active() {
		this.setAttribute('active', 'true');
	}

	unactive() {
		this.removeAttribute('active');
	}

	exit(confirmed) {
		if (this.propBool('exit-confirm', false) && this.needExitConfirmation) {
			if (confirmed === undefined) {
				this.setProp('should_show_exit_confirm', true);
			} else if (!confirmed) {
				this.setProp('should_show_exit_confirm', false);
			} else {
				this.setProp('should_show_exit_confirm', false);
				this.unactive();
			}
		} else {
			this.unactive();
		}
	}

	clear() {
		this.unactive();
		this.remove();
	}


	toggleFullscreen(forceOpen = null) {
		const floatingWindow = this;

		const canvasWidth = window.innerWidth;
		if (canvasWidth < 480) return;

		const shouldOpen = forceOpen === null ? !floatingWindow.isFullscreen() : forceOpen;

		if (shouldOpen) {
			floatingWindow._captureCurrentHeightIfNeeded();

			const body = document.body;
			const withSidebar = body.classList.contains('withSidebar');
			const withTaskPanel = body.classList.contains('withTaskPanel');

			let fullWidth = '100%';
			const fullHeight = withTaskPanel ? 'calc(100% - 40px)' : '100%';

			if (canvasWidth > 800 && withSidebar) fullWidth = 'calc(100% - 324px)';
			else if (canvasWidth > 700) fullWidth = 'calc(100% - 64px)';

			floatingWindow.setLayout({
				height: floatingWindow._initialHeightPx || '',
			});

			requestAnimationFrame(() => {
				floatingWindow.setLayout({
					right: '0px',
					width: fullWidth,
					height: fullHeight,
					borderRadius: '0px',
				});
			});

			setTimeout(() => floatingWindow.setAttribute('fullscreen', 'true'), 0);
		} else {
			const backHeight = floatingWindow._initialHeightPx || '';

			requestAnimationFrame(() => {
				floatingWindow.setLayout({
					right: '20px',
					width: '600px',
					height: backHeight,
					borderRadius: '12px 12px 0 0',
				});
			});

			setTimeout(() => floatingWindow.removeAttribute('fullscreen'), 0);
		}
	}

}


App.components.floating_window = {
	window: null,
	obj_wrapper: null,

	onBoot() {
		customElements.define(FloatingWindow.TAG_NAME, FloatingWindow);
		App.components.floating_window.window = App.window.floating_window.bind(App.components.floating_window)
		App.components.floating_window.obj_wrapper = $('#floatingWindow__wrapper');
	},
	append(window) {
		App.components.floating_window.obj_wrapper[0].append(window);
	}
};

;class MassTaskCreateFloatingWindow extends FloatingWindow {
	static TAG_NAME = 'mass-task-create-fw';
	/** @type {FormInstance} */
	form;

	static get observedAttributes() {
		return [...super.observedAttributes];
	}

	/** @returns {LifecycleLayer} */
	static defineLifecycle() {
		return function ({once}) {
			once('mount:before', () => {
				this._initForm();
				this._subscribeForm();
			});

			once('mount:after', () => {
				this._mountHandshakes();
				this.insertRow();
				App.helper.handle_multiline_paste.register(this, (rows) => this.fillRows(...rows), void (0));
			});
		};
	}

	_initForm() {
		const initial = this.propJson('initial', {});
		this.form = App.helper.useForm({
			initialValues: {
				project_id: initial.project_id,
				task_id: initial.task_id,
				tasks: initial.tasks || [],
				ids_subscribe: initial.ids_subscribe || [initial.me.id],
			},
			onSubmit: (values) => this._submitForm(values),
		});
	}

	_subscribeForm() {
		const initial = this.propJson('initial', {});

		this.form.subscribe(() => this.invalidateLifecycle('form:change'));

		this.form.subscribeField('project_id', () => {
			this.ref('subscribers-selector')?.onSelected({
				activeItems: this.ref('subscribers-selector')?.items.filter(item => item.id == App.me.id),
			});
			this.form.setValue('task_id', null);
			App.helper.nextTick(() => this.ref('task-selector')?.onDelete(), 1);
			this._massTasksApply({id_user_to: initial.me.id, user: initial.me});
		});
		this.form.subscribeField('task_id', () => {
			if (!this.form.getValue('task_id')) {
				return;
			}
			this.ref('subscribers-selector')?.onSelected({
				activeItems: this.ref('subscribers-selector')?.items.filter(item => item.id == App.me.id),
			});
			this._massTasksApply({id_user_to: initial.me.id, user: initial.me});
		})
	}

	_mountHandshakes() {
		this.onHandshake('task_selector_requirements', () => ({
			url: App.helper.endpoint.ajax(this.projectId),
		}));

		this.onHandshake('stage_selector_requirements', (e) => ({
			url: App.helper.url.add_query(
				App.helper.endpoint.ajax(this.projectOrInboxId),
				App.actions.get('project_task_stage_and_go:show'),
				{new_task: true}
			),
			userSelector: e.target.closest('subtaskForm')?.querySelector('user-selector'),
		}));

		this.onHandshake('user_selector_requirements', () => ({
			url: this.contextBasedUrl,
		}));

		this.onHandshake('subscribers_selector_requirements', () => ({
			url: this.contextBasedUrl,
			ids_project: this.projectId ? [this.projectId] : [],
			hidden: [],
		}));
	}

	_submitForm(values) {
		const projectId = this.projectOrInboxId;
		return $.ajax({
			url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('task_drafts:publish')),
			type: 'POST',
			dataType: 'script',
			data: {
				items: values.tasks.map(task => ({
					name: task.name,
					id_project: projectId,
					id_parent: values.task_id,
					important: task.priority,
					id_user_to: task.id_user_to,
					id_stage: task.id_stage,
					ids_subscribe: (values.ids_subscribe || []).filter(id => id > 0).join(','),
				})),
			},
			timeout: 10_000,
			success: () => this.exit(true),
		});
	}

	templateContext() {
		return {
			...super.templateContext(),
			...this.form.values,
			hasFilledTasks: this._tasks.some(t => t.name?.trim() !== ''),
			hasEmptyTask: this._tasks.some(t => !t.name?.trim()),
			allowAdditionalCustomize: this.customProjectSetted,
		};
	}

	provides() {
		return {
			form: () => this.form,
			controls: () => this._controls,
			tasks: () => ({...this._tasks}),
			hasEmptyTask: () => this._tasks.some(t => !t.name?.trim()),
			allowAdditionalCustomize: () => this.customProjectSetted,
		};
	}

	get _controls() {
		return {
			insertRow: () => this.insertRow(),
			focusInput: (index) => this.focusInput(index),
			removeRow: (index) => this.removeRow(index),
			handleKeydown: (event, i) => this.handleKeydown(event, i),
		};
	}

	get customProjectSetted() {
		return this.projectId && this.projectId != this.prop('inbox_id');
	}

	get _tasks() {
		return this.form.getValue('tasks');
	}

	get projectId() {
		return this.form.getValue('project_id');
	}

	get projectOrInboxId() {
		return this.projectId || this.prop('inbox_id');
	}

	get contextBasedUrl() {
		const taskId = this.form.getValue('task_id');
		return taskId
			? App.helper.url.add_query(App.helper.endpoint.task(taskId), App.actions.get('task_user_select_and_go:show'))
			: App.helper.url.add_query(App.helper.endpoint.project(this.projectOrInboxId), App.actions.get('user_select_and_go:show'));
	}

	get needExitConfirmation() {
		return this._tasks.some(t => t.name?.trim() !== '');
	}


	insertRow() {
		const tasks = this._tasks;
		const base = tasks.at(-1) ?? this.propJson('initial', {});
		tasks.push({
			id: (tasks.at(-1)?.id ?? -1) + 1,
			name: '',
			priority: base.priority ?? 0,
			id_stage: base.id_stage ?? null,
			id_user_to: base.id_user_to ?? null,
			stage: base.stage ?? {},
			user: base.user ?? {},
		});

		this.focusInput(tasks.length - 1);
		this.invalidateLifecycle('row:inserted');
	}

	removeRow(index) {
		const tasks = this._tasks;
		if (!tasks[index]) return;
		tasks.splice(index, 1);
		this.focusInput(index - 1);
		this.invalidateLifecycle('row:removed');
	}

	removeRows() {
		this.form.setValue('tasks', []);
	}

	focusInput(index) {
		App.helper.nextTick(() => {
			this.ref(`form-field-name-${index}`)?.focus();
		}, 100);
	}

	fillRows(...texts) {
		const tasks = this._tasks;
		texts.forEach((text) => {
			const emptyIndex = tasks.findIndex(t => !t.name?.trim());
			if (emptyIndex === -1) {
				this.insertRow();
				tasks.at(-1).name = text;
			} else {
				tasks[emptyIndex] = {...tasks[emptyIndex], name: text};
			}
		})
		this.invalidateLifecycle('rows:filled');
		this._ensureHasEmptyLine();
	}

	_ensureHasEmptyLine() {
		const emptyIndex = this._tasks.findIndex(t => !t.name?.trim());
		if (emptyIndex === -1) {
			this.insertRow();
		}
	}


	handleKeydown(event, rowIndex) {
		if (App.menu.is_shown()) return;

		const handlers = {
			[App.keycode.Enter]: () => this._handleEnter(event, rowIndex),
			[App.keycode.ArrowUp]: () => this.focusInput(rowIndex - 1),
			[App.keycode.ArrowDown]: () => this.focusInput(rowIndex + 1),
			[App.keycode.Backspace]: () => this._handleBackspace(event, rowIndex),
		};

		handlers[event.keyCode]?.();
	}

	_handleEnter(event, rowIndex) {
		if (rowIndex === this._tasks.length - 1) {
			this.insertRow();
		} else {
			this.focusInput(rowIndex + 1);
		}
	}

	_handleBackspace(event, rowIndex) {
		const tasks = this._tasks;
		const isEmpty = !tasks[rowIndex]?.name?.trim();
		if (isEmpty && tasks.length > 1) {
			event.preventDefault();
			this.removeRow(rowIndex);
		}
	}


	_massTasksApply(options) {
		this.form.setValue('tasks', this._tasks.map(item => ({...item, ...options})));
	}

	unactive() {
		super.unactive();
		App.helper.nextTick(() => this.remove(), 400);
	}
}

App.components.mass_task_create_floating_window = {
	onBoot() {
		customElements.define(MassTaskCreateFloatingWindow.TAG_NAME, MassTaskCreateFloatingWindow);
	},
};